import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  ArrayList3it5z8td81qkl as ArrayList,
  toList383f556t1dixk as toList,
  toMutableList20rdgwi7d3cwi as toMutableList,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  lazy2hsh8ze7j6ikd as lazy,
  toList3jhuyej2anx2q as toList_0,
  retainAll1hufpctl19y6u as retainAll,
  toSet2orjxp16sotqu as toSet,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  addAll1k27qatfgp3k5 as addAll,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toSet1glep2u1u9tcb as toSet_0,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToDouble210hrknaofnhf as numberToDouble,
  abs1kdzbjes1idip as abs,
  until1jbpn0z3f8lbg as until,
  listOfvhqybd2zx248 as listOf,
  get_sign1dnxi33u9vk0c as get_sign,
  isLetterOrDigit2kuxd9e198haf as isLetterOrDigit,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  isNaNymqb93xtq8w8 as isNaN_0,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  indexOfa2zokh3tu4p6 as indexOf,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Enum3alwj03lh1n41 as Enum,
  contains1tccixv8iwdcq as contains,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  replace3le3ie7l9k8aq as replace,
  plus20p0vtfmu0596 as plus,
  plus310ted5e4i90h as plus_0,
  createThis2j2avj17cvnv2 as createThis,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  countTrailingZeroBitszhs0313cn11e as countTrailingZeroBits,
  removeAll3o43e67jmwdpc as removeAll,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  invoke2sf88d1xeuyqh as invoke,
  Signal3nnez3346azzf as Signal,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  _RGBA___get_premultipliedFast__impl__qiau4g35hwdu9bo5950 as _RGBA___get_premultipliedFast__impl__qiau4g,
  get_lazyBitmap3pyj425xl7cp4 as get_lazyBitmap,
  RGBA__times_impl_wehs9n2bi9iz06j1oam as RGBA__times_impl_wehs9n,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  Font2bg7nte760csr as Font,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  MaterialColors_getInstance39ky4hjexuaug as MaterialColors_getInstance,
  RichTextData1m4oei1jdcuz5 as RichTextData,
  RGBA__withAf_impl_dpdu32g4ua5xko755s as RGBA__withAf_impl_dpdu32,
  _RGBA___get_ad__impl__pt5rdj2rhup0gteq97n as _RGBA___get_ad__impl__pt5rdj,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  getTextBoundsWithGlyphsa2ggkffutq4d as getTextBoundsWithGlyphs,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke_0,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  NativeImage33w1i7ec8zfym as NativeImage,
  drawRichTextyqpa5ren8u0j as drawRichText,
  placem8wpiy4fm4tw as place,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7_0,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  _FastDuration___get_fastSeconds__impl__amo4s31n2ucdhlz8ys6 as _FastDuration___get_fastSeconds__impl__amo4s3,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  get_slowaqovrrnrezzv as get_slow,
  get_fast37cu8s8qwnuyi as get_fast,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  toDuration15w5sljvx2ut2 as toDuration_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_7,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_8,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_9,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_10,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_11,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_12,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  If1av5krmfyt44s as If,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  TextClipboardDatafimoftc14pmm as TextClipboardData,
  Key_X_getInstance2ymba0j0rmblp as Key_X_getInstance,
  Key_BACKSPACE_getInstance1qsaehdyc2n7u as Key_BACKSPACE_getInstance,
  SoftKeyboardConfig3ue4h4egpkqhq as SoftKeyboardConfig,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_14,
  Cursor_TEXT_getInstancebh4jd1821ndb as Cursor_TEXT_getInstance,
  ISoftKeyboardConfige7b4czi6ukd7 as ISoftKeyboardConfig,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  _interpolateColor3ps0kri0tazz4 as _interpolateColor,
  Cursor_HAND_getInstance18p4ksi2yuad6 as Cursor_HAND_getInstance,
  Key_SPACE_getInstance3ccpin6uc1wp0 as Key_SPACE_getInstance,
  Companion_getInstance2y4l90zc9q53m as Companion_getInstance_15,
  Key_TAB_getInstancerm3v8lzruhq1 as Key_TAB_getInstance,
  _interpolated0idy8l9id9j as _interpolate,
  V2Callback2d6dtckx13wqz as V2Callback,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_16,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_17,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  VertexShader26kcg39ndf3s1 as VertexShader,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  drawfyi5eaogony1 as draw,
  Texture2obedkmljq67n as Texture_0,
  Shader39o79ur9unxav as Shader,
  Program1hnygp9hph4ry as Program,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  Companion_getInstance27aqys8b8jo0e as Companion_getInstance_18,
  AGTextureUnitInfoArray__get_impl_xhvpef1gqflly73w69y as AGTextureUnitInfoArray__get_impl_xhvpef,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_19,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_20,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus_1,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_21,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_22,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_23,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_24,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw_0,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_25,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_26,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_27,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_28,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_29,
  Companion_getInstance3lu3946d91kk8 as Companion_getInstance_30,
  Vector2F2yb91r49vy4m7 as Vector2F,
  timesatqrmkwmiu2z as times,
  Marginzmgz0t8x8vn as Margin,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstance3la8ioxhl91va as Companion_getInstance_31,
  RectCorners2yrtl8r42p5bs as RectCorners,
  Companion_getInstance2yu48324co92b as Companion_getInstance_32,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_33,
  Scale2cm697xlulcp5 as Scale,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_34,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_35,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_0,
  MarginInt3jiec8xsxkfd as MarginInt,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_36,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_1,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_37,
  convertRange1a6ancvyn151r as convertRange,
  clamp011ml7wx1d2b7sp as clamp01,
  toRatio1hooqit5gulhr as toRatio,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_38,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clamp31lhm66c28ic8 as clamp,
  clampdicp8njiht45 as clamp_0,
  clamp1qclpmpfxm7xb as clamp_1,
  toLongRound7crzegvo2qbo as toLongRound,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  toIntCeil3h286vm49zgwd as toIntCeil,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange_0,
  umod164hvijxhfi8p as umod,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_EASElq2v0gsk9fz7 as get_EASE,
  get_immutablepxpdoj6e54ll as get_immutable,
  Bezier1nrnsph9esuxa as Bezier,
  get_EASE_IN3dgilxucimnao as get_EASE_IN,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  RectSlicec5msorw5q4el as RectSlice,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_39,
  cancel1n0qjc93h2v6w as cancel_0,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Closeable2m9yv0b0gma2l as Closeable,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  get_length100spxmnpj7nb as get_length,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Property1m5vulkepgwzd as Property,
  Mixin3lmkm5hum2vdj as Mixin,
  getExtra307y0o9pd6mp3 as getExtra,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  Pool1zbsw0zhvh8ca as Pool,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  HistoryStack2mrikkhc0etuj as HistoryStack,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  IntArrayList3liuagbdnwmna as IntArrayList,
  getCyclicOrNull12fem85bj0m7u as getCyclicOrNull,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
import { atomic$int$11d5swdyn6j0pu as atomic$int$1 } from './kotlinx-atomicfu.mjs';
import {
  withoutRangetvtevgxw4fe7 as withoutRange,
  withoutIndex1982826lx7knb as withoutIndex,
  withInsertion32qy0wb7w2f46 as withInsertion,
} from './korlibs-string-root-korlibs-string.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.w9j_1 = Companion_getInstance_0().qw('Korge');
    this.x9j_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  y9j(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  vd(p1, $completion) {
    return this.y9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.k9i_1 = this$0;
    this.l9i_1 = $entry;
  }
  g1o($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_40();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_40().x9j_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().t8a_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().f88_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_41().h3p() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().f41_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().e41_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.m9i_1 = args;
    this.n9i_1 = imageFormats;
    this.o9i_1 = gameWindow;
    this.p9i_1 = mainSceneClass;
    this.q9i_1 = timeProvider;
    this.r9i_1 = injector;
    this.s9i_1 = configInjector;
    this.t9i_1 = debug;
    this.u9i_1 = trace;
    this.v9i_1 = context;
    this.w9i_1 = fullscreen;
    this.x9i_1 = blocking;
    this.y9i_1 = gameId;
    this.z9i_1 = settingsFolder;
    this.a9j_1 = batchMaxQuads;
    this.b9j_1 = windowSize;
    this.c9j_1 = virtualSize;
    this.d9j_1 = displayMode;
    this.e9j_1 = title;
    this.f9j_1 = backgroundColor;
    this.g9j_1 = quality;
    this.h9j_1 = icon;
    this.i9j_1 = multithreaded;
    this.j9j_1 = forceRenderEveryFrame;
    this.k9j_1 = windowCreationConfig;
    this.l9j_1 = main;
    this.m9j_1 = debugAg;
    this.n9j_1 = debugFontExtraScale;
    this.o9j_1 = debugFontColor;
    this.p9j_1 = stageBuilder;
    this.q9j_1 = targetFps;
    this.r9j_1 = preferSyncIo;
    this.s9j_1 = debugCoroutines;
    this.t9j_1 = unit;
  }
  t9m(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  u9m(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  u9j(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.m9i_1 : args;
    imageFormats = imageFormats === VOID ? this.n9i_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.o9i_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.p9i_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.q9i_1 : timeProvider;
    injector = injector === VOID ? this.r9i_1 : injector;
    configInjector = configInjector === VOID ? this.s9i_1 : configInjector;
    debug = debug === VOID ? this.t9i_1 : debug;
    trace = trace === VOID ? this.u9i_1 : trace;
    context = context === VOID ? this.v9i_1 : context;
    fullscreen = fullscreen === VOID ? this.w9i_1 : fullscreen;
    blocking = blocking === VOID ? this.x9i_1 : blocking;
    gameId = gameId === VOID ? this.y9i_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.z9i_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.a9j_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.b9j_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.c9j_1 : virtualSize;
    displayMode = displayMode === VOID ? this.d9j_1 : displayMode;
    title = title === VOID ? this.e9j_1 : title;
    backgroundColor = backgroundColor === VOID ? this.f9j_1 : backgroundColor;
    quality = quality === VOID ? this.g9j_1 : quality;
    icon = icon === VOID ? this.h9j_1 : icon;
    multithreaded = multithreaded === VOID ? this.i9j_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.j9j_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.k9j_1 : windowCreationConfig;
    main = main === VOID ? this.l9j_1 : main;
    debugAg = debugAg === VOID ? this.m9j_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.n9j_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.o9j_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.p9j_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.q9j_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.r9j_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.s9j_1 : debugCoroutines;
    unit = unit === VOID ? this.t9j_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.u9m(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.u9m;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.m9i_1);
    var tmp_0 = this.n9i_1.toString();
    var tmp_1 = toString_0(this.o9i_1);
    var tmp_2 = toString_0(this.p9i_1);
    var tmp_3 = toString(this.q9i_1);
    var tmp_4 = this.r9i_1.toString();
    var tmp_5 = toString(this.s9i_1);
    var tmp_6 = toString_0(this.v9i_1);
    var tmp_7 = this.b9j_1.toString();
    var tmp_8 = this.c9j_1.toString();
    var tmp_9 = this.d9j_1.toString();
    var tmp_10 = this.f9j_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.t9i_1 + ', trace=' + this.u9i_1 + ', context=' + tmp_6 + ', fullscreen=' + this.w9i_1 + ', blocking=' + this.x9i_1 + ', gameId=' + this.y9i_1 + ', settingsFolder=' + this.z9i_1 + ', batchMaxQuads=' + this.a9j_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.e9j_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.g9j_1) + ', icon=' + this.h9j_1 + ', multithreaded=' + this.i9j_1 + ', forceRenderEveryFrame=' + this.j9j_1 + ', windowCreationConfig=' + this.k9j_1.toString() + ', main=' + toString(this.l9j_1) + ', debugAg=' + this.m9j_1 + ', debugFontExtraScale=' + this.n9j_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.o9j_1) + ', stageBuilder=' + toString(this.p9j_1) + ', targetFps=' + this.q9j_1 + ', preferSyncIo=' + this.r9j_1 + ', debugCoroutines=' + this.s9j_1 + ', unit=' + this.t9j_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.m9i_1);
    result = imul(result, 31) + hashCode(this.n9i_1) | 0;
    result = imul(result, 31) + (this.o9i_1 == null ? 0 : hashCode(this.o9i_1)) | 0;
    result = imul(result, 31) + (this.p9i_1 == null ? 0 : this.p9i_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.q9i_1) | 0;
    result = imul(result, 31) + hashCode(this.r9i_1) | 0;
    result = imul(result, 31) + hashCode(this.s9i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t9i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u9i_1) | 0;
    result = imul(result, 31) + (this.v9i_1 == null ? 0 : hashCode(this.v9i_1)) | 0;
    result = imul(result, 31) + (this.w9i_1 == null ? 0 : getBooleanHashCode(this.w9i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x9i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y9i_1) | 0;
    result = imul(result, 31) + (this.z9i_1 == null ? 0 : getStringHashCode(this.z9i_1)) | 0;
    result = imul(result, 31) + this.a9j_1 | 0;
    result = imul(result, 31) + this.b9j_1.hashCode() | 0;
    result = imul(result, 31) + this.c9j_1.hashCode() | 0;
    result = imul(result, 31) + this.d9j_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.e9j_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.f9j_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.f9j_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.g9j_1.hashCode() | 0;
    result = imul(result, 31) + (this.h9j_1 == null ? 0 : getStringHashCode(this.h9j_1)) | 0;
    result = imul(result, 31) + (this.i9j_1 == null ? 0 : getBooleanHashCode(this.i9j_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j9j_1) | 0;
    result = imul(result, 31) + this.k9j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.l9j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n9j_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.o9j_1) | 0;
    result = imul(result, 31) + hashCode(this.p9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q9j_1) | 0;
    result = imul(result, 31) + (this.r9j_1 == null ? 0 : getBooleanHashCode(this.r9j_1)) | 0;
    result = imul(result, 31) + (this.s9j_1 == null ? 0 : getBooleanHashCode(this.s9j_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.m9i_1, tmp0_other_with_cast.m9i_1))
      return false;
    if (!equals(this.n9i_1, tmp0_other_with_cast.n9i_1))
      return false;
    if (!equals(this.o9i_1, tmp0_other_with_cast.o9i_1))
      return false;
    if (!equals(this.p9i_1, tmp0_other_with_cast.p9i_1))
      return false;
    if (!equals(this.q9i_1, tmp0_other_with_cast.q9i_1))
      return false;
    if (!equals(this.r9i_1, tmp0_other_with_cast.r9i_1))
      return false;
    if (!equals(this.s9i_1, tmp0_other_with_cast.s9i_1))
      return false;
    if (!(this.t9i_1 === tmp0_other_with_cast.t9i_1))
      return false;
    if (!(this.u9i_1 === tmp0_other_with_cast.u9i_1))
      return false;
    if (!equals(this.v9i_1, tmp0_other_with_cast.v9i_1))
      return false;
    if (!(this.w9i_1 == tmp0_other_with_cast.w9i_1))
      return false;
    if (!(this.x9i_1 === tmp0_other_with_cast.x9i_1))
      return false;
    if (!(this.y9i_1 === tmp0_other_with_cast.y9i_1))
      return false;
    if (!(this.z9i_1 == tmp0_other_with_cast.z9i_1))
      return false;
    if (!(this.a9j_1 === tmp0_other_with_cast.a9j_1))
      return false;
    if (!this.b9j_1.equals(tmp0_other_with_cast.b9j_1))
      return false;
    if (!this.c9j_1.equals(tmp0_other_with_cast.c9j_1))
      return false;
    if (!this.d9j_1.equals(tmp0_other_with_cast.d9j_1))
      return false;
    if (!(this.e9j_1 === tmp0_other_with_cast.e9j_1))
      return false;
    var tmp = this.f9j_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.f9j_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.g9j_1.equals(tmp0_other_with_cast.g9j_1))
      return false;
    if (!(this.h9j_1 == tmp0_other_with_cast.h9j_1))
      return false;
    if (!(this.i9j_1 == tmp0_other_with_cast.i9j_1))
      return false;
    if (!(this.j9j_1 === tmp0_other_with_cast.j9j_1))
      return false;
    if (!this.k9j_1.equals(tmp0_other_with_cast.k9j_1))
      return false;
    if (!equals(this.l9j_1, tmp0_other_with_cast.l9j_1))
      return false;
    if (!(this.m9j_1 === tmp0_other_with_cast.m9j_1))
      return false;
    if (!equals(this.n9j_1, tmp0_other_with_cast.n9j_1))
      return false;
    if (!(this.o9j_1 === tmp0_other_with_cast.o9j_1))
      return false;
    if (!equals(this.p9j_1, tmp0_other_with_cast.p9j_1))
      return false;
    if (!equals(this.q9j_1, tmp0_other_with_cast.q9j_1))
      return false;
    if (!(this.r9j_1 == tmp0_other_with_cast.r9j_1))
      return false;
    if (!(this.s9j_1 == tmp0_other_with_cast.s9j_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.p9m_1 = new KorgeDisplayMode(Companion_getInstance_26().i2g_1, Companion_getInstance_27().z24(), true);
    this.q9m_1 = new KorgeDisplayMode(Companion_getInstance_26().i2g_1, Companion_getInstance_27().z24(), false);
    this.r9m_1 = new KorgeDisplayMode(Companion_getInstance_26().i2g_1, Companion_getInstance_27().n24_1, false);
    this.s9m_1 = new KorgeDisplayMode(Companion_getInstance_26().k2g_1, Companion_getInstance_27().n24_1, false);
  }
  h3p() {
    return this.p9m_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_41();
    this.v9m_1 = scaleMode;
    this.w9m_1 = scaleAnchor;
    this.x9m_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.v9m_1.toString() + ', scaleAnchor=' + this.w9m_1.toString() + ', clipBorders=' + this.x9m_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.v9m_1);
    result = imul(result, 31) + this.w9m_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x9m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.v9m_1, tmp0_other_with_cast.v9m_1))
      return false;
    if (!this.w9m_1.equals(tmp0_other_with_cast.w9m_1))
      return false;
    if (!(this.x9m_1 === tmp0_other_with_cast.x9m_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.m9p_1 = $config;
    this.n9p_1 = $views;
    this.o9p_1 = $entry;
    this.p9p_1 = $gameWindow;
  }
  g1o($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.s9u_1 = $config;
    this.t9u_1 = $views;
    this.u9u_1 = $entry;
    this.v9u_1 = $gameWindow;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.w9u_1 = $realGameWindow;
    this.x9u_1 = $windowSize;
    this.y9u_1 = $config;
    this.z9u_1 = $iconPath;
    this.a9v_1 = $imageFormats;
    this.b9v_1 = $entry;
  }
  j9v($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  vd(p1, $completion) {
    return this.j9v(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.k9v_1 = $views;
  }
  ud($completion) {
    this.k9v_1.f6();
  }
}
class KorgeRunner {
  v9j(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  f9v(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.f9n_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.a67(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.e9n_1;
    injector.a67(getKClass(AG), instance);
    injector.a67(getKClass(Resources), views.m9v());
    var tmp = getKClass(ResourcesRoot);
    injector.d67(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.g9n_1;
    injector.a67(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.i9n_1;
    injector.a67(getKClass(Stats), instance_1);
    injector.a67(getKClass(CoroutineContext), views.d9n_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.e67(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.a67(getKClass(TimeProvider), views.h9n_1);
    configInjector(injector);
    var input = views.g9n_1;
    var ag = views.e9n_1;
    var downPos = {_v: Companion_getInstance_29().o25_1};
    var upPos = {_v: Companion_getInstance_29().o25_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().t1u_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().t1u_1)};
    var upTime = Companion_getInstance_5().t1u_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.n9v(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().a6c_1.slice();
    eventDispatcher.h6a(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().k6b_1.slice();
    eventDispatcher.h6a(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().b6d_1.slice();
    eventDispatcher.h6a(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().i6d_1.slice();
    eventDispatcher.h6a(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.v69(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.v69(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.v69(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.v69(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().d6e_1.slice();
    eventDispatcher.h6a(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().i6g_1.slice();
    eventDispatcher.h6a(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.v69(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.v69(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.g6a(new ReshapeEvent(0, 0, views.o9v(), views.p9v()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.v69(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.d9o_1 = clearEachFrame;
    views.e9o_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.j9n_1.r8m(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  y9j(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  vd(p1, $completion) {
    return this.y9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  y9j(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  vd(p1, $completion) {
    return this.y9j(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp.z9v_1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    this.a9w_1 = 128.0;
    this.b9w_1 = get_EASE(Companion_getInstance_37());
    this.c9w_1 = true;
  }
}
class RootAnimationNode {
  constructor($outer) {
    this.x9w_1 = $outer;
    this.v9w_1 = null;
    this.w9w_1 = fastArrayListOf([]);
  }
  t2q() {
    this.v9w_1 = null;
  }
  y9w(dt) {
    var dt_0 = !(this.x9w_1.p9w_1 === 1.0) ? FastDuration__times_impl_h6amcp(dt, this.x9w_1.p9w_1) : dt;
    ensureInit(this.x9w_1);
    if (this.x9w_1.h9w_1) {
      var completedTime = get_fastSeconds(0);
      this.w9w_1.l3();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = this.x9w_1.o9w_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.animate.RootAnimationNode.update.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var index_0 = checkIndexOverflow(tmp1);
        var result = item.y9w(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7(result, get_fastSeconds(0)) >= 0) {
          this.w9w_1.h(item);
        }
        var tmp;
        if (index_0 === 0) {
          tmp = result;
        } else {
          // Inline function 'kotlin.math.min' call
          var a = _FastDuration___get_fastMilliseconds__impl__pe68va(completedTime);
          var b = _FastDuration___get_fastMilliseconds__impl__pe68va(result);
          var tmp$ret$0 = Math.min(a, b);
          tmp = get_fastMilliseconds(tmp$ret$0);
        }
        completedTime = tmp;
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.w9w_1.g1()) {
        this.x9w_1.o9w_1.j2m(this.w9w_1);
      }
      this.w9w_1.l3();
      this.x9w_1.s9w_1 = true;
      return completedTime;
    }
    $l$loop: while (true) {
      if (this.v9w_1 == null) {
        var tmp_0 = this;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.x9w_1.o9w_1.g1()) {
          tmp_1 = this.x9w_1.o9w_1.qk();
        } else {
          tmp_1 = null;
        }
        tmp_0.v9w_1 = tmp_1;
        var tmp0_safe_receiver = this.v9w_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.t2q();
        }
        if (this.x9w_1.i9w_1) {
          var tmp1_safe_receiver = this.v9w_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this.x9w_1.o9w_1.y2l(tmp1_safe_receiver);
          }
        }
      }
      if (!(this.v9w_1 == null)) {
        var node = ensureNotNull(this.v9w_1);
        var extraTime = node.y9w(dt_0);
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().lj_1) >= 0) {
          this.v9w_1 = null;
          dt_0 = extraTime;
        }
        if (FastDuration__compareTo_impl_4fhnj7_0(extraTime, Companion_getInstance().lj_1) > 0) {
          continue $l$loop;
        }
      }
      var tmp_2;
      var tmp_3;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.x9w_1.o9w_1.g1()) {
        tmp_3 = true;
      } else {
        tmp_3 = !(this.v9w_1 == null);
      }
      if (tmp_3) {
        tmp_2 = get_fastSeconds(-1);
      } else {
        tmp_2 = Companion_instance_1.c1v();
      }
      return tmp_2;
    }
  }
  toString() {
    return 'RootAnimationNode(' + toString(this.x9w_1) + ')';
  }
}
class TweenNode {
  constructor(vs, lazyVs, time, lazyTime, easing, name) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? get_fastMilliseconds_0(1000) : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    name = name === VOID ? null : name;
    this.q9v_1 = vs;
    this.r9v_1 = lazyVs;
    this.s9v_1 = time;
    this.t9v_1 = lazyTime;
    this.u9v_1 = easing;
    this.v9v_1 = name;
    var tmp = this;
    tmp.w9v_1 = lazy(Animator$TweenNode$computedVs$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.x9v_1 = lazy(Animator$TweenNode$totalTime$delegate$lambda(this));
    this.y9v_1 = Companion_instance_1.c1v();
  }
  z9w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w9v_1;
    computedVs$factory();
    return this_0.u1();
  }
  toString() {
    return 'TweenNode(totalTime=' + FastDuration__toString_impl_c9xohb(_get_totalTime__xgts5c(this)) + ', name=' + this.v9v_1 + ', ' + toString(toList_0(this.z9w())) + ')';
  }
  t2q() {
    this.y9v_1 = Companion_instance_1.c1v();
  }
  y9w(dt) {
    if (equals(this.y9v_1, Companion_instance_1.c1v())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.z9w();
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).z35();
      }
    }
    this.y9v_1 = FastDuration__plus_impl_q1enab(this.y9v_1, dt);
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.z9w();
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.animate.TweenNode.update.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_1.d1(_unary__edvuaz_0);
      var ratio = equals(_get_totalTime__xgts5c(this), Companion_instance_1.c1v()) ? 1.0 : convertRange(_FastDuration___get_fastSeconds__impl__amo4s3(this.y9v_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.a8i_1), _FastDuration___get_fastSeconds__impl__amo4s3(it.g8i(_get_totalTime__xgts5c(this))), 0.0, 1.0);
      if (ratio >= 0.0) {
        it.h8i(toRatio(this.u9v_1.ix(clamp01(ratio))));
      }
    }
    return FastDuration__minus_impl_evs237(this.y9v_1, _get_totalTime__xgts5c(this));
  }
}
class BlockNode {
  constructor(name, callback) {
    name = name === VOID ? null : name;
    this.a9x_1 = name;
    this.b9x_1 = callback;
    this.c9x_1 = false;
  }
  toString() {
    return 'BlockNode(name=' + this.a9x_1 + ')';
  }
  t2q() {
    this.c9x_1 = false;
  }
  y9w(dt) {
    this.d9x();
    return dt;
  }
  d9x() {
    if (this.c9x_1)
      return Unit_instance;
    this.c9x_1 = true;
    this.b9x_1();
  }
}
class Animator {
  constructor(root, fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, parent, lazyInit, level, startImmediately) {
    Companion_getInstance_42();
    parallel = parallel === VOID ? false : parallel;
    looped = looped === VOID ? false : looped;
    lazyInit = lazyInit === VOID ? null : lazyInit;
    this.d9w_1 = root;
    this.e9w_1 = fastDefaultTime;
    this.f9w_1 = defaultSpeed;
    this.g9w_1 = defaultEasing;
    this.h9w_1 = parallel;
    this.i9w_1 = looped;
    this.j9w_1 = parent;
    this.k9w_1 = lazyInit;
    this.l9w_1 = level;
    this.m9w_1 = startImmediately;
    this.n9w_1 = new Signal();
    this.o9w_1 = TGenDeque.x2l();
    this.p9w_1 = 1.0;
    this.q9w_1 = null;
    this.r9w_1 = false;
    this.s9w_1 = false;
    this.t9w_1 = new RootAnimationNode(this);
  }
  g9x() {
    return get_slow(this.e9w_1);
  }
  u9w() {
    var tmp0_safe_receiver = this.j9w_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u9w();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  h9x(props) {
    var _iterator__ex2g4s = this.o9w_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var node = _iterator__ex2g4s.c1();
      if (node instanceof TweenNode) {
        var tmp = node.z9w();
        retainAll(tmp, Animator$removeProps$lambda(props));
      }
    }
  }
  i9x(node) {
    this.o9w_1.g2m(node);
    ensure(this);
  }
  f6() {
    this.f9x();
  }
  as(e) {
    this.f9x();
  }
  f9x() {
    this.t9w_1.t2q();
    this.o9w_1.l3();
    var tmp0_safe_receiver = this.u9w().q9w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel_0(tmp0_safe_receiver);
    }
    this.u9w().q9w_1 = null;
    this.s9w_1 = false;
    invoke(this.n9w_1);
    return this;
  }
  j9x(vs, lazyVs, time, lazyTime, easing, name, replace) {
    if (replace && this.h9w_1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(vs.length);
      var inductionVariable = 0;
      var last = vs.length;
      while (inductionVariable < last) {
        var item = vs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.Animator.__tween.<anonymous>' call
        var tmp$ret$0 = item.v8h_1;
        destination.h(tmp$ret$0);
      }
      this.h9x(toSet(destination));
    }
    this.i9x(new TweenNode(vs.slice(), lazyVs, time, lazyTime, easing, name));
  }
  k9x(vs, lazyVs, time, lazyTime, easing, name, replace, $super) {
    lazyVs = lazyVs === VOID ? null : lazyVs;
    time = time === VOID ? this.e9w_1 : time;
    lazyTime = lazyTime === VOID ? null : lazyTime;
    easing = easing === VOID ? this.g9w_1 : easing;
    replace = replace === VOID ? true : replace;
    var tmp;
    if ($super === VOID) {
      this.j9x(vs, lazyVs, time, lazyTime, easing, name, replace);
      tmp = Unit_instance;
    } else {
      tmp = $super.j9x.call(this, vs, lazyVs, new FastDuration(time), lazyTime, easing, name, replace);
    }
    return tmp;
  }
}
class ViewStageComponent {
  constructor(view) {
    this.l9x_1 = view;
    this.m9x_1 = new Signal();
    this.n9x_1 = new Signal();
  }
}
class KeysEvents$down$slambda {
  constructor($keys, $callback) {
    this.p9x_1 = $keys;
    this.q9x_1 = $callback;
  }
  h9y(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$down$slambda_0 {
  constructor($callback) {
    this.r9x_1 = $callback;
  }
  h9y(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$up$slambda {
  constructor($keys, $callback) {
    this.s9x_1 = $keys;
    this.t9x_1 = $callback;
  }
  h9y(e, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, e), $completion);
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$typed$slambda {
  constructor($callback) {
    this.u9x_1 = $callback;
  }
  h9y(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.b9y_1 = this$0;
    this.c9y_1 = $event;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.d9y_1 = this$0;
    this.e9y_1 = $event;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.f9y_1 = this$0;
    this.g9y_1 = $event;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.v9x_1 = view;
    this.x9x_1 = new AsyncSignal();
    this.y9x_1 = new AsyncSignal();
    this.z9x_1 = new AsyncSignal();
    this.a9y_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.v9x_1.v69(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.v9x_1.v69(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.v9x_1.v69(tmp_1, KeysEvents$lambda_1(this));
  }
  i9y() {
    var tmp = this.w9x_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  j9y(keys, callback) {
    return this.x9x_1.t1w(KeysEvents$down$slambda_1(keys, callback));
  }
  k9y(callback) {
    return this.x9x_1.t1w(KeysEvents$down$slambda_2(callback));
  }
  l9y(keys, callback) {
    return this.j9y(toSet_0(keys), callback);
  }
  m9y(keys, callback) {
    return this.y9x_1.t1w(KeysEvents$up$slambda_0(keys, callback));
  }
  n9y(keys, callback) {
    return this.m9y(toSet_0(keys), callback);
  }
  o9y(callback) {
    return this.z9x_1.t1w(KeysEvents$typed$slambda_0(callback));
  }
  f6() {
    this.a9y_1.f6();
  }
}
class Companion_2 {
  la0(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.a35_1) {
      this_0.a35_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.v9o_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.oa0_1 = $outer;
    this.ma0_1 = new Mixin();
    this.na0_1 = view;
    addUpdaterWithViews(this.na0_1, MouseEvents$MouseEventsUpdate$lambda(this.oa0_1));
  }
  ay(value) {
    this.ma0_1.ay(value);
  }
  by() {
    return this.ma0_1.by();
  }
}
class MouseEvents {
  constructor(view) {
    this.v9y_1 = new Mixin();
    this.w9y_1 = view;
    this.w9y_1.sa0(true);
    this.y9y_1 = new Signal();
    this.z9y_1 = new Signal();
    this.a9z_1 = new Signal();
    this.b9z_1 = new Signal();
    this.c9z_1 = new Signal();
    this.d9z_1 = new Signal();
    this.e9z_1 = new Signal();
    this.f9z_1 = new Signal();
    this.g9z_1 = new Signal();
    this.h9z_1 = new Signal();
    this.i9z_1 = new Signal();
    this.j9z_1 = new Signal();
    this.k9z_1 = new Signal();
    this.l9z_1 = new Signal();
    this.m9z_1 = new Signal();
    this.n9z_1 = new Signal();
    this.o9z_1 = new Signal();
    this.p9z_1 = new Signal();
    this.q9z_1 = new Signal();
    this.r9z_1 = null;
    this.s9z_1 = false;
    this.t9z_1 = false;
    this.u9z_1 = false;
    this.v9z_1 = PerformanceCounter_getInstance().v67();
    this.w9z_1 = PerformanceCounter_getInstance().v67();
    this.x9z_1 = Vector2D.h28();
    this.y9z_1 = Vector2D.h28();
    this.z9z_1 = Vector2D.h28();
    this.aa0_1 = Vector2D.h28();
    this.ba0_1 = Vector2D.h28();
    this.ca0_1 = 0;
    this.da0_1 = false;
    this.ea0_1 = null;
    this.fa0_1 = new MouseEvent();
    this.ga0_1 = false;
    this.ha0_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().a6c_1.slice();
    tmp.ia0_1 = this.w9y_1.h6a(tmp_0, MouseEvents$closeable$lambda(this));
    this.ja0_1 = new MouseEventsUpdate(this, this.w9y_1);
  }
  qa0() {
    var tmp = this.x9y_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ta0() {
    return this.qa0().d9n_1;
  }
  ua0() {
    return this.w9y_1.va0(this.ba0_1);
  }
  wa0() {
    return this.w9y_1.va0(this.x9z_1);
  }
  xa0() {
    var tmp0_safe_receiver = this.ea0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s6a();
    }
  }
  ra0() {
    var tmp0_safe_receiver = this.r9z_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.w9y_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  ya0() {
    return !(this.qa0().g9n_1.f87_1 === 0);
  }
  toString() {
    return this.fa0_1.toString();
  }
  ka0(views, dt) {
    if (!this.w9y_1.pa0())
      return Unit_instance;
    this.x9y_1 = views;
    Companion_instance_17.la0(views);
    this.r9z_1 = mouseHitTest(Companion_instance_17, views);
    var over = this.ra0();
    var inside = views.g9n_1.h87_1;
    if (over) {
      set_mouseHitResultUsed(views.g9n_1, this.w9y_1);
    }
    var overChanged = !(this.s9z_1 === over);
    var insideChanged = !(this.t9z_1 === inside);
    var pressingChanged = !(this.ya0() === this.u9z_1);
    this.ba0_1 = views.g9n_1.v87();
    if (!overChanged && over && !this.ba0_1.equals(this.aa0_1)) {
      this.k9z_1.i1w(this);
    }
    if (!overChanged && !over && !this.ba0_1.equals(this.aa0_1)) {
      this.m9z_1.i1w(this);
    }
    if (!this.ba0_1.equals(this.aa0_1)) {
      this.l9z_1.i1w(this);
    }
    if (overChanged && over) {
      this.a9z_1.i1w(this);
    }
    if (overChanged && !over) {
      this.b9z_1.i1w(this);
    }
    if (pressingChanged && this.ya0()) {
      this.z9z_1 = this.ba0_1;
      if (over) {
        this.c9z_1.i1w(this);
      }
      if (!over) {
        this.d9z_1.i1w(this);
      }
    }
    if (overChanged && this.ya0()) {
      this.e9z_1.i1w(this);
    }
    if (pressingChanged && !this.ya0()) {
      var tmp = this.ha0_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.ca0_1 > 0;
    if (insideChanged && !inside) {
      this.m9z_1.i1w(this);
      this.b9z_1.i1w(this);
      this.h9z_1.i1w(this);
      this.i9z_1.i1w(this);
      this.n9z_1.i1w(this);
    }
    this.s9z_1 = over;
    this.t9z_1 = inside;
    this.u9z_1 = this.ya0();
    this.aa0_1 = this.ba0_1;
    this.ca0_1 = 0;
  }
  f6() {
    this.ia0_1.f6();
  }
  ay(value) {
    this.v9y_1.ay(value);
  }
  by() {
    return this.v9y_1.by();
  }
}
class Info {
  constructor(index, id, local, startLocal, startTime, global, startGlobal, time) {
    index = index === VOID ? -1 : index;
    id = id === VOID ? 0 : id;
    local = local === VOID ? Vector2D.h28() : local;
    startLocal = startLocal === VOID ? Vector2D.h28() : startLocal;
    startTime = startTime === VOID ? Companion_getInstance_5().t1u_1 : startTime;
    global = global === VOID ? Vector2D.h28() : global;
    startGlobal = startGlobal === VOID ? Vector2D.h28() : startGlobal;
    time = time === VOID ? Companion_getInstance_5().t1u_1 : time;
    this.za0_1 = new Mixin();
    this.aa1_1 = index;
    this.ba1_1 = id;
    this.ca1_1 = local;
    this.da1_1 = startLocal;
    this.ea1_1 = startTime;
    this.fa1_1 = global;
    this.ga1_1 = startGlobal;
    this.ha1_1 = time;
  }
  ja1() {
    return DateTime__minus_impl_10njw8(this.ha1_1, this.ea1_1);
  }
  qa0() {
    var tmp = this.ia1_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ka1() {
    return this.ca1_1.m25_1;
  }
  la1() {
    return this.ca1_1.n25_1;
  }
  toString() {
    return 'Touch[' + this.ba1_1 + '](' + numberToInt(this.ka1()) + ', ' + numberToInt(this.la1()) + ')';
  }
  hashCode() {
    var result = this.aa1_1;
    result = imul(result, 31) + this.ba1_1 | 0;
    result = imul(result, 31) + this.ca1_1.hashCode() | 0;
    result = imul(result, 31) + this.da1_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.ea1_1) | 0;
    result = imul(result, 31) + this.fa1_1.hashCode() | 0;
    result = imul(result, 31) + this.ga1_1.hashCode() | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.ha1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    if (!(this.aa1_1 === tmp0_other_with_cast.aa1_1))
      return false;
    if (!(this.ba1_1 === tmp0_other_with_cast.ba1_1))
      return false;
    if (!this.ca1_1.equals(tmp0_other_with_cast.ca1_1))
      return false;
    if (!this.da1_1.equals(tmp0_other_with_cast.da1_1))
      return false;
    if (!equals(this.ea1_1, tmp0_other_with_cast.ea1_1))
      return false;
    if (!this.fa1_1.equals(tmp0_other_with_cast.fa1_1))
      return false;
    if (!this.ga1_1.equals(tmp0_other_with_cast.ga1_1))
      return false;
    if (!equals(this.ha1_1, tmp0_other_with_cast.ha1_1))
      return false;
    return true;
  }
  ay(value) {
    this.za0_1.ay(value);
  }
  by() {
    return this.za0_1.by();
  }
}
class TouchEvents {
  constructor(view) {
    this.ma1_1 = view;
    this.na1_1 = new Signal();
    this.oa1_1 = new Signal();
    this.pa1_1 = new Signal();
    this.qa1_1 = new Signal();
    this.ra1_1 = new Signal();
    this.sa1_1 = new Signal();
    this.ta1_1 = new Signal();
    var tmp = this;
    tmp.ua1_1 = Pool.a2q(VOID, TouchEvents$infoPool$lambda);
    this.va1_1 = FastIntMap();
    this.wa1_1 = FastArrayList.sy();
    var tmp_0 = Companion_getInstance_11().d6e_1.slice();
    this.ma1_1.h6a(tmp_0, TouchEvents$lambda(this));
  }
  xa1(_this__u8e3s4, touch) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.copyFrom.<anonymous>' call
    _this__u8e3s4.ba1_1 = touch.u6d_1;
    _this__u8e3s4.fa1_1 = touch.v6d_1;
    _this__u8e3s4.ca1_1 = this.ma1_1.va0(touch.v6d_1);
    return _this__u8e3s4;
  }
  ya1(_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.TouchEvents.start.<anonymous>' call
    _this__u8e3s4.da1_1 = _this__u8e3s4.ca1_1;
    _this__u8e3s4.ga1_1 = _this__u8e3s4.fa1_1;
    return _this__u8e3s4;
  }
  za1(views, globalXY) {
    var ev = new TouchEvent(Type_START_getInstance());
    ev.t6e(Type_START_getInstance());
    ev.y6e(0, globalXY, Status_ADD_getInstance());
    ev.u6e();
    onTouchEvent(this, views, ev);
    ev.t6e(Type_END_getInstance());
    ev.y6e(0, globalXY, Status_REMOVE_getInstance());
    ev.u6e();
    onTouchEvent(this, views, ev);
    get_mouse(this.ma1_1).z9y_1.i1w(get_mouse(this.ma1_1));
  }
}
class SingleTouchHandler {
  constructor() {
    this.aa2_1 = new Signal();
    this.ba2_1 = new Signal();
    this.ca2_1 = new Signal();
    this.da2_1 = new Signal();
    this.ea2_1 = new Signal();
    this.fa2_1 = new Signal();
    this.ga2_1 = new Signal();
    this.ha2_1 = new Signal();
  }
}
class singleTouch$SingleTouchInfo {
  constructor(handler, startedInside) {
    handler = handler === VOID ? new SingleTouchHandler() : handler;
    startedInside = startedInside === VOID ? false : startedInside;
    this.ia2_1 = handler;
    this.ja2_1 = startedInside;
  }
  toString() {
    return 'SingleTouchInfo(handler=' + toString(this.ia2_1) + ', startedInside=' + this.ja2_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.ia2_1);
    result = imul(result, 31) + getBooleanHashCode(this.ja2_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof singleTouch$SingleTouchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof singleTouch$SingleTouchInfo ? other : THROW_CCE();
    if (!equals(this.ia2_1, tmp0_other_with_cast.ia2_1))
      return false;
    if (!(this.ja2_1 === tmp0_other_with_cast.ja2_1))
      return false;
    return true;
  }
}
class MaterialBlockUB extends UniformBlock {
  constructor() {
    MaterialBlockUB_instance = null;
    super(3);
    MaterialBlockUB_instance = this;
    this.pa2_1 = this.l6y().z6x(this, u_ShadowColor$factory());
    this.qa2_1 = this.h6y().z6x(this, u_ShadowRadius$factory());
    this.ra2_1 = this.j6y().z6x(this, u_ShadowOffset$factory());
    this.sa2_1 = this.j6y().z6x(this, u_HighlightPos$factory());
    this.ta2_1 = this.h6y().z6x(this, u_HighlightRadius$factory());
    this.ua2_1 = this.l6y().z6x(this, u_HighlightColor$factory());
    this.va2_1 = this.j6y().z6x(this, u_Size$factory());
    this.wa2_1 = this.l6y().z6x(this, u_Radius$factory());
    this.xa2_1 = this.h6y().z6x(this, u_BorderSizeHalf$factory());
    this.ya2_1 = this.l6y().z6x(this, u_BorderColor$factory());
    this.za2_1 = this.l6y().z6x(this, u_BackgroundColor$factory());
  }
  ia3() {
    return this.pa2_1.no(this, u_ShadowColor$factory_0());
  }
  ka3() {
    return this.qa2_1.no(this, u_ShadowRadius$factory_0());
  }
  ja3() {
    return this.ra2_1.no(this, u_ShadowOffset$factory_0());
  }
  da3() {
    return this.sa2_1.no(this, u_HighlightPos$factory_0());
  }
  ea3() {
    return this.ta2_1.no(this, u_HighlightRadius$factory_0());
  }
  fa3() {
    return this.ua2_1.no(this, u_HighlightColor$factory_0());
  }
  ba3() {
    return this.va2_1.no(this, u_Size$factory_0());
  }
  aa3() {
    return this.wa2_1.no(this, u_Radius$factory_0());
  }
  ga3() {
    return this.xa2_1.no(this, u_BorderSizeHalf$factory_0());
  }
  ha3() {
    return this.ya2_1.no(this, u_BorderColor$factory_0());
  }
  ca3() {
    return this.za2_1.no(this, u_BackgroundColor$factory_0());
  }
}
class MaterialRender {
  constructor() {
    MaterialRender_instance = this;
    this.la3_1 = MaterialBlockUB_getInstance().ia3();
    this.ma3_1 = MaterialBlockUB_getInstance().ka3();
    this.na3_1 = MaterialBlockUB_getInstance().ja3();
    this.oa3_1 = MaterialBlockUB_getInstance().da3();
    this.pa3_1 = MaterialBlockUB_getInstance().ea3();
    this.qa3_1 = MaterialBlockUB_getInstance().fa3();
    this.ra3_1 = MaterialBlockUB_getInstance().ba3();
    this.sa3_1 = MaterialBlockUB_getInstance().aa3();
    this.ta3_1 = MaterialBlockUB_getInstance().ga3();
    this.ua3_1 = MaterialBlockUB_getInstance().ha3();
    this.va3_1 = MaterialBlockUB_getInstance().ca3();
    var tmp = this;
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var tmp1_$this = Companion_getInstance_6().a8b_1;
    var tmp2_name = null == null ? Companion_getInstance_6().a8b_1.z6q_1 : null;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>' call
    var size = MaterialRender_getInstance().ra3_1;
    var roundedDist = this_0.q71(this_0.t71(SDFShaders_getInstance().a8h(), this_0.q72(this_0.j70(), this_0.u72(size, 2.0)), this_0.u72(size, 2.0), MaterialRender_getInstance().sa3_1));
    this_0.n70(this_0.q70(), this_0.r70(MaterialRender_getInstance().va3_1, this_0.r71(SDFShaders_getInstance().u8g(), roundedDist)));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_0.a73(MaterialRender_getInstance().pa3_1, 0.0);
    var body = this_0.e71();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var highlightDist = body.s71(SDFShaders_getInstance().p8g(), roundedDist, body.s71(SDFShaders_getInstance().z8g(), body.q72(this_0.j70(), MaterialRender_getInstance().oa3_1), MaterialRender_getInstance().pa3_1));
    var highlightAlpha = body.q71(body.r71(SDFShaders_getInstance().u8g(), highlightDist));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = body.a73(highlightAlpha, 0.0);
    var body_0 = body.e71();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>.<anonymous>' call
    body_0.n70(body_0.q70(), body_0.s71(SDFShaders_getInstance().c8h(), body_0.q70(), body_0.r70(MaterialRender_getInstance().qa3_1, highlightAlpha)));
    var stmIf = new If(cond_0, body_0.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    body.m70_1.h(stmIf);
    var stmIf_0 = new If(cond, body.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.m70_1.h(stmIf_0);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_1 = this_0.a73(MaterialRender_getInstance().ta3_1, 0.0);
    var body_1 = this_0.e71();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var borderDist = body_1.s71(SDFShaders_getInstance().t8g(), roundedDist, body_1.t72(MaterialRender_getInstance().ta3_1, 2.0));
    var borderAlpha = body_1.q71(body_1.r71(SDFShaders_getInstance().u8g(), borderDist));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_2 = body_1.a73(borderAlpha, 0.0);
    var body_2 = body_1.e71();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>.<anonymous>' call
    body_2.n70(body_2.q70(), body_2.s71(SDFShaders_getInstance().c8h(), body_2.q70(), body_2.r70(MaterialRender_getInstance().ua3_1, borderAlpha)));
    var stmIf_1 = new If(cond_2, body_2.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    body_1.m70_1.h(stmIf_1);
    var stmIf_2 = new If(cond_1, body_1.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.m70_1.h(stmIf_2);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_3 = this_0.b73(this_0.x72(this_0.a71(this_0.q70()), 1.0), this_0.a73(MaterialRender_getInstance().ma3_1, 0.0));
    var body_3 = this_0.e71();
    // Inline function 'korlibs.korge.render.MaterialRender.PROGRAM.<anonymous>.<anonymous>' call
    var shadowSoftness = MaterialRender_getInstance().ma3_1;
    var shadowOffset = MaterialRender_getInstance().na3_1;
    var shadowDistance = body_3.t71(SDFShaders_getInstance().a8h(), body_3.q72(body_3.s72(body_3.w70(this_0.j70(), 'xy'), shadowOffset), body_3.u72(size, 2.0)), body_3.u72(size, 2.0), MaterialRender_getInstance().sa3_1);
    var shadowAlpha = body_3.r72(1.0, body_3.j72(body_3.p72(shadowSoftness), shadowSoftness, shadowDistance));
    body_3.n70(body_3.q70(), body_3.s71(SDFShaders_getInstance().c8h(), body_3.r70(MaterialRender_getInstance().la3_1, shadowAlpha), body_3.q70()));
    var stmIf_3 = new If(cond_3, body_3.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    this_0.m70_1.h(stmIf_3);
    this_0.n70(this_0.q70(), this_0.r70(this_0.q70(), this_0.o70()));
    var tmp3_fragment = FragmentShader(this_0.v70());
    tmp.wa3_1 = tmp1_$this.h7o(VOID, tmp3_fragment, tmp2_name);
  }
}
class SceneCancellationException extends CancellationException {
  static da4(scene) {
    var $this = this.md('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.ca4_1);
    $this.ba4_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.ea4_1 = new Mixin();
    this.ja4_1 = Container.ba7();
    this.ka4_1 = new CancellableGroup();
    var tmp = this;
    tmp.la4_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ma4_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.na4_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  pa4() {
    var tmp = this.fa4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  ca7(_set____db54di) {
    this.ga4_1 = _set____db54di;
  }
  qa0() {
    var tmp = this.ga4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  qa4() {
    var tmp = this.ha4_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  b15() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.la4_1;
    coroutineContext$factory();
    return this_0.u1();
  }
  da7() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ma4_1;
    sceneView$factory();
    return this_0.u1();
  }
  ra4(size) {
    return SContainer.pa9(size);
  }
  l67(injector) {
    this.fa4_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.j67(getKClass(Views));
    this.ca7(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.ha4_1 = injector.j67(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.ia4_1 = injector.j67(getKClass(ResourcesRoot));
  }
  qa9(_this__u8e3s4, $completion) {
  }
  ra9(_this__u8e3s4, $completion) {
  }
  sa9($completion) {
  }
  ta9($completion) {
  }
  ua9($completion) {
  }
  va9() {
    cancel_0(this.ka4_1);
    this.pa4().m67();
  }
  oa4($completion) {
  }
  wa9($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  xa9(size) {
    size_0(this.da7(), size);
  }
  ay(value) {
    this.ea4_1.ay(value);
  }
  by() {
    return this.ea4_1.by();
  }
}
class EmptyScene extends Scene {
  ra9(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.oad_1 = clazz;
    this.pad_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.oad_1) + ', injects=' + toString(this.pad_1) + ')';
  }
  hashCode() {
    var result = this.oad_1.hashCode();
    result = imul(result, 31) + hashCode(this.pad_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.oad_1.equals(tmp0_other_with_cast.oad_1))
      return false;
    if (!equals(this.pad_1, tmp0_other_with_cast.pad_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.saa_1 = Companion_getInstance_0().qw('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.taa_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.iaa_1 = this$0;
    this.jaa_1 = $event;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.vaa_1 = $newScene;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.waa_1 = $newScene;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.xaa_1 = $oldScene;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.yaa_1 = $oldScene;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.zaa_1 = $oldScene;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.aab_1 = $newScene;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static ycn() {
    return this.t69();
  }
  e9x() {
  }
}
class View extends BaseView {
  static tcq(isContainer) {
    var $this = this.ycn();
    $this.u9p_1 = isContainer;
    var tmp = $this;
    tmp.v9p_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.w9p_1 = true;
    $this.x9p_1 = null;
    $this.y9p_1 = null;
    $this.z9p_1 = null;
    $this.a9q_1 = 0;
    $this.b9q_1 = null;
    $this.c9q_1 = 1.0;
    $this.d9q_1 = null;
    $this.e9q_1 = null;
    $this.f9q_1 = null;
    $this.g9q_1 = Companion_getInstance_13().w82_1;
    $this.h9q_1 = 0.0;
    $this.i9q_1 = 0.0;
    $this.j9q_1 = 1.0;
    $this.k9q_1 = 1.0;
    $this.l9q_1 = Companion_getInstance_35().d25_1;
    $this.m9q_1 = Companion_getInstance_35().d25_1;
    $this.n9q_1 = Companion_getInstance_35().d25_1;
    $this.o9q_1 = 0.0;
    $this.p9q_1 = scale$factory($this);
    $this.q9q_1 = false;
    $this.r9q_1 = true;
    $this.s9q_1 = true;
    $this.t9q_1 = true;
    $this.u9q_1 = true;
    $this.v9q_1 = Companion_getInstance_34().g29_1;
    $this.w9q_1 = Companion_getInstance_34().g29_1;
    $this.x9q_1 = -1;
    $this.y9q_1 = Companion_getInstance_34().g29_1;
    $this.z9q_1 = -1;
    $this.a9r_1 = new ColorTransformMul();
    $this.b9r_1 = new ColorTransformMul();
    $this.c9r_1 = -1;
    $this.d9r_1 = Companion_getInstance_13().w82_1;
    $this.e9r_1 = -1;
    $this.f9r_1 = true;
    $this.g9r_1 = 0;
    $this.h9r_1 = 0;
    $this.i9r_1 = false;
    $this.j9r_1 = false;
    $this.k9r_1 = null;
    $this.l9r_1 = false;
    $this.m9r_1 = null;
    $this.n9r_1 = 0;
    $this.o9r_1 = true;
    $this.p9r_1 = null;
    return $this;
  }
  gak() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v9p_1;
    bviewAll$factory();
    return this_0.u1();
  }
  static qcw() {
    return this.tcq(false);
  }
  hak() {
    return 0.0;
  }
  iak() {
    return 0.0;
  }
  naj() {
    return null;
  }
  xcn(_set____db54di) {
    this.y9p_1 = _set____db54di;
  }
  jak() {
    return this.y9p_1;
  }
  kak() {
    return this.z9p_1;
  }
  lak(value) {
    this.a9q_1 = value;
  }
  t6g() {
    return this.a9q_1;
  }
  mak(value) {
    if (this.d9q_1 === value)
      return Unit_instance;
    this.d9q_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naj();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).mak(value);
      }
      tmp = Unit_instance;
    }
    this.nak();
  }
  nak() {
  }
  oak(value) {
    if (this.e9q_1 === value)
      return Unit_instance;
    this.e9q_1 = value;
    var parent = this.laj();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naj();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).oak(parent);
      }
      tmp = Unit_instance;
    }
  }
  laj() {
    return this.e9q_1;
  }
  pak() {
    var tmp0_safe_receiver = this.b9q_1;
    this.oak(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.laj());
  }
  qak(value) {
    if (this.b9q_1 === value)
      return Unit_instance;
    this.b9q_1 = value;
    var tmp0_safe_receiver = this.b9q_1;
    this.mak(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d9q_1);
    this.pak();
    this.eam();
    this.u69(value);
  }
  x23() {
    return this.b9q_1;
  }
  tay(value) {
    if (!this.g9q_1.equals(value)) {
      this.g9q_1 = value;
      this.oaj();
    }
  }
  rak() {
    return !(this.x23() == null) ? ensureNotNull(this.x23()).rak() * this.c9q_1 : this.c9q_1;
  }
  sak(x, y) {
    this.tal();
    if (!(this.h9q_1 === x) || !(this.i9q_1 === y)) {
      this.h9q_1 = x;
      this.i9q_1 = y;
      this.cam();
    }
  }
  b54(value) {
    return this.sak(value.m25_1, value.n25_1);
  }
  tak(v) {
    this.sak(v, this.b6e());
  }
  a6e() {
    this.tal();
    return this.h9q_1;
  }
  uak(v) {
    this.sak(this.a6e(), v);
  }
  b6e() {
    this.tal();
    return this.i9q_1;
  }
  vak() {
    return this.o9q_1;
  }
  wak(v) {
    this.cal(Scale.q2d(v, v));
  }
  xak() {
    return this.dal().s2b();
  }
  yak(v) {
    this.tal();
    if (!(this.j9q_1 === v)) {
      this.j9q_1 = v;
      this.cam();
    }
  }
  zak() {
    this.tal();
    return this.j9q_1;
  }
  aal(v) {
    this.tal();
    if (!(this.k9q_1 === v)) {
      this.k9q_1 = v;
      this.cam();
    }
  }
  bal() {
    this.tal();
    return this.k9q_1;
  }
  cal(value) {
    this.yak(value.o2d_1);
    this.aal(value.p2d_1);
  }
  dal() {
    return Scale.q2d(this.zak(), this.bal());
  }
  eal() {
    this.tal();
    return this.l9q_1;
  }
  fal() {
    this.tal();
    return this.m9q_1;
  }
  gal(v) {
    this.tal();
    if (!equals(this.n9q_1, v)) {
      this.n9q_1 = v;
      this.cam();
    }
  }
  hal() {
    this.tal();
    return this.n9q_1;
  }
  ial() {
    var tmp0_safe_receiver = this.x23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lam(Vector2D.w27(this.a6e(), this.b6e()));
    return tmp1_elvis_lhs == null ? Vector2D.w27(this.a6e(), this.b6e()) : tmp1_elvis_lhs;
  }
  jal(value) {
    this.pag(value);
  }
  e1() {
    return this.qag();
  }
  pag(value) {
    var size = this.e1();
    this.cal(Scale.q2d((this.zak() === 0.0 ? 1.0 : this.zak()) * (value.r26_1 / size.r26_1), (this.bal() === 0.0 ? 1.0 : this.bal()) * (value.s26_1 / size.s26_1)));
  }
  qag() {
    return this.r9y().e1();
  }
  kal(value) {
    this.pag(this.qag().u2g(value));
  }
  lal() {
    return this.qag().r26_1;
  }
  mal(value) {
    this.pag(this.qag().u2g(VOID, value));
  }
  nal() {
    return this.qag().s26_1;
  }
  oal(value) {
    this.kal(this.zak() === 0.0 ? value : value / this.zak());
  }
  pal() {
    return this.lal() * this.zak();
  }
  qal() {
    return this.nal() * this.bal();
  }
  z2i() {
    return this.lal();
  }
  hd3(value) {
    this.mal(value);
  }
  a2j() {
    return this.nal();
  }
  m4h(v) {
    if (!(v === this.a9r_1.r4g())) {
      this.a9r_1.m4h(v);
      this.paj();
    }
  }
  r4g() {
    return this.a9r_1.r4g();
  }
  ral(v) {
    if (!(this.a9r_1.l4h() === v)) {
      this.a9r_1.k4h(v);
      this.paj();
    }
  }
  sal() {
    return this.a9r_1.l4h();
  }
  tal() {
    if (this.t9q_1)
      return Unit_instance;
    this.t9q_1 = true;
    var t = this.v9q_1.u2a();
    this.h9q_1 = t.g2b_1;
    this.i9q_1 = t.h2b_1;
    this.j9q_1 = t.i2b_1;
    this.k9q_1 = t.j2b_1;
    this.l9q_1 = t.k2b_1;
    this.m9q_1 = t.l2b_1;
    this.n9q_1 = t.m2b_1;
  }
  r23() {
    var tmp0_safe_receiver = this.x23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r23();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  o9x() {
    return this.d9q_1;
  }
  sa0(_set____db54di) {
    this.q9q_1 = _set____db54di;
  }
  pa0() {
    return this.q9q_1;
  }
  ual() {
    return this.r9q_1;
  }
  y8m(value) {
    if (!(this.s9q_1 === value)) {
      this.s9q_1 = value;
      this.oaj();
    }
  }
  val() {
    return this.s9q_1;
  }
  wal() {
    if (!this.u9q_1) {
      this.u9q_1 = true;
      this.i9r_1 = true;
      this.v9q_1 = Companion_getInstance_34().s29(this.a6e(), this.b6e(), this.hal(), this.zak(), this.bal(), this.eal(), this.fal(), 0.0, 0.0);
    }
    return this.v9q_1;
  }
  t9y() {
    if (!(this.x9q_1 === this.g9r_1)) {
      this.x9q_1 = this.g9r_1;
      this.i9r_1 = true;
      this.w9q_1 = !(this.x23() == null) ? this.wal().u29(ensureNotNull(this.x23()).t9y()) : this.wal();
    }
    return this.w9q_1;
  }
  xal() {
    if (!(this.z9q_1 === this.g9r_1)) {
      this.z9q_1 = this.g9r_1;
      this.i9r_1 = true;
      this.y9q_1 = this.t9y().t2a();
    }
    return this.y9q_1;
  }
  yal() {
    updateRenderColorTransformIfRequired(this);
    return this.b9r_1;
  }
  zal() {
    updateRenderBlendModeIfRequired(this);
    return this.d9r_1;
  }
  aam() {
    updateRenderColorTransformIfRequired(this);
    return this.b9r_1.r4g();
  }
  bam(views) {
    return this.va0(views.g9n_1.v87());
  }
  cam() {
    this.u9q_1 = false;
    this.oaj();
  }
  oaj() {
    this.g9r_1 = this.g9r_1 + 1 | 0;
    this.i9r_1 = false;
    this.f9r_1 = true;
    this.e9x();
  }
  dam() {
    if (!(this.k9r_1 == null)) {
      this.k9r_1 = null;
      var tmp0_safe_receiver = this.x23();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.dam();
      }
    }
  }
  eam() {
    this.tag();
  }
  fam() {
    this.tag();
  }
  tag() {
  }
  e9x() {
    var tmp0_safe_receiver = this.e9q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.maj(this);
    }
    this.dam();
  }
  paj() {
    this.h9r_1 = this.h9r_1 + 1 | 0;
    this.j9r_1 = false;
    this.f9r_1 = true;
    this.e9x();
  }
  gam(phase) {
    if (this.m9r_1 == null)
      this.m9r_1 = fastArrayListOf([]);
    var tmp0_safe_receiver = this.m9r_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.h(phase);
    var tmp1_safe_receiver = this.m9r_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.sortBy' call
      if (tmp1_safe_receiver.e1() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = View$addRenderPhase$lambda;
        var tmp$ret$0 = new sam$kotlin_Comparator$0_0(tmp);
        sortWith(tmp1_safe_receiver, tmp$ret$0);
      }
    }
  }
  rag(ctx) {
    if (!this.val())
      return Unit_instance;
    var tmp0_safe_receiver = this.m9r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].pd9(this, ctx);
      }
    }
    try {
      this.ham(ctx);
    }finally {
      var tmp1_safe_receiver = this.m9r_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.qy_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.e1() - n_0 | 0) - 1 | 0].qd9(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  ham(ctx) {
    var oldPhase = this.n9r_1;
    try {
      this.n9r_1 = 0;
      this.iam(ctx);
    }finally {
      this.n9r_1 = oldPhase;
    }
  }
  iam(ctx) {
    var stages = this.m9r_1;
    if (!(stages == null) && this.n9r_1 < stages.e1()) {
      var _unary__edvuaz = this.n9r_1;
      this.n9r_1 = _unary__edvuaz + 1 | 0;
      stages.d1(_unary__edvuaz).rd9(this, ctx);
    } else {
      var tmp = this.n9r_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.e1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.vag(ctx);
        this.n9r_1 = this.n9r_1 + 1 | 0;
      }
    }
  }
  zaj(ctx) {
    if (this.l9r_1 || this === get_debugAnnotateView(ctx)) {
      this.jam(ctx);
    }
  }
  jam(ctx) {
    var local = this.r9y();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.q8d_1;
    if (!(this_1.s84_1 === this_0)) {
      this_1.s84_1 = this_0;
      this_1.c86();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.c8e_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().f83_1;
          var doUpdate = !(this_0.b8e_1 === blending);
          var old = this_0.b8e_1;
          try {
            if (doUpdate) {
              this_0.q8d_1.c86();
              this_0.b8e_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().g41_1;
            var m = this_0.c8e_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.t8d_1;
            this_0.t8d_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.y3o(this.xam());
              this_0.i8e(this_3, m);
            }finally {
              this_0.t8d_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.q8d_1.c86();
            }
            this_0.b8e_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().g41_1;
        var m_0 = this_0.c8e_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.t8d_1;
        this_0.t8d_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.q3d(this.lam(Vector2D.w27(local.d26(), local.f26())));
          this_4.d3e(this.lam(Vector2D.w27(local.e26(), local.f26())));
          this_4.d3e(this.lam(Vector2D.w27(local.e26(), local.g26())));
          this_4.d3e(this.lam(Vector2D.w27(local.d26(), local.g26())));
          this_4.f6();
          this_0.i8e(this_4, m_0);
        }finally {
          this_0.t8d_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().u46_1;
        var m_1 = this_0.c8e_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.t8d_1;
        this_0.t8d_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).j8d();
          this_5.d3p(this.lam(local.v26()), anchorSize);
          this_5.d3p(this.lam(local.t2e()), anchorSize);
          this_5.d3p(this.lam(local.x26()), anchorSize);
          this_5.d3p(this.lam(local.u2e()), anchorSize);
          this_5.d3p(this.lam(interpolate(Companion_getInstance_38().qx_1, local.v26(), local.t2e())), anchorSize);
          this_5.d3p(this.lam(interpolate(Companion_getInstance_38().qx_1, local.t2e(), local.x26())), anchorSize);
          this_5.d3p(this.lam(interpolate(Companion_getInstance_38().qx_1, local.x26(), local.u2e())), anchorSize);
          this_5.d3p(this.lam(interpolate(Companion_getInstance_38().qx_1, local.u2e(), local.v26())), anchorSize);
          this_0.i8e(this_5, m_1);
        }finally {
          this_0.t8d_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().i41_1;
        var m_2 = this_0.c8e_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.t8d_1;
        this_0.t8d_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.ial();
          this_6.x3o(Vector2D.w27(center.m25_1, center.n25_1 - 5), Vector2D.w27(center.m25_1, center.n25_1 + 5));
          this_6.x3o(Vector2D.w27(center.m25_1 - 5, center.n25_1), Vector2D.w27(center.m25_1 + 5, center.n25_1));
          this_0.i8e(this_6, m_2);
        }finally {
          this_0.t8d_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.a6e() === 0.0) || !(this.b6e() === 0.0))
      out = out + (':pos=(' + this.kam(this.a6e()) + ',' + this.kam(this.b6e()) + ')');
    if (!(this.zak() === 1.0) || !(this.bal() === 1.0))
      out = out + (':scale=(' + this.kam(this.zak()) + ',' + this.kam(this.bal()) + ')');
    if (!equals(this.eal(), Companion_getInstance_35().d25_1) || !equals(this.fal(), Companion_getInstance_35().d25_1))
      out = out + (':skew=(' + this.kam(_Angle___get_degrees__impl__qg56vw(this.eal())) + ',' + this.kam(_Angle___get_degrees__impl__qg56vw(this.fal())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.hal()), Companion_getInstance_35().d25_1))
      out = out + (':rotation=(' + this.kam(_Angle___get_degrees__impl__qg56vw(this.hal())) + '\xBA)');
    if (!(this.f9q_1 == null))
      out = out + (':name=(' + this.f9q_1 + ')');
    if (!this.g9q_1.equals(Companion_getInstance_13().w82_1))
      out = out + (':blendMode=(' + this.g9q_1.toString() + ')');
    if (!this.val())
      out = out + (':visible=' + this.val());
    if (!(this.sal() === 1.0))
      out = out + (':alpha=' + niceStr(this.sal(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.r4g()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().e41_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.r4g()));
    return out;
  }
  kam(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  va0(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.xal();
      if (this_0.b26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.w27(this_0.y29(p.m25_1, p.n25_1), this_0.b2a(p.m25_1, p.n25_1));
    }
    return tmp$ret$0;
  }
  lam(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.t9y();
      if (this_0.b26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.w27(this_0.y29(p.m25_1, p.n25_1), this_0.b2a(p.m25_1, p.n25_1));
    }
    return tmp$ret$0;
  }
  mam(globalPos, direction) {
    if (!this.o9r_1)
      return null;
    if (!this.val())
      return null;
    var tmp0_safe_receiver = this.naj();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.hitTest.<anonymous>' call
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).mam(globalPos, direction);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          return tmp0_safe_receiver_0;
        }
        n = n + 1 | 0;
      }
    }
    var res = this.pam(globalPos);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  ka2(globalPos, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.mam(globalPos, direction) : $super.mam.call(this, globalPos, direction);
  }
  q9y(p) {
    if (!this.o9r_1)
      return null;
    if (!this.val())
      return null;
    if (this.ual()) {
      var tmp0_safe_receiver = this.naj();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).q9y(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.pa0())
      return null;
    var tmp1_safe_receiver = this.pam(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.nam();
      if (!area.b26() && !area.s27(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  nam() {
    var out = Companion_getInstance_33().j26_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x23();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.v62();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.zam();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.c2f(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.x23();
    }
    return count === 0 ? Companion_getInstance_33().l26() : out;
  }
  oam(p, direction) {
    if (!this.o9r_1)
      return null;
    var ll = this.va0(p);
    var bounds = this.r9y();
    if (!bounds.s27(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.q2a(this.hak(), this.iak());
    var l = Vector2D.w27(ll.m25_1 + that.m25_1, ll.n25_1 + that.n25_1);
    if (this.p9r_1 === false)
      return this;
    var hitShape = this.jak();
    var hitShapes = this.kak();
    if (this.p9r_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.e1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.d1(_unary__edvuaz).t3p(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.t3p(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  pam(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.oam(p, direction) : $super.oam.call(this, p, direction);
  }
  qam() {
    var tmp0_safe_receiver = this.x23();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.fak(this);
  }
  ram(target, inclusive) {
    var tmp;
    if (target === this.x23()) {
      tmp = this.wal();
    } else if (target === this) {
      tmp = Companion_getInstance_34().g29_1;
    } else {
      var commonAncestor = Companion_instance_28.md9(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.x23() == null && inclusive) {
          return this.t9y();
        }
        tmp_0 = this.t9y().u29(target.xal());
      } else {
        tmp_0 = Companion_getInstance_34().g29_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.u29(target.wal());
    }
    return out;
  }
  sam() {
    var tmp0_elvis_lhs = this.tam();
    return tmp0_elvis_lhs == null ? this.zam() : tmp0_elvis_lhs;
  }
  tam() {
    var stage = this.r23();
    if (!(stage instanceof Stage))
      return null;
    return this.uam(stage);
  }
  uam(bp) {
    return this.zam().k2f(bp.f8d());
  }
  vam(ctx) {
    return ctx.q8e() ? this.uam(ctx) : this.zam();
  }
  wam(ctx) {
    return this.vam(ctx);
  }
  xam() {
    return this.zam();
  }
  yam(includeFilters) {
    return this.ean(this.r23(), VOID, true, includeFilters);
  }
  zam(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.yam(includeFilters) : $super.yam.call(this, includeFilters);
  }
  aan(target, inclusive, includeFilters) {
    return this.dan(target, false, inclusive, includeFilters);
  }
  ban(target, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.aan(target, inclusive, includeFilters) : $super.aan.call(this, target, inclusive, includeFilters);
  }
  can(concat, doAnchoring, includeFilters) {
    var out = this.fan(doAnchoring, includeFilters);
    if (concat.c26() && !concat.v29()) {
      var tmp = Companion_getInstance_32();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.v26();
        if (concat.b26()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.w27(concat.y29(p.m25_1, p.n25_1), concat.b2a(p.m25_1, p.n25_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.t2e();
        if (concat.b26()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.w27(concat.y29(p_0.m25_1, p_0.n25_1), concat.b2a(p_0.m25_1, p_0.n25_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.x26();
        if (concat.b26()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.w27(concat.y29(p_1.m25_1, p_1.n25_1), concat.b2a(p_1.m25_1, p_1.n25_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.u2e();
        if (concat.b26()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.w27(concat.y29(p_2.m25_1, p_2.n25_1), concat.b2a(p_2.m25_1, p_2.n25_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.n26(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  dan(target, doAnchoring, inclusive, includeFilters) {
    return this.can(this.ram(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  ean(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.dan(target, doAnchoring, inclusive, includeFilters) : $super.dan.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  fan(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.k9r_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.sag();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.k9r_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.k2a(Vector2D.q2a(this.hak(), this.iak()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  r9y(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.fan(doAnchoring, includeFilters) : $super.fan.call(this, doAnchoring, includeFilters);
  }
  sag() {
    return Companion_getInstance_33().l26();
  }
  c6a(type, event, result) {
    var tmp0_safe_receiver = this.x23();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.j6a(type, event, result);
  }
}
class Container extends View {
  static ba7(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.tcq(true);
    $this.sa6_1 = cull;
    $this.ta6_1 = FastArrayList.sy();
    $this.ua6_1 = new ContainerCollection($this, $this.ta6_1);
    $this.va6_1 = null;
    $this.wa6_1 = new MMatrix();
    $this.xa6_1 = false;
    $this.ya6_1 = false;
    $this.za6_1 = FastArrayList.sy();
    return $this;
  }
  naj() {
    return this.ta6_1;
  }
  oaj() {
    super.oaj();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ua6_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.i9r_1) {
        child.oaj();
      }
    }
  }
  paj() {
    super.paj();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ua6_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.j9r_1) {
        child.paj();
      }
    }
  }
  qaj() {
    return this.ta6_1.e1();
  }
  raj(view) {
  }
  saj(view) {
  }
  tag() {
    super.tag();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naj();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).fam();
      }
      tmp = Unit_instance;
    }
  }
  taj(index) {
    return this.ta6_1.d1(index);
  }
  uaj(index) {
    return this.vaj(index, 1) === 1;
  }
  vaj(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.qaj();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.taj(removedIndex);
        view.qak(null);
        view.lak(-1);
      }
       while (inductionVariable < to);
    this.ta6_1.c7(from, to);
    var inductionVariable_0 = index;
    var last = this.qaj();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.ta6_1.d1(i).lak(i);
      }
       while (inductionVariable_0 < last);
    this.bak();
    this.cak();
    this.dam();
    return to - from | 0;
  }
  waj() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ua6_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      child.qak(null);
      child.lak(-1);
    }
    this.ta6_1.l3();
    this.bak();
  }
  xaj(view) {
    return this.eak(view, this.qaj());
  }
  aa7(view) {
    this.eak(view, this.qaj());
  }
  d1(index) {
    return this.taj(index);
  }
  vag(ctx) {
    if (!this.val())
      return Unit_instance;
    this.yaj(ctx);
  }
  yaj(ctx) {
    if (!this.sa6_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.xa6_1) {
        this.xa6_1 = true;
        this.za6_1.l3();
        this.za6_1.f1(this.ua6_1);
        if (this.aak())
          this.ya6_1 = false;
      }
      if (!this.ya6_1) {
        this.ya6_1 = true;
        sortWith(this.za6_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.za6_1.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].rag(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.zam();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_33().l26() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.xa6_1) {
      this.xa6_1 = true;
      this.za6_1.l3();
      this.za6_1.f1(this.ua6_1);
      if (this.aak())
        this.ya6_1 = false;
    }
    if (!this.ya6_1) {
      this.ya6_1 = true;
      sortWith(this.za6_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.za6_1.qy_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.b26() || bounds.z2e(child.yam(true))) {
        child.rag(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  zaj(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.xa6_1) {
      this.xa6_1 = true;
      this.za6_1.l3();
      this.za6_1.f1(this.ua6_1);
      if (this.aak())
        this.ya6_1 = false;
    }
    if (!this.ya6_1) {
      this.ya6_1 = true;
      sortWith(this.za6_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.za6_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].zaj(ctx);
    }
    super.zaj(ctx);
  }
  sag() {
    var bb = Companion_getInstance_32().m26();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ua6_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.ean(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  aak() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ta6_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].vak() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  bak() {
    this.xa6_1 = false;
    this.cak();
  }
  cak() {
    var tmp0_safe_receiver = this.o9x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qa0();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.maj(this);
    }
  }
  dak(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  eak(view, index) {
    this.dak(view);
    var tmp0_safe_receiver = view.x23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.bak();
    }
    view.qam();
    var aindex = clamp(index, 0, this.qaj());
    var children = this.ta6_1;
    children.a7(aindex, view);
    var inductionVariable = aindex;
    var last = this.qaj();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.d1(n).lak(n);
      }
       while (inductionVariable < last);
    view.qak(this);
    view.oaj();
    this.raj(view);
    this.bak();
    this.cak();
    this.dam();
  }
  fak(view) {
    if (!((view == null ? null : view.x23()) === this))
      return false;
    return this.uaj(view.t6g());
  }
  z69(type, event, result) {
    if (this.va6_1 == null)
      this.va6_1 = FastArrayList.ry(this.ua6_1.e1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.ta6_1;
    var temp = ensureNotNull(this.va6_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].i6a(type, event, result);
      }
    }finally {
      temp.l3();
    }
  }
}
class CachedContainer extends Container {
  static zcn(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.ba7();
    $this.eaj_1 = cache;
    $this.faj_1 = renderQuality;
    $this.gaj_1 = null;
    $this.haj_1 = true;
    $this.iaj_1 = -1.0;
    $this.jaj_1 = Companion_getInstance_33().j29();
    $this.kaj_1 = Scale.c2g(1);
    return $this;
  }
  e9x() {
    super.e9x();
    this.haj_1 = true;
  }
  vag(ctx) {
    if (!this.val())
      return Unit_instance;
    if (!this.eaj_1) {
      return super.vag(ctx);
    }
    if (this.gaj_1 == null) {
      this.gaj_1 = new CacheTexture(this, ctx);
      this.haj_1 = true;
    }
    var cache = ensureNotNull(this.gaj_1);
    ctx.u8e(cache);
    var renderScale = ctx.k8e().r3_1 === 0 ? 1.0 : ctx.c8f();
    var tmp1_elvis_lhs = this.faj_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.k8e() : tmp1_elvis_lhs);
    if (this.haj_1 || !(this.iaj_1 === renderScale)) {
      this.iaj_1 = renderScale;
      this.jaj_1 = this.r9y(VOID, false);
      this.kaj_1 = doExpensiveScaling ? this.sam().e1().e2g(this.jaj_1.e1()) : Scale.c2g(1);
      this.haj_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.jaj_1.y25_1 * renderScale * this.kaj_1.o2d_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.jaj_1.z25_1 * renderScale * this.kaj_1.p2d_1), 1);
      cache.fco(texWidth, texHeight);
      ctx.c86();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.bco_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.z8e(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.o84_1;
        var this_1 = this_0.x84_1;
        if (!(this_1.s84_1 === this_0)) {
          this_1.s84_1 = this_0;
          this_1.c86();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.b6u(0, 0, frameBuffer.a6j_1, frameBuffer.b6j_1);
          var temp = this_0.v85_1;
          this_0.e8c();
          this_0.v85_1 = scissor;
          try {
            if (true) {
              ctx.s8e(Colors_getInstance().j41_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.xal().m2a(-this.jaj_1.w25_1, -this.jaj_1.x25_1).g2a(renderScale * this.kaj_1.o2d_1, renderScale * this.kaj_1.p2d_1);
            ctx.c86();
            var temp4 = ctx.d84_1;
            var temp2d = ctx.e84_1;
            ctx.e84_1 = matrix;
            ctx.d84_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.n6q(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.c6s();
              this_2.f7f(_unary__edvuaz + 1 | 0);
              this_2.g7f(this_2.c6s() + 1 | 0);
              var blockSize = this_2.g6q_1;
              var index0 = imul(this_2.c6s() - 1 | 0, blockSize);
              var index1 = imul(this_2.c6s(), blockSize);
              var texBlockSize = this_2.d6q_1.c6y().e1();
              var texIndex0 = imul(this_2.c6s() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.c6s(), texBlockSize);
              if (this_2.c6s() > 0) {
                arraycopy(this_2.i6q_1, index0, this_2.i6q_1, index1, blockSize);
              } else {
                arrayfill(this_2.i6q_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.d6q_1;
              this_2.j6q_1.v7f($this$push.b6y(), ctx.d84_1);
              if (true && this_2.c6s() >= 1) {
                var equals = arrayequal(this_2.i6q_1, index0, this_2.i6q_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.c6s();
                  this_2.f7f(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.vag(ctx);
            }finally {
              ctx.c86();
              ctx.d84_1 = temp4;
              ctx.e84_1 = temp2d;
              ctx.n6q(ProjViewUB_getInstance()).h7f();
            }
            break $l$block_0;
          }finally {
            this_0.e8c();
            this_0.v85_1 = temp;
          }
        }
      }finally {
        ctx.a8f();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.o84_1;
    var this_4 = this_3.x84_1;
    if (!(this_4.s84_1 === this_3)) {
      this_4.s84_1 = this_3;
      this_4.c86();
    }
    this_3.e86(cache.dco_1, VOID, VOID, VOID, VOID, this.t9y().r2a(this.jaj_1.w25_1, this.jaj_1.x25_1).i2a(1.0 / (renderScale * this.kaj_1.o2d_1), 1.0 / (renderScale * this.kaj_1.p2d_1)), VOID, this.aam(), this.g9q_1);
  }
  laj() {
    return this;
  }
  maj(view) {
    this.haj_1 = true;
    var tmp0_safe_receiver = this.x23();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e9q_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.maj(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static tch(size, cache, clip) {
    size = size === VOID ? Size2D.t26(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.zcn(cache);
    $this.qch_1 = clip;
    $this.rch_1 = size;
    $this.sch_1 = Ref(false);
    return $this;
  }
  pag(_set____db54di) {
    this.rch_1 = _set____db54di;
  }
  qag() {
    return this.rch_1;
  }
  sag() {
    return new Rectangle(0.0, 0.0, this.z2i(), this.a2j());
  }
  vag(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.qch_1;
      var renderingInternalRef = this.sch_1;
      if (renderingInternalRef.u1()) {
        super.vag(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.t9y();
        var hasRotation = !(m.m29_1 === 0.0) || !(m.n29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.u1();
          try {
            renderingInternalRef.j2r(true);
            renderFiltered(this, ctx, Companion_getInstance_61());
          }finally {
            renderingInternalRef.j2r(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.o84_1;
        if (!(ctx.s84_1 === batcher)) {
          ctx.s84_1 = batcher;
          ctx.c86();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.q84_1;
        var bounds = this.wam(ctx).k2f(ctx.e84_1).l2f();
        var rect = c2d.g8f_1.o8b().j6u();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.z2e(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_16().e6u(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.g8f_1;
            var scissor_0 = c2d.t8f(scissor);
            var temp = this_0.v85_1;
            this_0.e8c();
            this_0.v85_1 = scissor_0;
            try {
              super.vag(ctx);
              break $l$block_1;
            }finally {
              this_0.e8c();
              this_0.v85_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.vag(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.vag(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static kag(size, cache) {
    Companion_getInstance_46();
    size = size === VOID ? Companion_getInstance_46().fb8_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.tch(size, cache, false);
    $this.iag_1 = size;
    $this.jag_1 = false;
    return $this;
  }
  pag(value) {
    if (!this.iag_1.equals(value)) {
      this.iag_1 = value;
      this.mag();
    }
  }
  qag() {
    return this.iag_1;
  }
  sag() {
    return new Rectangle(0.0, 0.0, this.z2i(), this.a2j());
  }
  hb8() {
    return this.pa0();
  }
  mag() {
    var tmp0_safe_receiver = this.x23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.saj(this);
    }
  }
  tag() {
    super.tag();
    this.uag();
  }
  uag() {
    this.oaj();
  }
  vag(ctx) {
    registerUISupportOnce(this);
    super.vag(ctx);
  }
}
class SceneContainer extends UIView {
  static q9u(views, defaultTransition, name, size) {
    Companion_getInstance_44();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_37())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.p9o_1.e1() : size;
    var $this = this.kag(size);
    $this.k9u_1 = views;
    $this.l9u_1 = defaultTransition;
    $this.f9q_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.lag();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.aa7(this_0);
    tmp.m9u_1 = this_0;
    $this.n9u_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.v69(tmp_0, SceneContainer$lambda($this));
    $this.o9u_1 = arrayListOf([Companion_getInstance_44().taa_1]);
    $this.p9u_1 = 0;
    return $this;
  }
  mag() {
    var tmp0_safe_receiver = this.n9u_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.xa9(Size2D.l2e(this.z2i(), this.a2j()));
    }
  }
  nag(clazz, injects, time, transition, $completion) {
    this.oag(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  r9u(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.l9u_1 : transition;
    return $super === VOID ? this.nag(clazz, injects, time, transition, $completion) : $super.nag.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  uaa(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  oag(entry) {
    while (this.o9u_1.e1() <= this.p9u_1) {
      this.o9u_1.h(Companion_getInstance_44().taa_1);
    }
    this.o9u_1.o3(this.p9u_1, entry);
  }
  b15() {
    return this.k9u_1.d9n_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static lag() {
    var $this = this.ba7();
    dummyView($this);
    dummyView($this);
    $this.jad_1 = Companion_getInstance_38().ox_1;
    $this.kad_1 = get_AlphaTransition();
    return $this;
  }
  j1i() {
    return this.d1(0);
  }
  g1i() {
    return this.d1(1);
  }
  mad(next, transition) {
    this.kad_1 = transition;
    this.jad_1 = Companion_getInstance_38().ox_1;
    this.lad_1 = transition.jan();
    this.kan(this.g1i(), next);
    _get_transitionProcess__5hlux5(this).gan(this.j1i(), this.g1i());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.jad_1) + ':transition=' + toString(this.kad_1));
  }
  nad() {
    this.jad_1 = Companion_getInstance_38().rx_1;
    _get_transitionProcess__5hlux5(this).han(this.j1i(), this.g1i());
    this.kan(dummyView(this), this.g1i());
  }
  kan(prev, next) {
    this.waj();
    this.xaj(prev);
    this.xaj(next);
  }
  vag(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.jad_1, Companion_getInstance_38().ox_1) <= 0) {
      this.j1i().rag(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.jad_1, Companion_getInstance_38().rx_1) >= 0) {
      this.g1i().rag(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).ian(ctx, this.j1i(), this.g1i(), this.jad_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.lan_1 = $render;
    this.man_1 = $name;
  }
  jan() {
    return this;
  }
  ian(ctx, prev, next, ratio) {
    return this.lan_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.man_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.nan_1 = $process;
    this.oan_1 = $easing;
  }
  gan(prev, next) {
    return this.nan_1.gan(prev, next);
  }
  han(prev, next) {
    return this.nan_1.han(prev, next);
  }
  ian(ctx, prev, next, ratio) {
    return this.nan_1.ian(ctx, prev, next, this.oan_1.jx(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.pan_1 = $this_withEasing;
    this.qan_1 = $easing;
  }
  toString() {
    return toString(this.pan_1) + '.withEasing';
  }
  jan() {
    var process = this.pan_1.jan();
    return new withEasing$1$create$1(process, this.qan_1);
  }
}
class ViewStyles {
  constructor(view) {
    this.ran_1 = view;
    this.san_1 = null;
    this.tan_1 = atomic$int$1(0);
  }
  uan(prop, default_0) {
    var tmp0_safe_receiver = this.san_1;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f3(prop.callableName);
    var tmp1_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.ran_1.x23();
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : get_styles(tmp2_safe_receiver);
      tmp_0 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.uan(prop, default_0);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp_0;
    return tmp4_elvis_lhs == null ? default_0 : tmp4_elvis_lhs;
  }
  van(updating) {
    if (updating === 0) {
      var tmp = this.ran_1;
      var tmp0_safe_receiver = isInterface(tmp, StyleableView) ? tmp : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wan();
      }
    }
  }
  xan(updating, $super) {
    updating = updating === VOID ? this.tan_1.kotlinx$atomicfu$value : updating;
    var tmp;
    if ($super === VOID) {
      this.van(updating);
      tmp = Unit_instance;
    } else {
      tmp = $super.van.call(this, updating);
    }
    return tmp;
  }
}
class ViewStyle {
  constructor(default_0) {
    this.yan_1 = default_0;
  }
}
class StyleableView {}
function updatedStyles() {
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.zan_1 = this.dao(true, VOID, false);
    this.aao_1 = this.dao(true, VOID, true);
    this.bao_1 = this.eao(false, 'r', false);
    this.cao_1 = this.eao(false, 'a', false);
  }
  eao(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().a8b_1;
    var tmp2_name = name == null ? Companion_getInstance_6().a8b_1.z6q_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.d72();
    var tmp_0 = this_0.d72();
    var tmp_1 = this_0.d72();
    var tmp_2 = this_0.d72();
    var median$delegate = this_0.o71(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).q6y(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_6().x8a_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.v71(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.l72(this_0.b71());
    var alpha = this_0.m72(this_0.b71());
    this_0.n70(this_0.q70(), this_0.q72(this_0.q70(), this_0.u70([this_0.t70(0.5)])));
    if (msdf) {
      this_0.n70(d, this_0.t71(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.w70(this_0.q70(), 'r'), this_0.w70(this_0.q70(), 'g'), this_0.w70(this_0.q70(), 'b')));
    } else {
      this_0.n70(d, this_0.w70(this_0.q70(), sdf));
    }
    this_0.n70(alpha, this_0.r71(SDFShaders_getInstance().v8g(), d));
    if (inverted) {
      this_0.n70(alpha, this_0.q72(this_0.t70(1.0), alpha));
    }
    this_0.n70(this_0.q70(), this_0.r70(this_0.o70(), alpha));
    var tmp3_fragment = FragmentShader(this_0.v70());
    return tmp1_$this.h7o(VOID, tmp3_fragment, tmp2_name);
  }
  dao(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.eao(msdf, sdf, inverted) : $super.eao.call(this, msdf, sdf, inverted);
  }
}
class TextSnapshot {
  constructor(text, selectionRange) {
    this.tap_1 = text;
    this.uap_1 = selectionRange;
  }
  vap(out) {
    setTextNoSnapshot$default(out, this.tap_1);
    out.wap(this.uap_1);
  }
  toString() {
    return 'TextSnapshot(text=' + this.tap_1 + ', selectionRange=' + this.uap_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.tap_1);
    result = imul(result, 31) + this.uap_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSnapshot))
      return false;
    var tmp0_other_with_cast = other instanceof TextSnapshot ? other : THROW_CCE();
    if (!(this.tap_1 === tmp0_other_with_cast.tap_1))
      return false;
    if (!this.uap_1.equals(tmp0_other_with_cast.uap_1))
      return false;
    return true;
  }
}
class TextEditController$slambda {
  constructor(this$0) {
    this.wat_1 = this$0;
  }
  h9y(it, $completion) {
    if (!get_focused(this.wat_1))
      return Unit_instance;
    if (it.v6b_1 || it.t6b_1)
      return Unit_instance;
    // Inline function 'kotlin.code' call
    var this_0 = it.r6b_1;
    var code = Char__toInt_impl_vasixd(this_0);
    switch (code) {
      case 8:
      case 127:
        break;
      case 9:
      case 10:
      case 13:
        if (code === 10 || code === 13) {
          this.wat_1.oao_1.i1w(this.wat_1);
        }

        break;
      case 27:
        this.wat_1.nao_1.i1w(this.wat_1);
        break;
      default:
        this.wat_1.jap(it.y6b());
        break;
    }
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class TextEditController$slambda_0 {
  constructor(this$0) {
    this.fao_1 = this$0;
  }
  h9y(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this, it), $completion);
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIFocusable {}
class TextEditController {
  constructor(textView, caretContainer, eventHandler, bg) {
    caretContainer = caretContainer === VOID ? textView : caretContainer;
    eventHandler = eventHandler === VOID ? textView : eventHandler;
    bg = bg === VOID ? null : bg;
    this.gao_1 = new SoftKeyboardConfig();
    this.hao_1 = textView;
    this.iao_1 = caretContainer;
    this.jao_1 = eventHandler;
    this.kao_1 = bg;
    set_focusable(this.hao_1, this);
    this.lao_1 = this.hao_1.b5u();
    this.mao_1 = new CancellableGroup();
    this.nao_1 = new Signal();
    this.oao_1 = new Signal();
    this.pao_1 = new Signal();
    this.qao_1 = new Signal();
    this.rao_1 = new Signal();
    this.sao_1 = new Signal();
    this.tao_1 = new Signal();
    this.uao_1 = new Signal();
    var tmp = this;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.korge.view.debug.debugVertexView' call
    var this_0 = this.iao_1;
    // Inline function 'kotlin.collections.listOf' call
    var pointsList = emptyList();
    var color = Colors_getInstance().e41_1;
    var type = Companion_getInstance_14().z6s_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = DebugVertexView.say(pointsList, color, type);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.debug.debugVertexView.<anonymous>' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.text.TextEditController.caret.<anonymous>' call
    this_2.tay(Companion_getInstance_13().f83_1);
    this_2.y8m(false);
    tmp.vao_1 = this_2;
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_31();
    tmp_0.wao_1 = Margin.t28(numberToDouble(3.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    this.mao_1.cs(onNewAttachDetach(this.hao_1, TextEditController$lambda));
    this.uao_1.i1w(this);
    this.xao_1 = new HistoryStack();
    this.yao_1 = color$factory(this.hao_1);
    this.zao_1 = this.lao_1.length;
    this.aap_1 = this.zao_1;
    this.bap_1 = 0;
    var tmp_1 = this;
    tmp_1.cap_1 = TextEditController$acceptTextChange$lambda;
    set_cursor(this.jao_1, Cursor_TEXT_getInstance());
    var tmp_2 = get_timers(this.jao_1);
    // Inline function 'korlibs.time.seconds' call
    var tmp_3 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
    this.mao_1.cs(tmp_2.zay(tmp_3, TextEditController$lambda_0(this)));
    // Inline function 'korlibs.korge.input.newKeys' call
    var this_3 = this.jao_1;
    // Inline function 'kotlin.also' call
    var this_4 = new KeysEvents(this_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.newKeys.<anonymous>' call
    // Inline function 'korlibs.korge.text.TextEditController.<anonymous>' call
    this_4.o9y(TextEditController$slambda_1(this));
    this_4.k9y(TextEditController$slambda_2(this));
    this.mao_1.cs(this_4);
    // Inline function 'korlibs.korge.input.newMouse' call
    var this_5 = this.jao_1;
    // Inline function 'kotlin.also' call
    var this_6 = new MouseEvents(this_5);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.newMouse.<anonymous>' call
    // Inline function 'korlibs.korge.text.TextEditController.<anonymous>' call
    var dragging = {_v: false};
    var tmp0_safe_receiver = this.kao_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.iaw_1 = false;
    }
    this.tao_1.i1w(this);
    this_6.a9z_1.h1w(TextEditController$lambda_1(this));
    this_6.b9z_1.h1w(TextEditController$lambda_2(this));
    this_6.y9y_1.h1w(TextEditController$lambda_3(this, dragging));
    this_6.c9z_1.h1w(TextEditController$lambda_4(this, dragging));
    this_6.d9z_1.h1w(TextEditController$lambda_5(dragging, this));
    this_6.l9z_1.h1w(TextEditController$lambda_6(this, dragging));
    this_6.g9z_1.h1w(TextEditController$lambda_7(dragging, this));
    doubleClick(this_6, TextEditController$lambda_8(this));
    this.mao_1.cs(this_6);
    this.aaz();
  }
  o9x() {
    return this.hao_1.o9x();
  }
  baz(_this__u8e3s4) {
    return this.hao_1;
  }
  hap(value) {
    var snapshot = setTextNoSnapshot$default(this, value);
    if (!(snapshot == null)) {
      this.xao_1.s2n(snapshot);
    }
  }
  b5u() {
    return this.hao_1.b5u();
  }
  dap() {
    var tmp0_safe_receiver = this.xao_1.t2n();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vap(this);
    }
  }
  eap() {
    var tmp0_safe_receiver = this.xao_1.u2n();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vap(this);
    }
  }
  jap(substr) {
    var tmp = withoutRange(this.b5u(), this.gap());
    // Inline function 'kotlin.math.min' call
    var a = this.oap();
    var b = this.sat();
    var tmp$ret$0 = Math.min(a, b);
    this.hap(withInsertion(tmp, tmp$ret$0, substr));
    this.nap(this.map() + substr.length | 0);
  }
  caz(value) {
    this.hao_1.daz(value);
    this.aaz();
  }
  y53() {
    var tmp = this.hao_1.nas_1;
    return isInterface(tmp, Font) ? tmp : THROW_CCE();
  }
  eaz(value) {
    this.hao_1.eaz(value);
    this.aaz();
  }
  faz() {
    return this.hao_1.oas_1;
  }
  uat(value) {
    this.zao_1 = clampIndex(this, value);
    this.aaz();
  }
  oap() {
    return this.zao_1;
  }
  law(value) {
    this.aap_1 = clampIndex(this, value);
    this.aaz();
  }
  sat() {
    return this.aap_1;
  }
  nap(value) {
    var value_0 = clampIndex(this, value);
    this.zao_1 = value_0;
    this.aap_1 = value_0;
    this.aaz();
  }
  map() {
    return this.oap();
  }
  tat(start, end) {
    this.zao_1 = clampIndex(this, start);
    this.aap_1 = clampIndex(this, end);
    this.aaz();
  }
  wap(range) {
    this.tat(range.d2_1, range.e2_1 + 1 | 0);
  }
  kap() {
    this.tat(0, this.b5u().length);
  }
  vat() {
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.sat() - this.oap() | 0;
    return abs(this_0);
  }
  fap() {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.b5u();
    // Inline function 'kotlin.math.min' call
    var a = this.oap();
    var b = this.sat();
    var startIndex = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = this.oap();
    var b_0 = this.sat();
    var endIndex = Math.max(a_0, b_0);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.substring(startIndex, endIndex);
  }
  gaz(value) {
    this.wap(value);
  }
  gap() {
    // Inline function 'kotlin.math.min' call
    var a = this.oap();
    var b = this.sat();
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = this.oap();
    var b_0 = this.sat();
    var tmp$ret$1 = Math.max(a_0, b_0);
    return until(tmp, tmp$ret$1);
  }
  haz(index) {
    var glyphPositions = this.hao_1.iaz().i4z_1;
    if (glyphPositions.g1())
      return Bezier.a3c(Vector2D.h28(), Vector2D.h28());
    // Inline function 'kotlin.math.min' call
    var b = glyphPositions.e1() - 1 | 0;
    var tmp$ret$0 = Math.min(index, b);
    var glyph = glyphPositions.d1(tmp$ret$0);
    return index < glyphPositions.e1() ? glyph.b4z() : glyph.c4z();
  }
  kaw(pos) {
    var glyphPositions = this.hao_1.iaz().i4z_1;
    var index = 0;
    var minDist = Infinity;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!glyphPositions.g1()) {
      var inductionVariable = 0;
      var last = glyphPositions.e1();
      if (inductionVariable <= last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.min' call
          var a = glyphPositions.e1() - 1 | 0;
          var b = n;
          var tmp$ret$1 = Math.min(a, b);
          var glyph = glyphPositions.d1(tmp$ret$1);
          var dist = glyph.f4z(pos);
          if (minDist > dist) {
            minDist = dist;
            index = n >= (glyphPositions.e1() - 1 | 0) && !(dist === 0.0) && glyph.e4z(pos, false) < glyph.e4z(pos, true) ? n + 1 | 0 : n;
          }
        }
         while (!(n === last));
    }
    return index;
  }
  aaz() {
    var range = this.gap();
    var array = new PointArrayList(range.g1() ? 2 : imul(get_length(range) + 1 | 0, 2));
    if (range.g1()) {
      var last = range.d2_1 >= this.b5u().length;
      var caret = this.haz(range.d2_1);
      var sign = last ? -1.0 : +1.0;
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      var this_0 = caret.z38(Companion_getInstance_38().ox_1);
      var scale = 2.0 * sign;
      var normal = Vector2D.w27(this_0.m25_1 * scale, this_0.n25_1 * scale);
      var p0 = caret.q39_1.d2m();
      var p1 = caret.q39_1.e2m();
      array.z2r(p0);
      array.z2r(p1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$1 = Vector2D.w27(p0.m25_1 + normal.m25_1, p0.n25_1 + normal.n25_1);
      array.z2r(tmp$ret$1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$2 = Vector2D.w27(p1.m25_1 + normal.m25_1, p1.n25_1 + normal.n25_1);
      array.z2r(tmp$ret$2);
    } else {
      var inductionVariable = range.d2_1;
      var last_0 = range.e2_1 + 1 | 0;
      if (inductionVariable <= last_0)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var caret_0 = this.haz(n);
          array.z2r(caret_0.q39_1.d2m());
          array.z2r(caret_0.q39_1.e2m());
        }
         while (!(n === last_0));
    }
    this.vao_1.m4h(Colors_getInstance().e41_1);
    this.vao_1.jaz(listOf(array));
    this.vao_1.y8m(get_focused(this));
    this.hao_1.e9x();
  }
  iap(selection, index) {
    if (selection) {
      this.uat(index);
    } else {
      this.nap(index);
    }
  }
  kaz(index, direction, word) {
    var dir = get_sign(direction);
    if (word) {
      var sidx = index + dir | 0;
      var idx = sidx;
      while (true) {
        if (!(0 <= idx ? idx <= (charSequenceLength(this.b5u()) - 1 | 0) : false)) {
          return dir < 0 ? idx - dir | 0 : idx;
        }
        if (!isLetterOrDigit(charSequenceGet(this.b5u(), idx))) {
          return dir < 0 ? idx === sidx ? idx : idx - dir | 0 : idx;
        }
        idx = idx + dir | 0;
      }
    }
    return index + dir | 0;
  }
  qap(index, word) {
    return this.kaz(index, -1, word);
  }
  sap(index, word) {
    return this.kaz(index, 1, word);
  }
  laz() {
    return this.bap_1;
  }
  maz() {
    return true;
  }
  naz(value) {
    var tmp0_safe_receiver = this.kao_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.haw_1 = value;
    }
    if (value) {
      this.vao_1.y8m(true);
      var tmp1_safe_receiver = this.o9x();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_uiFocusManager(tmp1_safe_receiver);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.raz(true, this);
      }
    } else {
      this.vao_1.y8m(false);
      var tmp5_safe_receiver = this.o9x();
      var tmp = tmp5_safe_receiver == null ? null : get_uiFocusedView(tmp5_safe_receiver);
      if (!(!(tmp == null) ? isInterface(tmp, ISoftKeyboardConfig) : false)) {
        var tmp3_safe_receiver = this.o9x();
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : get_uiFocusManager(tmp3_safe_receiver);
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.raz(false, null);
        }
      }
    }
    if (value) {
      this.qao_1.i1w(this);
    } else {
      this.rao_1.i1w(this);
    }
  }
  pap(_this__u8e3s4) {
    return Companion_getInstance_39().iu().fu() ? _this__u8e3s4.u6b_1 : _this__u8e3s4.t6b_1;
  }
  rap(_this__u8e3s4) {
    return _this__u8e3s4.v6b_1 && Companion_getInstance_39().iu().fu();
  }
  lap(_this__u8e3s4) {
    return _this__u8e3s4.z6b();
  }
  f6() {
    set_cursor(this.hao_1, null);
    cancel_0(this.mao_1);
    set_focusable(this.hao_1, null);
  }
}
class TimerComponents {
  constructor(view) {
    this.uay_1 = view;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.vay_1 = ArrayList.h1();
    this.way_1 = IntArrayList.a2k();
    this.xay_1 = IntArrayList.a2k();
    this.yay_1 = null;
  }
  zay(time, callback) {
    return this.uaz(get_fast(time), callback);
  }
  uaz(time, callback) {
    return _interval(this, time, true, callback);
  }
}
class TimerRef {
  constructor(index) {
    this.taz_1 = index;
  }
  toString() {
    return TimerRef__toString_impl_8hh2j7(this.taz_1);
  }
  hashCode() {
    return TimerRef__hashCode_impl_d9ou9o(this.taz_1);
  }
  equals(other) {
    return TimerRef__equals_impl_2fvpr4(this.taz_1, other);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.d1v() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.d1v() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.vaz_1 = view;
    this.waz_1 = vs;
    this.xaz_1 = fastTime;
    this.yaz_1 = easing;
    this.zaz_1 = callback;
    this.ab0_1 = c;
    this.bb0_1 = fastWaitTime;
    this.cb0_1 = autoInvalidate;
    this.db0_1 = Companion_instance_1.c1v();
    var tmp = this;
    var tmp_0;
    if (!equals(this.xaz_1, Companion_instance_1.d1v())) {
      tmp_0 = this.xaz_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.waz_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.d8i_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.eb0_1 = tmp_0;
    this.fb0_1 = false;
    this.gb0_1 = false;
    this.hb0_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.ib0_1 = this.vaz_1.v69(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.ab0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.z17(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.c1v());
  }
  pb0() {
    return get_slow(this.bb0_1);
  }
  qb0() {
    if (this.hb0_1)
      return Unit_instance;
    this.hb0_1 = true;
    var tmp0_safe_receiver = this.ab0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.tc(tmp$ret$0);
    }
  }
  ob0() {
    if (this.gb0_1)
      return Unit_instance;
    this.gb0_1 = true;
    var tmp0_safe_receiver = this.ib0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f6();
    }
    this.ib0_1 = null;
    this.qb0();
  }
  jb0(elapsed) {
    if (equals(elapsed, Companion_instance_1.c1v())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.waz_1;
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).z35();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.waz_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.d1(_unary__edvuaz_0);
      var durationInTween = equals(v.b8i_1, Companion_instance_1.d1v()) ? FastDuration__minus_impl_evs237(this.eb0_1, v.a8i_1) : v.b8i_1;
      var elapsedInTween = get_fastMilliseconds(clamp_1(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.a8i_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7_0(durationInTween, Companion_getInstance().lj_1) <= 0 || FastDuration__compareTo_impl_4fhnj7(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.yaz_1.ix(ratioInTween);
      v.h8i(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.vaz_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.rb0_1 = $this_tween;
    this.sb0_1 = $tc;
    this.tb0_1 = $vs;
    this.ub0_1 = $time;
    this.vb0_1 = $easing;
    this.wb0_1 = $callback;
    this.xb0_1 = $waitTime;
    this.yb0_1 = $autoInvalidate;
  }
  g1o($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_19 = this;
    this.db1_1 = get_UI_DEFAULT_SIZE();
  }
}
class UIButton$slambda {
  constructor($$this$mouse, this$0) {
    this.gbb_1 = $$this$mouse;
    this.hbb_1 = this$0;
  }
  ibb(it, $completion) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    this.gbb_1;
    this.hbb_1.jbb();
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$lambda$slambda {
  constructor($handler, $it) {
    this.zb0_1 = $handler;
    this.ab1_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this), $completion);
  }
}
class UIButton$slambda_0 {
  constructor($$this$mouse, this$0) {
    this.kbb_1 = $$this$mouse;
    this.lbb_1 = this$0;
  }
  ibb(it, $completion) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    this.kbb_1;
    this.lbb_1.mbb();
  }
  vd(p1, $completion) {
    return this.ibb(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$lambda$slambda_0 {
  constructor($handler, $it) {
    this.bb1_1 = $handler;
    this.cb1_1 = $it;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this), $completion);
  }
}
class UIButton$slambda_1 {
  constructor(this$0) {
    this.nbb_1 = this$0;
  }
  h9y(it, $completion) {
    if (get_focused(this.nbb_1)) {
      this.nbb_1.ib8(0.5, 0.5);
    }
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIButton$slambda_2 {
  constructor(this$0, $$this$keys) {
    this.obb_1 = this$0;
    this.pbb_1 = $$this$keys;
  }
  h9y(it, $completion) {
    if (this.obb_1.nb4_1) {
      this.obb_1.fbb();
      this.obb_1.qbb(this.pbb_1.i9y());
    }
  }
  vd(p1, $completion) {
    return this.h9y(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class UIFocusableView extends UIView {
  static sbb(size, cache) {
    size = size === VOID ? Size2D.t26(90, 32) : size;
    cache = cache === VOID ? false : cache;
    var $this = this.kag(size, cache);
    $this.dbb_1 = 0;
    $this.ebb_1 = true;
    return $this;
  }
  baz(_this__u8e3s4) {
    return this;
  }
  laz() {
    return this.dbb_1;
  }
  maz() {
    return this.ebb_1;
  }
  naz(value) {
  }
}
class UIButton extends UIFocusableView {
  static rbb(size, text, icon, richText) {
    Companion_getInstance_45();
    size = size === VOID ? Companion_getInstance_45().db1_1 : size;
    text = text === VOID ? '' : text;
    icon = icon === VOID ? null : icon;
    richText = richText === VOID ? null : richText;
    var $this = this.sbb(size);
    $this.ab4_1 = false;
    $this.bb4_1 = Companion_getInstance_38().sx_1;
    $this.cb4_1 = 6.0;
    $this.db4_1 = MaterialColors_getInstance().g4k_1;
    $this.eb4_1 = MaterialColors_getInstance().h4k_1;
    $this.fb4_1 = MaterialColors_getInstance().i4k_1;
    $this.gb4_1 = Colors_getInstance().r4h('#777777ff');
    $this.hb4_1 = true;
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiMaterialLayer' call
    // Inline function 'kotlin.apply' call
    var this_0 = addTo(UIMaterialLayer.tbb(size), $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIButton.background.<anonymous>' call
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_30();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    this_0.bb8(tmp$ret$0);
    tmp.ib4_1 = this_0;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.textBlock' call
    var text_0 = richText == null ? RichTextData.o5v(text, get_DefaultTtfFontAsBitmap()) : richText;
    var align = Companion_getInstance_3().d50_1;
    var size_0 = Size2D.t26(100, 100);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = TextBlock.fbf(text_0, align, size_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.textBlock.<anonymous>' call
    tmp_0.jb4_1 = addTo(this_1, $this);
    $this.kb4_1 = align$factory($this.jb4_1);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.image' call
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var texture = get_Bitmaps_transparent();
    var anchor = Companion_getInstance_27().n24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Image.qbh(texture, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp_1.lb4_1 = addTo(this_2, $this);
    $this.mb4_1 = false;
    $this.nb4_1 = false;
    var tmp_2 = $this;
    var tmp0_defaultEasing = Companion_getInstance_37().lx_1;
    tmp_2.ob4_1 = animator($this, VOID, VOID, tmp0_defaultEasing, true);
    var tmp_3 = $this;
    var tmp0_defaultEasing_0 = Companion_getInstance_37().lx_1;
    tmp_3.pb4_1 = animator($this, VOID, VOID, tmp0_defaultEasing_0, true);
    $this.qb4_1 = text$factory($this.jb4_1);
    $this.rb4_1 = icon;
    $this.sb4_1 = new Signal();
    singleTouch($this, VOID, VOID, UIButton$lambda($this));
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$mouse = get_mouse($this);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = UIButton$slambda_3($this$mouse, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_4 = over$factory().get($this$mouse);
    tmp_4.b1w(UIButton$lambda_0($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = UIButton$slambda_4($this$mouse, $this);
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_5 = out$factory().get($this$mouse);
    tmp_5.b1w(UIButton$lambda_1($this$mouse, handler_0));
    set_cursor($this, Cursor_HAND_getInstance());
    setInitialState($this);
    $this.tb4_1 = false;
    $this.rbh(false, false, VOID, VOID, true);
    $this.ub4_1 = 0.0;
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.UIButton.<anonymous>' call
    var $this$keys = get_keys($this);
    var tmp_6 = [Key_SPACE_getInstance(), Companion_getInstance_15().z6g_1];
    $this$keys.l9y(tmp_6, UIButton$slambda_5($this));
    var tmp_7 = [Key_SPACE_getInstance(), Companion_getInstance_15().z6g_1];
    $this$keys.n9y(tmp_7, UIButton$slambda_6($this, $this$keys));
    return $this;
  }
  vb4() {
    return !isNaN_0(this.cb4_1) ? this.cb4_1 : _Ratio___get_value__impl__57cli6(this.bb4_1) * _get_halfSide__37ya73(this);
  }
  hb8() {
    return super.hb8();
  }
  mag() {
    setInitialState(this);
  }
  jbb() {
    if (this.mb4_1)
      return Unit_instance;
    this.mb4_1 = true;
    this.rbh(VOID, true);
  }
  mbb() {
    if (!this.mb4_1)
      return Unit_instance;
    this.mb4_1 = false;
    this.rbh(VOID, false);
  }
  ib8(x, y) {
    return this.sbh(Vector2D.w27(x, y));
  }
  sbh(p) {
    if (this.nb4_1)
      return Unit_instance;
    this.nb4_1 = true;
    this.rbh(true, VOID, VOID, p);
  }
  fbb() {
    if (!this.nb4_1)
      return Unit_instance;
    this.nb4_1 = false;
    this.rbh(false);
  }
  qbb(views) {
    get_touch(this).za1(views, this.lam(Vector2D.w27(this.z2i() * 0.5, this.a2j() * 0.5)));
  }
  tbh(down, over, enable, pos, immediate) {
    if (this.hb8() && !(down == null)) {
      if (down) {
        this.ib4_1.vbh(pos);
      } else {
        this.ib4_1.ubh();
      }
    }
    var bgColor = enable === false || !this.hb8() ? this.gb4_1 : over === true ? this.eb4_1 : this.tb4_1 ? this.fb4_1 : this.db4_1;
    if (immediate) {
      this.ib4_1.wbh(bgColor);
    } else {
      // Inline function 'korlibs.korge.tween.get' call
      var this_0 = bgColor$factory(this.ib4_1);
      var tmp = this_0.get();
      var tmp_0 = [new V2(this_0, tmp, new RGBA(bgColor), _interpolateColor$ref(), false)];
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
      tween(this.ob4_1, tmp_0, tmp$ret$1);
    }
  }
  rbh(down, over, enable, pos, immediate, $super) {
    down = down === VOID ? null : down;
    over = over === VOID ? null : over;
    enable = enable === VOID ? null : enable;
    pos = pos === VOID ? Companion_getInstance_29().o25_1 : pos;
    immediate = immediate === VOID ? false : immediate;
    var tmp;
    if ($super === VOID) {
      this.tbh(down, over, enable, pos, immediate);
      tmp = Unit_instance;
    } else {
      tmp = $super.tbh.call(this, down, over, enable, pos, immediate);
    }
    return tmp;
  }
  uag() {
    super.uag();
    this.rbh(VOID, VOID, VOID, VOID, true);
  }
  naz(value) {
    this.rbh(VOID, value);
  }
}
class UIBaseContainer extends UIView {
  static sbn(size) {
    var $this = this.kag(size);
    $this.qbn_1 = false;
    $this.rbn_1 = true;
    return $this;
  }
  raj(view) {
    super.raj(view);
    this.ubn();
  }
  saj(view) {
    super.saj(view);
    this.ubn();
  }
  mag() {
    super.mag();
    this.ubn();
  }
  ubn() {
    if (this.qbn_1)
      return Unit_instance;
    this.qbn_1 = true;
    try {
      this.tbn();
    }finally {
      this.qbn_1 = false;
    }
  }
}
class UIContainer extends UIBaseContainer {
  static vbk(size) {
    return this.sbn(size);
  }
  tbn() {
  }
}
class UIVerticalHorizontalStack extends UIContainer {
  static tbt(size, padding, adjustSize) {
    size = size === VOID ? get_UI_DEFAULT_SIZE() : size;
    padding = padding === VOID ? 0.0 : padding;
    var $this = this.vbk(size);
    $this.rbt_1 = adjustSize;
    $this.sbt_1 = numberToDouble(padding);
    return $this;
  }
}
class UIVerticalStack extends UIVerticalHorizontalStack {
  static ubq(forcedWidth, padding, adjustSize) {
    forcedWidth = forcedWidth === VOID ? null : forcedWidth;
    padding = padding === VOID ? 0.0 : padding;
    adjustSize = adjustSize === VOID ? true : adjustSize;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_28();
    var width = forcedWidth == null ? 100.0 : forcedWidth;
    var tmp$ret$0 = Size2D.l2e(numberToDouble(width), numberToDouble(0.0));
    var $this = this.tbt(tmp$ret$0, padding, adjustSize);
    var tmp = $this;
    tmp.tbq_1 = forcedWidth == null ? null : numberToDouble(forcedWidth);
    return $this;
  }
  tbn() {
    var y = 0.0;
    var bb = Companion_getInstance_32().m26();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naj();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.ui.UIVerticalStack.relayoutInternal.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = tmp0_safe_receiver.d1(_unary__edvuaz);
        it.uak(y);
        if (this.rbt_1 && !(this.tbq_1 == null)) {
          it.oal(this.z2i());
        }
        var bounds = it.r9y();
        y = y + (bounds.g26() + this.sbt_1);
        bb = BoundsBuilder__plus_impl_cz7f7x(bb, it.ean(this));
      }
      tmp = Unit_instance;
    }
    this.pag(Size2D.l2e(this.tbq_1 == null ? _BoundsBuilder___get_xmax__impl__gsz0km(bb) : ensureNotNull(this.tbq_1), y));
  }
}
class UIHorizontalVerticalFill extends UIContainer {
  static pbz(size, padding) {
    size = size === VOID ? Size2D.t26(128, 128) : size;
    padding = padding === VOID ? 0.0 : padding;
    var $this = this.vbk(size);
    $this.obz_1 = padding;
    return $this;
  }
}
class UIVerticalFill extends UIHorizontalVerticalFill {
  static rbw(size, padding) {
    size = size === VOID ? Size2D.t26(128, 128) : size;
    padding = padding === VOID ? 0.0 : padding;
    return this.pbz(size, padding);
  }
  tbn() {
    // Inline function 'korlibs.korge.ui.UIHorizontalVerticalFill._relayoutInternal' call
    var dimension = this.a2j();
    var pos = 0.0;
    var padding = this.obz_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.qaj() - 1 | 0;
    var numSpaces = Math.max(0, b);
    var elementSize = (dimension - numSpaces * padding) / this.qaj();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.naj();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.ui.UIHorizontalVerticalFill._relayoutInternal.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.korge.ui.UIVerticalFill.relayoutInternal.<anonymous>' call
        var it = tmp0_safe_receiver.d1(_unary__edvuaz);
        var pos_0 = pos;
        it.uak(pos_0);
        it.oal(this.z2i());
        it.mal(elementSize);
        pos = pos + (elementSize + padding);
      }
      tmp = Unit_instance;
    }
  }
}
class Scope {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.rbz_1 = function_0;
  }
  ui(a, b) {
    return this.rbz_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  n4() {
    return this.rbz_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class UIFocusManager {
  constructor(view) {
    this.oaz_1 = view;
    this.paz_1 = this.oaz_1;
    this.qaz_1 = null;
    var tmp = Type_DOWN_getInstance_0();
    this.oaz_1.v69(tmp, UIFocusManager$lambda(this));
  }
  qa0() {
    return this.paz_1.qa0();
  }
  tbz() {
    return this.oaz_1.tbz();
  }
  qbz(value) {
    if (equals(this.qaz_1, value))
      return Unit_instance;
    var tmp0_safe_receiver = this.qaz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.naz(false);
    }
    this.qaz_1 = value;
    var tmp1_safe_receiver = this.qaz_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.naz(true);
    }
    if (!(value == null)) {
      this.qa0().ubz(_get_rfocusView__qys03k(value, this), true);
    }
  }
  raz(show, view) {
    if (show) {
      if (view == null)
        null;
      else {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.ui.UIFocusManager.requestToggleSoftKeyboard.<anonymous>' call
        this.tbz().i8m(view.baz(Scope_instance).uam(this.paz_1).k2e());
      }
      var tmp = this.tbz();
      tmp.k8m(VOID, (view == null ? true : isInterface(view, ISoftKeyboardConfig)) ? view : null);
    } else {
      this.tbz().l8m();
    }
  }
  sbz(dir) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = descendantsWith(this.paz_1, VOID, UIFocusManager$changeFocusIndex$lambda);
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      var tmp0_safe_receiver = get_focusable(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    var focusables = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = UIFocusManager$changeFocusIndex$lambda_0;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = sortedWith(focusables, tmp$ret$4);
    var destination_0 = ArrayList.h1();
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      if (element_0.maz()) {
        destination_0.h(element_0);
      }
    }
    var sortedFocusables = destination_0;
    // Inline function 'kotlin.takeIf' call
    var this_2 = indexOf(sortedFocusables, this.qaz_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
    if (this_2 >= 0) {
      tmp_0 = this_2;
    } else {
      tmp_0 = null;
    }
    var index = tmp_0;
    var tmp0_safe_receiver_0 = getCyclicOrNull(sortedFocusables, !(index == null) ? index + dir | 0 : dir < 0 ? -1 : 0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
      focus(tmp0_safe_receiver_0);
      scrollParentsToMakeVisible(_get_rfocusView__qys03k(tmp0_safe_receiver_0, this));
    }
  }
}
class Highlight {
  constructor(pos, radiusRatio, alpha, below, scale) {
    below = below === VOID ? false : below;
    scale = scale === VOID ? 1.0 : scale;
    this.ybz_1 = pos;
    this.zbz_1 = radiusRatio;
    this.ac0_1 = alpha;
    this.bc0_1 = below;
    this.cc0_1 = scale;
  }
}
class Highlights {
  constructor(view) {
    this.vbz_1 = view;
    this.wbz_1 = fastArrayListOf([]);
    this.xbz_1 = fastArrayListOf([]);
  }
  dc0(pos, below, scale, startRadius) {
    this.ubh();
    var highlight = new Highlight(pos, startRadius, 1.0, below, scale);
    // Inline function 'kotlin.collections.plusAssign' call
    this.wbz_1.h(highlight);
    // Inline function 'kotlin.collections.plusAssign' call
    this.xbz_1.h(highlight);
    var tmp = get_simpleAnimator(this.vbz_1);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = radiusRatio$factory(highlight);
    var tmp_0 = this_0.get();
    var tmp_1 = new V2(this_0, tmp_0, 1.0, _interpolate$ref(), false);
    var tmp_2 = [tmp_1, V2Callback(VOID, UIMaterialLayer$Highlights$addHighlight$lambda(this))];
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
    tween(tmp, tmp_2, tmp$ret$1, get_EASE_IN(Companion_getInstance_37()));
    return highlight;
  }
  ec0(highlight) {
    // Inline function 'korlibs.korge.animate.Animator.sequence' call
    var this_0 = get_simpleAnimator(this.vbz_1);
    var defaultTime = this_0.g9x();
    var defaultSpeed = this_0.f9w_1;
    var easing = this_0.g9w_1;
    var startImmediately = this_0.m9w_1;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var tmp0_root = this_0.d9w_1;
    var tmp1_fastDefaultTime = get_fast(defaultTime);
    var tmp2_level = this_0.l9w_1 + 1 | 0;
    var this_1 = new Animator(tmp0_root, tmp1_fastDefaultTime, defaultSpeed, easing, false, false, this_0, VOID, tmp2_level, startImmediately);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.sequence.<anonymous>' call
    // Inline function 'korlibs.korge.ui.Highlights.removeHighlight.<anonymous>' call
    var tmp;
    if (highlight.bc0_1) {
      // Inline function 'korlibs.korge.tween.get' call
      var this_2 = radiusRatio$factory_0(highlight);
      var tmp_0 = this_2.get();
      tmp = new V2(this_2, tmp_0, 0.0, _interpolate$ref_0(), false);
    } else {
      // Inline function 'korlibs.korge.tween.get' call
      var this_3 = alpha$factory(highlight);
      var tmp_1 = this_3.get();
      tmp = new V2(this_3, tmp_1, 0.0, _interpolate$ref_1(), false);
    }
    var tmp_2 = tmp;
    var tmp_3 = [tmp_2, V2Callback(VOID, UIMaterialLayer$Highlights$removeHighlight$lambda(this))];
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
    tween(this_1, tmp_3, tmp$ret$2, get_EASE_IN(Companion_getInstance_37()));
    block(this_1, VOID, UIMaterialLayer$Highlights$removeHighlight$lambda_0(this, highlight));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.sequence.<anonymous>' call
    this_0.i9x(this_1.t9w_1);
    this.xbz_1.m3(highlight);
  }
  fc0(highlights) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = toList_0(highlights);
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.ui.Highlights.removeHighlights.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      this.ec0(it);
    }
  }
  ubh() {
    this.fc0(this.xbz_1);
  }
}
class UIMaterialLayer extends UIView {
  static tbb(size) {
    size = size === VOID ? Size2D.t26(100, 100) : size;
    var $this = this.kag(size);
    $this.qb7_1 = Colors_getInstance().e41_1;
    $this.rb7_1 = null;
    $this.sb7_1 = null;
    $this.tb7_1 = Colors_getInstance().f41_1;
    $this.ub7_1 = 0.0;
    $this.vb7_1 = RGBA__withAf_impl_dpdu32(Colors_getInstance().f41_1, 0.3);
    $this.wb7_1 = 10.0;
    $this.xb7_1 = Companion_getInstance_29().o25_1;
    $this.yb7_1 = RGBA__withAd_impl_cralao(Colors_getInstance().e41_1, 0.4);
    $this.zb7_1 = new Highlights($this);
    $this.ab8_1 = Companion_getInstance_27().n24_1;
    return $this;
  }
  wbh(value) {
    this.qb7_1 = value;
    this.e9x();
  }
  bb8(value) {
    this.rb7_1 = value;
    this.e9x();
  }
  cb8(value) {
    this.wb7_1 = value;
    this.e9x();
  }
  gc0(value) {
    if (!this.ab8_1.equals(value)) {
      this.ab8_1 = value;
      this.dam();
    }
  }
  hak() {
    return this.z2i() * this.ab8_1.w24_1;
  }
  iak() {
    return this.a2j() * this.ab8_1.x24_1;
  }
  sag() {
    return new Rectangle(-this.hak(), -this.iak(), this.z2i(), this.a2j());
  }
  vag(ctx) {
    if (!this.val())
      return Unit_instance;
    // Inline function 'korlibs.korge.render.renderCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var batcher = ctx.o84_1;
    if (!(ctx.s84_1 === batcher)) {
      ctx.s84_1 = batcher;
      ctx.c86();
    }
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
    // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
    var context = ctx.q84_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
    $l$block_3: {
      // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
      var old = context.k8f_1;
      try {
        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
        $l$block_2: {
          // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
          var oldBlendFactors = context.l8f_1;
          try {
            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
              var multiplyColor = context.m8f_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                $l$block_0: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                  var filtering = context.n8f_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    $l$block: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                      var size = context.i8f_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        context.i8f_1 = Size2D.l2e(this.z2i(), this.a2j());
                        context.l8f_1 = this.zal();
                        context.m8f_1 = this.aam();
                        context.o8f(this.t9y());
                        this.hc0(context, true);
                        materialRoundRect(context, -this.hak(), -this.iak(), this.z2i(), this.a2j(), this.qb7_1, _get_computedRadius__cigsus(this), this.xb7_1, this.vb7_1, this.wb7_1, VOID, VOID, VOID, this.ub7_1, this.tb7_1);
                        this.hc0(context, false);
                        break $l$block;
                      }finally {
                        context.i8f_1 = size;
                      }
                    }
                    break $l$block_0;
                  }finally {
                    context.n8f_1 = filtering;
                  }
                }
                break $l$block_1;
              }finally {
                context.m8f_1 = multiplyColor;
              }
            }
            break $l$block_2;
          }finally {
            context.l8f_1 = oldBlendFactors;
          }
        }
        break $l$block_3;
      }finally {
        context.k8f_1 = old;
      }
    }
  }
  hc0(ctx2d, below) {
    // Inline function 'korlibs.korge.ui.Highlights.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.zb7_1.wbz_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.ui.UIMaterialLayer.renderHighlights.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      if (below === it.bc0_1) {
        materialRoundRect(ctx2d, -this.hak() * it.cc0_1, -this.iak() * it.cc0_1, this.z2i() * it.cc0_1, this.a2j() * it.cc0_1, Colors_getInstance().j41_1, _get_computedRadius__cigsus(this).d2e(it.cc0_1), VOID, VOID, VOID, it.ybz_1, it.zbz_1 * this.xak(), RGBA__withAd_impl_cralao(this.yb7_1, _RGBA___get_ad__impl__pt5rdj(this.yb7_1) * it.ac0_1));
      }
    }
  }
  dc0(pos, below, scale, startRadius) {
    return this.zb7_1.dc0(pos, below, scale, startRadius);
  }
  vbh(pos, below, scale, startRadius, $super) {
    below = below === VOID ? false : below;
    scale = scale === VOID ? 1.0 : scale;
    startRadius = startRadius === VOID ? 0.0 : startRadius;
    return $super === VOID ? this.dc0(pos, below, scale, startRadius) : $super.dc0.call(this, pos, below, scale, startRadius);
  }
  ubh() {
    this.zb7_1.ubh();
  }
}
class UIScrollable extends UIView {
  hc3() {
    return this.a2j() * this.gc3_1;
  }
  ic3() {
    return this.z2i() * this.gc3_1;
  }
  jc3() {
    return this.hc3();
  }
  kc3() {
    return this.hc3();
  }
  lc3() {
    return this.ic3();
  }
  mc3() {
    return this.ic3();
  }
  nc3(rect, anchor) {
    this.fc3_1.yc3(rect.d26(), rect.e26(), anchor.w24_1);
    this.ec3_1.yc3(rect.f26(), rect.g26(), anchor.x24_1);
  }
  zc3(view, anchor) {
    this.nc3(view.ean(this), anchor);
    scrollParentsToMakeVisible(this);
  }
  ac4(view, anchor, $super) {
    anchor = anchor === VOID ? Companion_getInstance_27().z24() : anchor;
    var tmp;
    if ($super === VOID) {
      this.zc3(view, anchor);
      tmp = Unit_instance;
    } else {
      tmp = $super.zc3.call(this, view, anchor);
    }
    return tmp;
  }
}
class ViewRenderer {}
class sam$korlibs_korge_view_ViewRenderer$0 {
  constructor(function_0) {
    this.dc4_1 = function_0;
  }
  ec4(_this__u8e3s4) {
    return this.dc4_1(_this__u8e3s4);
  }
  n4() {
    return this.dc4_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ViewRenderer) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class UITextInput extends UIView {
  static qc7(initialText, size) {
    initialText = initialText === VOID ? '' : initialText;
    size = size === VOID ? Size2D.t26(128, 24) : size;
    var $this = this.kag(size);
    $this.zc6_1 = new SoftKeyboardConfig();
    var tmp = $this;
    // Inline function 'korlibs.korge.view.renderableView' call
    var viewRenderer = UITextInput$bg$lambda;
    tmp.ac7_1 = addTo(RenderableView.rc7(size, new sam$korlibs_korge_view_ViewRenderer$0(viewRenderer)), $this);
    $this.bc7_1 = viewRenderer$factory($this.ac7_1);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.clipContainer' call
    var size_0 = Companion_getInstance_28().p2g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = ClipContainer.dca(size_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.clipContainer.<anonymous>' call
    tmp_0.cc7_1 = addTo(this_0, $this);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.text' call
    var this_1 = $this.cc7_1;
    var color = Colors_getInstance().f41_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_3().q4z_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance_26.fca_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Text.gca(initialText, numberToDouble(16.0), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    tmp_1.dc7_1 = addTo(this_2, this_1);
    $this.ec7_1 = new TextEditController($this.dc7_1, $this.dc7_1, $this, $this.ac7_1);
    $this.fc7_1 = text$factory_0($this.ec7_1);
    $this.gc7_1 = textSize$factory($this.ec7_1);
    $this.hc7_1 = font$factory($this.ec7_1);
    $this.ic7_1 = onReturnPressed$factory($this.ec7_1);
    $this.jc7_1 = onEscPressed$factory($this.ec7_1);
    $this.kc7_1 = onFocusLost$factory($this.ec7_1);
    $this.lc7_1 = selectionRange$factory($this.ec7_1);
    $this.mc7_1 = selectionStart$factory($this.ec7_1);
    $this.nc7_1 = selectionEnd$factory($this.ec7_1);
    $this.oc7_1 = selectionLength$factory($this.ec7_1);
    var tmp_2 = $this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_31();
    tmp_2.pc7_1 = Margin.t28(numberToDouble(3.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    $this.mag();
    return $this;
  }
  hap(_set____db54di) {
    var this_0 = this.fc7_1;
    text$factory_1();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  b5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.fc7_1;
    text$factory_2();
    return this_0.get();
  }
  mag() {
    size(this.ac7_1, this.z2i(), this.a2j());
    bounds(this.cc7_1, (new Rectangle(0.0, 0.0, this.z2i(), this.a2j())).y2e(this.pc7_1));
  }
}
class sam$korlibs_korge_view_ViewRenderer$0_0 {
  constructor(function_0) {
    this.hca_1 = function_0;
  }
  ec4(_this__u8e3s4) {
    return this.hca_1(_this__u8e3s4);
  }
  n4() {
    return this.hca_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ViewRenderer) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_20 = this;
    this.db8_1 = 90.0;
    this.eb8_1 = 32.0;
    this.fb8_1 = Size2D.g2e(90.0, 32.0);
  }
  gb8(iconView, bmp, width, height, anchor_0) {
    var iconScaleX = width / bmp.x3f_1;
    var iconScaleY = height / bmp.y3f_1;
    // Inline function 'kotlin.math.min' call
    var iconScale = Math.min(iconScaleX, iconScaleY);
    iconView.acf(bmp);
    anchor(iconView, anchor_0);
    position(iconView, width * anchor_0.w24_1, height * anchor_0.x24_1);
    scale(iconView, iconScale, iconScale);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.tck_1 = 1.0;
    this.uck_1 = 1.0;
    this.vck_1 = 1.0;
    this.wck_1 = 1.0;
    this.xck_1 = 1.0;
    this.yck_1 = MatrixTransform.q2b();
  }
  zck(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.yck_1 = globalMatrix.u2a();
      // Inline function 'kotlin.math.abs' call
      var x = this.yck_1.i2b_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.yck_1.j2b_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.vck_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.wck_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.vck_1 = sx;
        this.wck_1 = sy;
        this.xck_1 = sxy;
        this.tck_1 = 1.0 / sx;
        this.uck_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.vck_1 = 1.0;
      this.wck_1 = 1.0;
      this.xck_1 = 1.0;
      this.tck_1 = 1.0;
      this.uck_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static ncu(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.qcw();
    $this.icn_1 = smoothing;
    $this.xcn(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.jcn_1 = get_Bitmaps_white();
    $this.kcn_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_17();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.lcn_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.mcn_1 = null;
    $this.ncn_1 = null;
    return $this;
  }
  ucn(v) {
    if (!(this.jcn_1 === v)) {
      this.jcn_1 = v;
      this.f9r_1 = true;
      this.e9x();
    }
  }
  gc0(v) {
    if (!this.kcn_1.equals(v)) {
      this.kcn_1 = v;
      this.f9r_1 = true;
      this.e9x();
    }
  }
  ocn() {
    return this.kcn_1;
  }
  gcl() {
    return 0.0;
  }
  hcl() {
    return 0.0;
  }
  hak() {
    return this.ocn().w24_1 * this.gcl();
  }
  iak() {
    return this.ocn().x24_1 * this.hcl();
  }
  pcn() {
    return -this.hak();
  }
  qcn() {
    return -this.iak();
  }
  vag(ctx) {
    if (!this.val())
      return Unit_instance;
    var tmp = this.jcn_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.f9r_1) {
      this.f9r_1 = false;
      this.wcn();
    }
    this.vcn(ctx);
  }
  vcn(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.o84_1;
    var this_1 = this_0.x84_1;
    if (!(this_1.s84_1 === this_0)) {
      this_1.s84_1 = this_0;
      this_1.c86();
    }
    var tmp0_safe_receiver = this.ncn_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.lcn_1;
    var tex = ctx.t8e(this.jcn_1).x3g();
    var smoothing = this.icn_1;
    var blendMode = this.zal();
    var program = this.mcn_1;
    var vcount = array.y8b_1;
    var icount = array.z8b_1;
    var matrix = Companion_getInstance_34().h29_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.y88_1;
      this_0.r8b(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_6().a8b_1 : program;
      if (this_0.g8c(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.i8b();
      if (!contains(this_0.n85_1, tex_0)) {
        this_0.m85_1 = 0;
        this_0.n85_1[0] = tex_0;
      }
      this_0.o85_1 = smoothing;
      this_0.p85_1 = blendMode;
      this_0.q85_1 = pprogram;
    }
    this_0.d8c(array, matrix, vcount, icount);
  }
  wcn() {
    this.lcn_1.g8h(0, this.pcn(), this.qcn(), this.gcl(), this.hcl(), this.t9y(), this.jcn_1, this.aam());
  }
  sag() {
    return Companion_getInstance_33().f2e(this.pcn(), this.qcn(), this.gcl(), this.hcl());
  }
  toString() {
    var out = super.toString();
    if (!this.ocn().equals(Companion_getInstance_27().n24_1))
      out = out + (':anchor=(' + this.kam(this.ocn().w24_1) + ', ' + this.kam(this.ocn().x24_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static ad3(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ncu(anchor, hitShape, smoothing);
    $this.yce_1 = false;
    $this.zce_1 = bitmap;
    $this.rcn();
    return $this;
  }
  static bcl(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.ad3(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  acf(value) {
    if (equals(this.jcn_1, value))
      return Unit_instance;
    this.yce_1 = true;
    this.ucn(value);
  }
  c5m() {
    return this.jcn_1;
  }
  rcn() {
    if (this.yce_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  vag(ctx) {
    this.rcn();
    super.vag(ctx);
  }
  gcl() {
    return this.jcn_1.z2i();
  }
  hcl() {
    return this.jcn_1.a2j();
  }
  u3h() {
    return this.jcn_1.u3h();
  }
  v3h() {
    return this.jcn_1.v3h();
  }
  a3h() {
    return this.jcn_1.a3h();
  }
  b3h() {
    return this.jcn_1.b3h();
  }
  scn() {
    return this.ocn().w24_1 * this.a3h();
  }
  tcn() {
    return this.ocn().x24_1 * this.b3h();
  }
  hak() {
    return this.scn() - this.u3h();
  }
  iak() {
    return this.tcn() - this.v3h();
  }
  sag() {
    return Companion_getInstance_33().f2e(-this.scn(), -this.tcn(), this.a3h(), this.b3h());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.c5m()));
  }
}
class BaseGraphics extends BaseImage {
  static acl(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.bcl(tmp$ret$0);
    $this.cck_1 = autoScaling;
    $this.dck_1 = true;
    $this.eck_1 = false;
    $this.fck_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.gck_1 = ArrayList.h1();
    $this.hck_1 = new InternalViewAutoscaling();
    $this.ick_1 = 1;
    $this.jck_1 = true;
    $this.kck_1 = true;
    $this.lck_1 = null;
    $this.mck_1 = 1.0;
    $this.nck_1 = 1.0;
    $this.ock_1 = true;
    $this.pck_1 = true;
    $this.qck_1 = Companion_getInstance_33().j29();
    $this.rck_1 = Companion_getInstance_33().j29();
    return $this;
  }
  ccl(value) {
    this.dck_1 = value;
    this.dcl();
  }
  dcl() {
    this.jck_1 = true;
    this.kck_1 = true;
    this.dam();
  }
  tag() {
    super.tag();
    if (this.x23() == null || this.o9x() == null) {
      var tmp = this.c5m().x3g();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.gck_1.h(this.c5m().x3g());
      }
      clearBitmaps(this, true);
    }
  }
  vag(ctx) {
    this.lck_1 = ctx;
    clearBitmaps(this, false);
    this.ecl();
    super.vag(ctx);
  }
  ecl() {
    if (this.hck_1.zck(this.cck_1, this.eck_1, this.t9y())) {
      this.jck_1 = true;
    }
    if (!this.jck_1)
      return false;
    this.jck_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.gck_1.h(this.c5m().x3g());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.y25_1 * this.hck_1.vck_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.z25_1 * this.hck_1.wck_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.ick_1 | 0, imageHeight + this.ick_1 | 0, this.dck_1, true);
    this.mck_1 = this.hck_1.vck_1;
    this.nck_1 = this.hck_1.wck_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.b40_1;
    if (true) {
      image.k40();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.t47(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.r5k(this.mck_1, this.nck_1);
        ctx.v53(-boundsWithShapes.w25_1, -boundsWithShapes.x25_1);
        this.fcl(ctx);
      }finally {
        ctx.l18();
      }
    }finally {
      result = true ? image.m40(rect) : 0;
    }
    this.acf(slice(image));
    return true;
  }
  gcl() {
    return _get_bitmapWidth__ndy7bu(this) / this.mck_1;
  }
  hcl() {
    return _get_bitmapHeight__5t1vx1(this) / this.nck_1;
  }
  a3h() {
    return this.gcl();
  }
  b3h() {
    return this.hcl();
  }
  hak() {
    return this.ocn().w24_1 * this.gcl();
  }
  iak() {
    return this.ocn().x24_1 * this.hcl();
  }
  pcn() {
    return _getLocalBoundsInternal(this, this.ock_1).w25_1;
  }
  qcn() {
    return _getLocalBoundsInternal(this, this.ock_1).x25_1;
  }
  sag() {
    return _getLocalBoundsInternal$default(this);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.eco_1 = $outer;
    this.aco_1 = ctx;
    this.bco_1 = this.aco_1.x8e(16, 16, VOID, VOID, VOID, false);
    this.cco_1 = TextureBase.b89(this.bco_1.c6o(), 16, 16);
    this.dco_1 = Texture(this.cco_1);
  }
  fco(width, height) {
    this.bco_1.e6o(0, 0, width, height);
    this.cco_1.c89(width);
    this.cco_1.d89(height);
    this.dco_1 = Texture(this.cco_1);
  }
  f6() {
    this.eco_1.gaj_1 = null;
    this.aco_1.y8e(this.bco_1);
  }
}
class FixedSizeContainer extends Container {
  static rcq(size, clip) {
    size = size === VOID ? Size2D.t26(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.ba7();
    $this.ocq_1 = clip;
    $this.pcq_1 = size;
    $this.qcq_1 = Ref(false);
    return $this;
  }
  v62() {
    return this.ocq_1;
  }
  pag(_set____db54di) {
    this.pcq_1 = _set____db54di;
  }
  qag() {
    return this.pcq_1;
  }
  sag() {
    return new Rectangle(0.0, 0.0, this.z2i(), this.a2j());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.z2i()) + 'x' + get_niceStr(this.a2j()) + ')');
    return out;
  }
  vag(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.v62();
      var renderingInternalRef = this.qcq_1;
      if (renderingInternalRef.u1()) {
        super.vag(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.t9y();
        var hasRotation = !(m.m29_1 === 0.0) || !(m.n29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.u1();
          try {
            renderingInternalRef.j2r(true);
            renderFiltered(this, ctx, Companion_getInstance_61());
          }finally {
            renderingInternalRef.j2r(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.o84_1;
        if (!(ctx.s84_1 === batcher)) {
          ctx.s84_1 = batcher;
          ctx.c86();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.q84_1;
        var bounds = this.wam(ctx).k2f(ctx.e84_1).l2f();
        var rect = c2d.g8f_1.o8b().j6u();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.z2e(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_16().e6u(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.g8f_1;
            var scissor_0 = c2d.t8f(scissor);
            var temp = this_0.v85_1;
            this_0.e8c();
            this_0.v85_1 = scissor_0;
            try {
              super.vag(ctx);
              break $l$block_1;
            }finally {
              this_0.e8c();
              this_0.v85_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.vag(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.vag(ctx);
      }
    }
  }
}
class ClipContainer extends FixedSizeContainer {
  static dca(size) {
    size = size === VOID ? Size2D.t26(100, 100) : size;
    return this.rcq(size, true);
  }
}
class ZIndexComparator {
  scq(a, b) {
    return compareTo(a.vak(), b.vak());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.scq(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.xcq_1 = this$0;
    this.wcq_1 = 0;
  }
  b1() {
    return this.wcq_1 < this.xcq_1.vcq_1.qaj();
  }
  c1() {
    var _unary__edvuaz = this.wcq_1;
    this.wcq_1 = _unary__edvuaz + 1 | 0;
    return this.xcq_1.vcq_1.taj(_unary__edvuaz);
  }
  j6() {
    this.wcq_1 = this.wcq_1 - 1 | 0;
    this.xcq_1.vcq_1.uaj(this.wcq_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.ucq_1 = children;
    this.vcq_1 = container;
  }
  e1() {
    return this.vcq_1.qaj();
  }
  ycq(element) {
    return element.x23() === this.vcq_1;
  }
  z2(element) {
    if (!(element instanceof View))
      return false;
    return this.ycq(element instanceof View ? element : THROW_CCE());
  }
  zcq(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.x23() === this.vcq_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  a3(elements) {
    return this.zcq(elements);
  }
  g1() {
    return this.vcq_1.qaj() === 0;
  }
  acr(element) {
    this.vcq_1.xaj(element);
    return true;
  }
  h(element) {
    return this.acr(element instanceof View ? element : THROW_CCE());
  }
  bcr(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.vcq_1.xaj(element);
    }
    return true;
  }
  f1(elements) {
    return this.bcr(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
  ccr(element) {
    return this.vcq_1.fak(element);
  }
  m3(element) {
    if (!(element instanceof View))
      return false;
    return this.ccr(element instanceof View ? element : THROW_CCE());
  }
  d1(index) {
    return this.ucq_1.d1(index);
  }
  dcr(element) {
    return this.ucq_1.l1(element);
  }
  l1(element) {
    if (!(element instanceof View))
      return -1;
    return this.dcr(element instanceof View ? element : THROW_CCE());
  }
  b3() {
    return this.ucq_1.b3();
  }
  i1(index) {
    return this.ucq_1.i1(index);
  }
  c3(fromIndex, toIndex) {
    return this.ucq_1.c3(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static kcu(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.acl(autoScaling);
    $this.ccu_1 = 0;
    $this.dcu_1 = null;
    $this.ecu_1 = true;
    $this.fcu_1 = -1;
    $this.gcu_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.hcu_1 = ArrayList.h1();
    $this.icu_1 = null;
    $this.jcu_1 = null;
    $this.p9r_1 = true;
    return $this;
  }
  lcu(value) {
    this.dcu_1 = value;
    this.ccu_1 = this.ccu_1 + 1 | 0;
    this.dcl();
  }
  xcn(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.jcu_1 = tmp_0;
  }
  jak() {
    var tmp0_safe_receiver = this.kak();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  kak() {
    if (!(this.jcu_1 == null))
      return this.jcu_1;
    if (!(this.fcu_1 === this.ccu_1)) {
      this.fcu_1 = this.ccu_1;
      this.hcu_1.l3();
      var tmp = this.hcu_1;
      var tmp0_safe_receiver = this.dcu_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h55();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.hcu_1;
  }
  fcl(ctx) {
    var tmp0_safe_receiver = this.dcu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o54(ctx);
    }
  }
  sck(includeStrokes) {
    var tmp0_safe_receiver = this.dcu_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n62(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_33().i26_1 : tmp1_elvis_lhs;
  }
}
class CustomContextRenderizableView extends RectBase {
  static mcu(size) {
    var $this = this.ncu();
    $this.occ_1 = size;
    return $this;
  }
  pag(value) {
    if (!this.occ_1.equals(value)) {
      this.occ_1 = value;
      this.f9r_1 = true;
    }
  }
  qag() {
    return this.occ_1;
  }
  rcc() {
    var tmp = this.qcc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('ctx2d');
    }
  }
  vag(ctx) {
    if (!this.val())
      return Unit_instance;
    this.pcc_1 = ctx;
    // Inline function 'korlibs.korge.render.renderCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var batcher = ctx.o84_1;
    if (!(ctx.s84_1 === batcher)) {
      ctx.s84_1 = batcher;
      ctx.c86();
    }
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
    // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
    var context = ctx.q84_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
    $l$block_3: {
      // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
      var old = context.k8f_1;
      try {
        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
        $l$block_2: {
          // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
          var oldBlendFactors = context.l8f_1;
          try {
            // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
              var multiplyColor = context.m8f_1;
              try {
                // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                $l$block_0: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                  var filtering = context.n8f_1;
                  try {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    $l$block: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                      var size = context.i8f_1;
                      try {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        context.i8f_1 = Size2D.l2e(this.z2i(), this.a2j());
                        context.l8f_1 = this.zal();
                        context.m8f_1 = this.aam();
                        context.o8f(this.t9y());
                        this.qcc_1 = context;
                        this.ocu(context, Size2D.l2e(this.z2i(), this.a2j()));
                        break $l$block;
                      }finally {
                        context.i8f_1 = size;
                      }
                    }
                    break $l$block_0;
                  }finally {
                    context.n8f_1 = filtering;
                  }
                }
                break $l$block_1;
              }finally {
                context.m8f_1 = multiplyColor;
              }
            }
            break $l$block_2;
          }finally {
            context.l8f_1 = oldBlendFactors;
          }
        }
        break $l$block_3;
      }finally {
        context.k8f_1 = old;
      }
    }
  }
}
class DummyView extends View {
  static pcw() {
    return this.qcw();
  }
  vag(ctx) {
    return Unit_instance;
  }
}
class Companion_6 {}
class SContainer extends FixedSizeContainer {
  static pa9(size, clip) {
    size = size === VOID ? Size2D.t26(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.rcq(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.scw_1 = capacity;
    this.tcw_1 = IntDeque.t2m(this.scw_1);
    this.ucw_1 = 0;
  }
  e1() {
    return this.tcw_1.e1();
  }
  vcw() {
    return this.tcw_1.e1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.ucw_1 / this.tcw_1.e1());
  }
  wcw() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.vcw());
  }
  xcw(index) {
    return get_fastMicroseconds_0(this.tcw_1.d1(index));
  }
  ycw(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.tcw_1.y2m(intValue);
    this.ucw_1 = this.ucw_1 + intValue | 0;
    if (this.tcw_1.e1() > this.scw_1) {
      this.ucw_1 = this.ucw_1 - this.tcw_1.qk() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static rd2(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.ba7();
    $this.hcz_1 = null;
    $this.icz_1 = null;
    $this.jcz_1 = true;
    $this.kcz_1 = false;
    $this.lcz_1 = true;
    $this.mcz_1 = true;
    $this.ncz_1 = EmptyShape_instance;
    $this.ocz_1 = renderer;
    $this.pd2(shape);
    return $this;
  }
  sd2() {
    var tmp0_elvis_lhs = this.hcz_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.icz_1 : tmp0_elvis_lhs);
  }
  gc0(value) {
    _get_anchorable__ebfoik(this).gc0(value);
    this.e9x();
  }
  hak() {
    return this.sd2().hak();
  }
  iak() {
    return this.sd2().iak();
  }
  td2(value) {
    if (this.lcz_1 === value)
      return Unit_instance;
    this.lcz_1 = value;
    var tmp0_safe_receiver = this.hcz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.icn_1 = value;
    }
    var tmp1_safe_receiver = this.icz_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.rd1_1 = value;
    }
    this.e9x();
  }
  ud2(value) {
    if (this.mcz_1 === value)
      return Unit_instance;
    this.mcz_1 = value;
    var tmp0_safe_receiver = this.hcz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cck_1 = value;
    }
    var tmp1_safe_receiver = this.icz_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.pd1_1 = value;
    }
    this.e9x();
  }
  pd2(value) {
    if (this.ncz_1 === value)
      return Unit_instance;
    this.ncz_1 = value;
    ensure_0(this);
    var tmp0_safe_receiver = this.hcz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.lcu(value);
    }
    var tmp1_safe_receiver = this.icz_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.pd2(value);
    }
    this.e9x();
  }
  vd2() {
    ensure_0(this);
    var tmp0_safe_receiver = this.hcz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dcl();
    }
    var tmp1_safe_receiver = this.hcz_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.ecl();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.a9o_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.cd3(views, currentVfs, sourceFile, $completion) : $super.cd3.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static zd2(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ad3(bitmap, anchor, hitShape, smoothing);
    $this.obh_1 = new Mixin_0();
    $this.pbh_1 = sourceFile$factory($this);
    return $this;
  }
  static qbh(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.zd2(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  vag(ctx) {
    this.bd3(ctx, this);
    super.vag(ctx);
  }
  cd3(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  ed3(_set____db54di) {
    this.obh_1.xd2_1 = _set____db54di;
  }
  fd3(_set____db54di) {
    this.obh_1.fd3(_set____db54di);
  }
  gd3() {
    return this.obh_1.yd2_1;
  }
  wd2(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  bd3(ctx, view) {
    this.obh_1.bd3(ctx, view);
  }
}
class RenderableView extends CustomContextRenderizableView {
  static rc7(size, viewRenderer) {
    var $this = this.mcu(size);
    $this.gaw_1 = viewRenderer;
    $this.haw_1 = false;
    $this.iaw_1 = false;
    $this.jaw_1 = false;
    return $this;
  }
  ocu(context, size) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.RenderableView.renderer.<anonymous>' call
    this.gaw_1.ec4(this);
  }
}
class Companion_7 {}
class Companion_8 {}
class SolidRect extends RectBase {
  static pd5(size, color) {
    color = color === VOID ? Colors_getInstance().e41_1 : color;
    var $this = this.ncu();
    $this.od5_1 = size;
    $this.m4h(color);
    return $this;
  }
  pag(value) {
    if (this.od5_1.equals(value))
      return Unit_instance;
    this.od5_1 = value;
    this.f9r_1 = true;
    this.e9x();
  }
  qag() {
    return this.od5_1;
  }
  gcl() {
    return this.z2i();
  }
  hcl() {
    return this.a2j();
  }
}
class Sprite extends BaseImage {
  static ud8(bitmap, anchor, hitShape, smoothing) {
    var tmp;
    if (bitmap === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bitmap;
    }
    bitmap = tmp;
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.bcl(bitmap, anchor, hitShape, smoothing);
    $this.yd7_1 = false;
    $this.zd7_1 = 0;
    $this.ad8_1 = 0;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    tmp_0.bd8_1 = _AnimationType___init__impl__l3ftd1(0);
    $this.cd8_1 = null;
    $this.dd8_1 = null;
    $this.ed8_1 = null;
    $this.fd8_1 = null;
    $this.gd8_1 = get_fastMilliseconds_0(50);
    $this.hd8_1 = false;
    $this.id8_1 = get_fastSeconds(0);
    $this.jd8_1 = get_fastSeconds(0);
    $this.kd8_1 = null;
    $this.ld8_1 = 0;
    $this.md8_1 = false;
    addFastUpdater_0($this, Sprite$lambda);
    return $this;
  }
  static vd8(initialAnimation, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().n24_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ud8(initialAnimation.wd8(), anchor, hitShape, smoothing);
    $this.kd8_1 = initialAnimation;
    $this.xd8(0);
    return $this;
  }
  pd8() {
    if (this.cd8_1 == null)
      this.cd8_1 = new Signal();
    return ensureNotNull(this.cd8_1);
  }
  od8() {
    if (this.dd8_1 == null)
      this.dd8_1 = new Signal();
    return ensureNotNull(this.dd8_1);
  }
  nd8() {
    this.yd7_1 = false;
    triggerEvent(this, this.dd8_1);
  }
  qd8() {
    var tmp0_elvis_lhs = this.kd8_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ca = tmp;
    return ca.e1();
  }
  xd8(index) {
    _set_currentSpriteIndex__7b2y7x(this, index);
  }
}
class Companion_9 {}
class Companion_10 {}
class SpriteAnimation {
  constructor(sprites, fastDefaultTimePerFrame) {
    fastDefaultTimePerFrame = fastDefaultTimePerFrame === VOID ? Companion_instance_1.d1v() : fastDefaultTimePerFrame;
    this.rd8_1 = sprites;
    this.sd8_1 = fastDefaultTimePerFrame;
  }
  wd8() {
    return this.rd8_1.d1(0);
  }
  td8(index) {
    return this.rd8_1.d1(umod(index, this.rd8_1.e1()));
  }
  yd8(element) {
    return this.rd8_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof RectSlice))
      return false;
    return this.yd8(element instanceof RectSlice ? element : THROW_CCE());
  }
  zd8(elements) {
    return this.rd8_1.a3(elements);
  }
  a3(elements) {
    return this.zd8(elements);
  }
  g1() {
    return this.rd8_1.g1();
  }
  a1() {
    return this.rd8_1.a1();
  }
  e1() {
    return this.rd8_1.e1();
  }
}
class Stage extends FixedSizeContainer {
  static o9m(views) {
    var $this = this.rcq();
    $this.k9m_1 = views.n9n_1;
    $this.l9m_1 = views;
    $this.m9m_1 = clipBorders$factory($this.qa0());
    $this.n9m_1 = virtualSizeDouble$factory($this.qa0());
    $this.mak($this);
    $this.oak($this);
    return $this;
  }
  qa0() {
    return this.l9m_1;
  }
  ad9(_set____db54di) {
    var this_0 = this.m9m_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  v62() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m9m_1;
    clip$factory_0();
    return this_0.get();
  }
  pag(_set____db54di) {
    var this_0 = this.n9m_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  qag() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n9m_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  pa4() {
    return this.qa0().f9n_1;
  }
  tbz() {
    return this.qa0().j9n_1;
  }
  o9x() {
    return this;
  }
  laj() {
    return this;
  }
  v87() {
    return this.bam(this.qa0());
  }
  maj(view) {
    this.qa0().maj(view);
  }
  toString() {
    return 'Stage';
  }
  b15() {
    return this.l9m_1.d9n_1;
  }
  l8d(pos) {
    return this.k9m_1.l8d(pos);
  }
  a8d(value) {
    this.k9m_1.a8d(value);
  }
  b8d() {
    return this.k9m_1.b8d();
  }
  c8d(value) {
    this.k9m_1.c8d(value);
  }
  d8d() {
    return this.k9m_1.d8d();
  }
  e8d(value) {
    this.k9m_1.e8d(value);
  }
  f8d() {
    return this.k9m_1.f8d();
  }
  g8d(value) {
    this.k9m_1.g8d(value);
  }
  h8d() {
    return this.k9m_1.h8d();
  }
  i8d(value) {
    this.k9m_1.i8d(value);
  }
  j8d() {
    return this.k9m_1.j8d();
  }
  k8d() {
    return this.k9m_1.k8d();
  }
}
class Companion_11 {
  constructor() {
    this.eca_1 = 16.0;
    this.fca_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.dd9_1 = this$0;
    this.ed9_1 = $ctx;
    this.fd9_1 = $fontSource;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this), $completion);
  }
}
class IText {}
class Text extends Container {
  static gca(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_26.eca_1 : textSize;
    color = color === VOID ? Colors_getInstance().e41_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().q4z_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_26.fca_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.ba7();
    $this.fas_1 = true;
    $this.gas_1 = -1;
    $this.has_1 = -1;
    $this.ias_1 = 0;
    $this.jas_1 = 0;
    $this.kas_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.las_1 = fill == null ? new RGBA(color) : fill;
    $this.mas_1 = stroke;
    $this.nas_1 = font;
    $this.oas_1 = numberToDouble(textSize);
    $this.pas_1 = textSize$factory_0($this);
    $this.qas_1 = 0;
    $this.ras_1 = 2147483647;
    $this.sas_1 = renderer;
    $this.tas_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.ba7(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.uas_1 = addTo(this_0, $this);
    $this.vas_1 = new Text2TextRendererActions();
    $this.was_1 = false;
    $this.xas_1 = autoScaling;
    $this.yas_1 = false;
    $this.zas_1 = null;
    $this.aat_1 = Companion_getInstance_33().e2e(0, 0, 2048, 2048);
    $this.bat_1 = true;
    $this.cat_1 = -1;
    $this.dat_1 = new MMatrix();
    $this.eat_1 = -1;
    $this.fat_1 = null;
    $this.gat_1 = new Entry();
    $this.hat_1 = new FontMetrics();
    $this.iat_1 = new TextMetrics();
    $this.jat_1 = null;
    $this.kat_1 = null;
    $this.lat_1 = null;
    $this.mat_1 = null;
    $this.nat_1 = new MMatrix();
    $this.oat_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.pat_1 = true;
    $this.qat_1 = null;
    $this.rat_1 = fontSource$factory($this);
    return $this;
  }
  hap(value) {
    if (!(this.kas_1 === value)) {
      this.kas_1 = value;
      updateLineCount(this);
      this.oaj();
      this.e9x();
    }
  }
  b5u() {
    return this.kas_1;
  }
  id9(value) {
    if (!equals(this.las_1, value)) {
      this.las_1 = value;
      this.oaj();
    }
  }
  saz(value) {
    this.id9(new RGBA(value));
  }
  m5h() {
    var tmp = this.las_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.t4h_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().e41_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  daz(value) {
    if (!equals(this.nas_1, value)) {
      this.nas_1 = value;
      this.oaj();
    }
  }
  eaz(value) {
    if (!(this.oas_1 === value)) {
      this.oas_1 = value;
      this.oaj();
    }
  }
  jd9(_set____db54di) {
    var this_0 = this.pas_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  n4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.pas_1;
    fontSize$factory_0();
    return this_0.get();
  }
  oaj() {
    this.ias_1 = this.ias_1 + 1 | 0;
    super.oaj();
  }
  f61() {
    return this.tas_1.i51_1;
  }
  z5x() {
    return this.tas_1.j51_1;
  }
  hd9(value) {
    this.zas_1 = value;
    this.was_1 = false;
    this.oaj();
  }
  gd9(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  sag() {
    this.kd9(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.sag();
    } else {
      return this.aat_1;
    }
  }
  vag(ctx) {
    this.kd9(ctx);
    var tva = this.mat_1;
    if (!(tva == null)) {
      this.dat_1.b3r(this.t9y());
      this.dat_1.c3r(this.uas_1.a6e(), this.uas_1.b6e());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.o84_1;
      var this_1 = this_0.x84_1;
      if (!(this_1.s84_1 === this_0)) {
        this_1.s84_1 = this_0;
        this_1.c86();
      }
      var tmp = this.nas_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.s4s();
      this_0.i8c(tex, this.fas_1, this.zal(), get_agProgram(bmpfont), tva.z8b_1, tva.y8b_1);
      this_0.d8c(tva, this.dat_1.k2e());
    } else {
      super.vag(ctx);
    }
  }
  iaz() {
    this.kd9(null);
    if (!(this.eat_1 === this.ias_1)) {
      this.eat_1 = this.ias_1;
      var tmp = this;
      var tmp0_safe_receiver = this.nas_1.dz();
      tmp.fat_1 = tmp0_safe_receiver == null ? null : getTextBoundsWithGlyphs(tmp0_safe_receiver, this.n4s(), this.b5u(), this.sas_1, this.tas_1);
    }
    var tmp1_elvis_lhs = this.fat_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Must ensure font is resolved before calling getGlyphMetrics';
      throw IllegalStateException.z4(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  kd9(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.zas_1;
      if (!this.was_1 && !(fontSource == null)) {
        this.was_1 = true;
        launchImmediately_0(ctx.u83_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.nas_1.dz();
    var tmp;
    var tmp_0;
    if (this.bat_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.cat_1 === this.ias_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.cat_1 = this.ias_1;
      var metrics = getTextBounds(font, this.oas_1, this.b5u(), this.iat_1, this.sas_1, this.tas_1);
      this.aat_1 = new Rectangle(metrics.d26(), VerticalAlign__getOffsetY_impl_iso0y6(this.tas_1.j51_1, metrics.a2j(), -metrics.q51()), metrics.z2i(), font.w4s(this.oas_1, this.hat_1).o4s() * this.jas_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.sas_1.s5w();
        if (!(this.kat_1 === this.fas_1) || !(this.gas_1 === this.ias_1) || !(this.has_1 === rversion)) {
          this.kat_1 = this.fas_1;
          this.has_1 = rversion;
          this.gas_1 = this.ias_1;
          if (!(this.qat_1 == null)) {
            this.qat_1 = null;
            this.uas_1.waj();
          }
          this.vas_1.d5y();
          this.vas_1.q5x_1 = Companion_getInstance_3().u4z_1;
          invoke_0(this.sas_1, this.vas_1, this.b5u(), this.oas_1, font);
          while (this.uas_1.qaj() < this.vas_1.e1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.uas_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_27().n24_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.qbh(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.uas_1.qaj() > this.vas_1.e1()) {
            this.uas_1.d1(this.uas_1.qaj() - 1 | 0).qam();
          }
          var bounds = this.vas_1.h3a();
          var firstBounds = this.vas_1.b5y(0);
          var lineInfos = this.vas_1.a5y();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.z5w_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.y25_1;
          var textHeight = bounds.z25_1;
          var dx = this.bat_1 ? this.aat_1.w25_1 : this.aat_1.w25_1 + 1 + (this.aat_1.y25_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.f61());
          var tmp_2;
          if (this.bat_1) {
            tmp_2 = this.aat_1.x25_1 + firstLineInfos.x5w_1;
          } else {
            var tmp2_subject = this.z5x();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_4().m5w_1) ? this.aat_1.x25_1 : this.aat_1.x25_1 + firstLineInfos.x5w_1 + (this.aat_1.z25_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.z5x());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.vas_1.e1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.vas_1.c5y(n, this.gat_1);
              var tmp_3 = this.uas_1.d1(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.mcn_1 = program;
              it.m4h(this.m5h());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.a25(numberToDouble(0), numberToDouble(0)));
              it.icn_1 = this.fas_1;
              it.acf(entry.a5x_1);
              it.b54(Vector2D.w27(entry.b5x_1 + dx, entry.c5x_1 + dy));
              it.cal(Scale.q2d(entry.d5x_1, entry.e5x_1));
              it.gal(entry.f5x_1);
              var containsLower = this.qas_1;
              it.y8m(n < this.ras_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.kat_1 === this.fas_1) || !(this.lat_1 === this.pat_1)) {
          this.ias_1 = this.ias_1 + 1 | 0;
          this.lat_1 = this.pat_1;
          this.jat_1 = this.xas_1;
          this.kat_1 = this.fas_1;
        }
        if (!(this.gas_1 === this.ias_1)) {
          this.gas_1 = this.ias_1;
          var realTextSize = this.oas_1;
          if (this.qat_1 == null) {
            this.uas_1.waj();
            var tmp_4 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.uas_1;
            var renderer = this.oat_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.rd2(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).n4y();
            this_3.pd2(tmp$ret$10);
            this_3.vd2();
            tmp_4.qat_1 = this_3;
            var tmp3_safe_receiver = this.qat_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.ud2(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.qat_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.b5u();
          var tmp1_pos = Companion_getInstance_29().o25_1;
          var tmp2_paint = this.m5h();
          var tmp3_renderer = this.sas_1;
          var tmp4_align = this.tas_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.las_1;
          var tmp7_stroke = this.mas_1;
          var tmp8_textRangeStart = this.qas_1;
          var tmp9_textRangeEnd = this.ras_1;
          result_0 = this_5.z5v(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.n4y();
          this_4.pd2(tmp$ret$16);
          var metrics_0 = result_0;
          this.eat_1 = this.ias_1;
          this.fat_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_29().o25_1, font.w4s(this.n4s(), this.hat_1).a4t_1);
        }
        var tmp4_safe_receiver = this.qat_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.td2(this.fas_1);
        }
      }
    }
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_27 = this;
    this.ld9_1 = until(0, 2147483647);
  }
}
class TextBlock extends UIView {
  static fbf(text, align, size) {
    Companion_getInstance_53();
    var tmp;
    if (text === VOID) {
      var tmp0_font = get_DefaultTtfFontAsBitmap();
      tmp = RichTextData.o5v('', tmp0_font, 16.0);
    } else {
      tmp = text;
    }
    text = tmp;
    align = align === VOID ? Companion_getInstance_3().q4z_1 : align;
    size = size === VOID ? Size2D.t26(100, 100) : size;
    var $this = this.kag(size);
    $this.obe_1 = true;
    $this.pbe_1 = text;
    $this.qbe_1 = align;
    $this.rbe_1 = false;
    $this.sbe_1 = true;
    $this.tbe_1 = new RGBA($this.r4g());
    $this.ube_1 = null;
    $this.vbe_1 = true;
    $this.wbe_1 = '...';
    $this.xbe_1 = Companion_getInstance_31().o28_1;
    $this.ybe_1 = false;
    $this.zbe_1 = 0;
    $this.abf_1 = 2147483647;
    $this.bbf_1 = true;
    $this.cbf_1 = null;
    $this.dbf_1 = null;
    invalidateText($this);
    $this.ebf_1 = null;
    return $this;
  }
  ybh(value) {
    if (!this.pbe_1.equals(value)) {
      this.pbe_1 = value;
      invalidateText(this);
    }
  }
  xbh(value) {
    if (!this.qbe_1.equals(value)) {
      this.qbe_1 = value;
      invalidProps(this);
    }
  }
  mag() {
    invalidProps(this);
  }
  vag(ctx) {
    if (_get_allBitmap__bdn8f(this) === true) {
      if (this.obe_1 || this.ebf_1 == null) {
        this.obe_1 = false;
        this.ebf_1 = place(this.pbe_1, new Rectangle(this.xbe_1.s28_1, this.xbe_1.p28_1, this.z2i() - this.xbe_1.q28_1, this.a2j() - this.xbe_1.r28_1), this.vbe_1, this.rbe_1, this.wbe_1, this.tbe_1, this.ube_1, this.qbe_1, this.sbe_1);
      }
      var tmp0_safe_receiver = this.cbf_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.qam();
      }
      this.cbf_1 = null;
      // Inline function 'korlibs.korge.render.renderCtx2d' call
      // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var batcher = ctx.o84_1;
      if (!(ctx.s84_1 === batcher)) {
        ctx.s84_1 = batcher;
        ctx.c86();
      }
      // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
      // Inline function 'korlibs.korge.render.renderCtx2d.<anonymous>' call
      var context = ctx.q84_1;
      // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
      $l$block_3: {
        // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
        var old = context.k8f_1;
        try {
          // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>' call
          $l$block_2: {
            // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
            var oldBlendFactors = context.l8f_1;
            try {
              // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>' call
              $l$block_1: {
                // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
                var multiplyColor = context.m8f_1;
                try {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>' call
                  $l$block_0: {
                    // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                    var filtering = context.n8f_1;
                    try {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      $l$block: {
                        // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                        var size = context.i8f_1;
                        try {
                          // Inline function 'korlibs.korge.render.RenderContext2D.keep.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                          context.i8f_1 = Size2D.l2e(this.z2i(), this.a2j());
                          context.l8f_1 = this.zal();
                          context.m8f_1 = this.aam();
                          context.o8f(this.t9y());
                          drawText_0(context, ensureNotNull(this.ebf_1), this.zbe_1, this.abf_1, this.bbf_1);
                          break $l$block;
                        }finally {
                          context.i8f_1 = size;
                        }
                      }
                      break $l$block_0;
                    }finally {
                      context.n8f_1 = filtering;
                    }
                  }
                  break $l$block_1;
                }finally {
                  context.m8f_1 = multiplyColor;
                }
              }
              break $l$block_2;
            }finally {
              context.l8f_1 = oldBlendFactors;
            }
          }
          break $l$block_3;
        }finally {
          context.k8f_1 = old;
        }
      }
    } else {
      ensureTexture(this);
    }
    super.vag(ctx);
  }
}
class ColorReference {}
class Companion_13 {
  md9(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x23();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x23();
      }
    }
    return null;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.nd9_1 = function_0;
  }
  ui(a, b) {
    return this.nd9_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  n4() {
    return this.nd9_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.n4(), other.n4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4());
  }
}
class ViewRenderPhase {}
function get_priority() {
  return 0;
}
function render_0(view, ctx) {
  return view.iam(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.xd9_1 = $view;
    this.yd9_1 = $ctx;
    this.zd9_1 = this$0;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.xd2_1 = true;
    this.yd2_1 = null;
  }
  ed3(_set____db54di) {
    this.xd2_1 = _set____db54di;
  }
  fd3(value) {
    this.xd2_1 = false;
    this.yd2_1 = value;
  }
  wd2(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.fd3(sourceFile);
    _this__u8e3s4.ed3(true);
  }
  cd3(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.td('An operation is not implemented: ' + reason);
  }
  bd3(ctx, view) {
    if (this.xd2_1)
      return Unit_instance;
    this.ada(ctx, view);
  }
  ada(ctx, view) {
    if (!this.xd2_1 && !(this.yd2_1 == null)) {
      this.xd2_1 = true;
      launchImmediately_0(ctx.u83_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.bda_1 = this$0;
  }
  ud($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_24.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static c9v(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().t8a_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.t69();
    $this.c9n_1 = new Mixin();
    $this.d9n_1 = coroutineContext;
    $this.e9n_1 = ag;
    $this.f9n_1 = injector;
    $this.g9n_1 = input;
    $this.h9n_1 = timeProvider;
    $this.i9n_1 = stats;
    $this.j9n_1 = gameWindow;
    $this.k9n_1 = gameId;
    $this.l9n_1 = settingsFolder;
    $this.m9n_1 = batchMaxQuads;
    $this.n9n_1 = bp;
    $this.o9n_1 = stageBuilder;
    $this.p9n_1 = quality$factory($this.j9n_1);
    $this.q9n_1 = $this;
    $this.r9n_1 = false;
    $this.s9n_1 = continuousRenderMode$factory($this.j9n_1);
    $this.t9n_1 = new ReshapeEvent(0, 0);
    $this.u9n_1 = new UpdateEvent();
    $this.v9n_1 = new ViewsUpdateEvent($this);
    $this.w9n_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.x9n_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.z9n_1 = null;
    $this.a9o_1 = get_resourcesVfs();
    $this.b9o_1 = get_RegisteredImageFormats();
    $this.c9o_1 = new RenderContext($this.e9n_1, $this, $this.j9n_1, $this.i9n_1, $this.d9n_1, $this.m9n_1, $this.j9n_1);
    $this.d9o_1 = true;
    $this.e9o_1 = Colors_getInstance().f41_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.f9o_1 = HashMap.l8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.g9o_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.h9o_1 = new Resources($this.d9n_1, $this.a9o_1);
    $this.i9o_1 = false;
    $this.j9o_1 = 1280;
    $this.k9o_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.l9o_1 = ArrayList.h1();
    $this.m9o_1 = Companion_getInstance_26().i2g_1;
    $this.n9o_1 = Companion_getInstance_27().r24_1;
    $this.o9o_1 = true;
    $this.p9o_1 = $this.o9n_1($this);
    $this.q9o_1 = $this.p9o_1;
    $this.r9o_1 = true;
    $this.s9o_1 = false;
    $this.t9o_1 = debugExtraFontScale$factory($this.c9o_1);
    $this.u9o_1 = debugExtraFontColor$factory($this.c9o_1);
    $this.v9o_1 = FastArrayList.sy();
    $this.w9o_1 = $this.h9n_1.x1u();
    var tmp_4 = $this;
    tmp_4.x9o_1 = Pool.a2q(VOID, Views$tempViewsPool$lambda);
    $this.y9o_1 = SizeInt.y2g();
    $this.z9o_1 = SizeInt.y2g();
    $this.a9p_1 = SizeInt.y2g();
    $this.b9p_1 = new Signal();
    $this.c9p_1 = new Signal();
    $this.d9p_1 = -1.0;
    $this.f9n_1.a67(getKClass(CoroutineContext), $this.d9n_1);
    $this.f9n_1.a67(getKClass(AG), $this.e9n_1);
    $this.f9n_1.a67(getKClass(Views), $this);
    $this.c9p_1.h1w(Views$lambda($this));
    $this.b9p_1.h1w(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.e9p_1 = Companion_instance_11.bi('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.f9p_1 = new EventResult();
    $this.g9p_1 = new Signal();
    $this.h9p_1 = Companion_getInstance_0().qw('debugHightlightView');
    $this.i9p_1 = new Signal();
    $this.j9p_1 = new Signal();
    $this.k9p_1 = ArrayList.h1();
    $this.l9p_1 = updatedSinceFrame$factory($this.j9n_1);
    return $this;
  }
  b15() {
    return this.d9n_1;
  }
  qa0() {
    return this.q9n_1;
  }
  n9v(_set____db54di) {
    var this_0 = this.s9n_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  h9v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s9n_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  dda() {
    return replace(replace(replace(this.k9n_1, '\\', ''), '/', ''), '..', '');
  }
  u9y() {
    var tmp = this.y9n_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  g23($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  m9v() {
    return this.h9o_1;
  }
  o9v() {
    return this.e9n_1.h6j().a6j_1;
  }
  p9v() {
    return this.e9n_1.h6j().b6j_1;
  }
  eda(value) {
    this.j9o_1 = numberToInt(value);
  }
  fda() {
    return this.j9o_1;
  }
  gda(value) {
    this.k9o_1 = numberToInt(value);
  }
  hda() {
    return this.k9o_1;
  }
  cd9(value) {
    this.eda(value.r26_1);
    this.gda(value.s26_1);
  }
  bd9() {
    return Size2D.l2e(this.fda(), this.hda());
  }
  f6() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  cda($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  p9y() {
    return this.p9o_1.v87();
  }
  d9v(_set____db54di) {
    var this_0 = this.t9o_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ida() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t9o_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  e9v(_set____db54di) {
    var this_0 = this.u9o_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  jda() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u9o_1;
    debugFontColor$factory_0();
    return this_0.get().t4h_1;
  }
  rcw(block) {
    this.v9o_1.h(block);
  }
  x69(type, event, result, up, down) {
    event.q6a(false);
    var result_0 = super.x69(type, event, result, up, down);
    var e = event;
    e.p6a(this.q9n_1);
    if (e instanceof KeyEvent) {
      this.g9n_1.c88(e);
      this.g9n_1.j87_1.t86(e);
      if (e.n6b_1.equals(Type_UP_getInstance_0()) && this.r9o_1 && (e.p6b_1.equals(Key_F12_getInstance()) || e.p6b_1.equals(Key_F7_getInstance()))) {
        this.s9o_1 = !this.s9o_1;
        this.j9n_1.c8n(this.s9o_1);
        this.maj(this.p9o_1);
      }
    }
    try {
      return this.p9o_1.g6a(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  kda(frameBuffer) {
    this.c9o_1.t84_1 = frameBuffer;
    if (this.d9o_1) {
      var tmp0_$this = this.c9o_1;
      var tmp1_color = this.e9o_1;
      tmp0_$this.s8e(tmp1_color, 1.0, 0, true, true, true);
    }
    this.b9p_1.i1w(this.c9o_1);
    this.c9o_1.c86();
    this.p9o_1.rag(this.c9o_1);
    this.c9o_1.c86();
    this.p9o_1.zaj(this.c9o_1);
    if (this.s9o_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.v9o_1.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.c9o_1);
      }
    }
    this.c9p_1.i1w(this.c9o_1);
    this.c9o_1.c86();
  }
  lda(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.e9n_1.h6j() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.kda(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.kda.call(this, frameBuffer);
    }
    return tmp;
  }
  mda() {
    this.e9n_1.l6j();
    this.lda();
  }
  i9v(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.h9n_1.x1u();
    this.q9n_1.i9n_1.l6j();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().w9j_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.w9o_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.q9n_1.g9o_1) > 0 ? this.q9n_1.g9o_1 : delta;
    this.w9o_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.d1v())) {
        this.oda(fixedSizeStep);
      } else {
        this.nda(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.pda() > 0);
    if (doRender2) {
      if (this.e9p_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().z1u().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.pda() + ']');
      }
      this.mda();
      this.l6j();
    }
  }
  nda(elapsed) {
    return this.oda(get_fast(elapsed));
  }
  oda(elapsed) {
    this.g9n_1.a88(elapsed);
    this.f9p_1.t2q();
    updateSingleViewWithViewsAll(this.p9o_1, this, elapsed);
    this.g9n_1.b88(elapsed);
  }
  g9v() {
  }
  l9v(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.z9o_1 = SizeInt.x2g(actualWidth, actualHeight);
    this.qda();
  }
  qda() {
    setBoundsInfo(this.n9n_1, Size2D.t26(this.j9o_1, this.k9o_1), toFloat(this.z9o_1), this.m9o_1, this.n9o_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.c9o_1.a84_1 = this.n9n_1.f8d();
    this.c9o_1.b84_1 = this.n9n_1.b8d();
    // Inline function 'kotlin.also' call
    var this_0 = this.t9n_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.h6b_1 = this.z9o_1.v2g_1;
    this_0.i6b_1 = this.z9o_1.w2g_1;
    this.g6a(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.w9n_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.uda_1 = this.y9o_1;
    this.g6a(this_1);
    this.p9o_1.oaj();
  }
  ubz(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.j9n_1.d8n())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.h9p_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.g9p_1.i1w(viewToHightlight);
  }
  s9y(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.ubz(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.ubz.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  vda(_set____db54di) {
    var this_0 = this.l9p_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  pda() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l9p_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  l6j() {
    this.j9n_1.l6j();
  }
  maj(view) {
    this.j9n_1.r8n();
  }
  ay(value) {
    this.c9n_1.ay(value);
  }
  by() {
    return this.c9n_1.by();
  }
  l8d(pos) {
    return this.n9n_1.l8d(pos);
  }
  a8d(value) {
    this.n9n_1.a8d(value);
  }
  b8d() {
    return this.n9n_1.b8d();
  }
  c8d(value) {
    this.n9n_1.c8d(value);
  }
  d8d() {
    return this.n9n_1.d8d();
  }
  e8d(value) {
    this.n9n_1.e8d(value);
  }
  f8d() {
    return this.n9n_1.f8d();
  }
  g8d(value) {
    this.n9n_1.g8d(value);
  }
  h8d() {
    return this.n9n_1.h8d();
  }
  i8d(value) {
    this.n9n_1.i8d(value);
  }
  j8d() {
    return this.n9n_1.j8d();
  }
  k8d() {
    return this.n9n_1.k8d();
  }
  c8f() {
    return this.j9n_1.c8f();
  }
  d8f() {
    return this.j9n_1.d8f();
  }
  e8f() {
    return this.j9n_1.e8f();
  }
  n8e() {
    return this.j9n_1.n8e();
  }
}
class Companion_14 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.c1v() : fastDelta;
    super();
    this.ud9_1 = views;
    this.vd9_1 = fastDelta;
  }
  wd9() {
    return toDuration_0(this.vd9_1);
  }
  w29() {
    return Companion_instance_29;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.vd9_1) + ')';
  }
}
class Companion_15 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.x2g(0, 0) : size;
    super();
    this.tda_1 = views;
    this.uda_1 = size;
  }
  w29() {
    return Companion_instance_30;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.uda_1.toString() + ')';
  }
}
class UB extends UniformBlock {
  constructor() {
    UB_instance = null;
    super(6);
    UB_instance = this;
    this.adb_1 = this.l6y().z6x(this, u_Col$factory());
    this.bdb_1 = this.p6x().z6x(this, u_Matrix$factory());
  }
  cdb() {
    return this.adb_1.no(this, u_Col$factory_0());
  }
  ddb() {
    return this.bdb_1.no(this, u_Matrix$factory_0());
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    var tmp_0 = DefaultShaders_getInstance().s6w_1;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.debug.Companion.PROGRAM.<anonymous>' call
    this_0.n70(this_0.q70(), this_0.r70(this_0.r70(this_0.r70(this_0.a6y(), this_0.b6y()), UB_getInstance().ddb()), this_0.u70([this_0.s70(), this_0.t70(0.0), this_0.t70(1.0)])));
    var tmp_1 = VertexShader(this_0.v70());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder = ProgramBuilderDefault.i70();
    // Inline function 'korlibs.korge.view.debug.Companion.PROGRAM.<anonymous>' call
    builder.n70(builder.q70(), UB_getInstance().cdb());
    var tmp$ret$2 = FragmentShader(builder.v70());
    tmp.edb_1 = tmp_0.h7o(tmp_1, tmp$ret$2);
  }
}
class Batch {
  constructor(offset, count) {
    this.fdb_1 = offset;
    this.gdb_1 = count;
  }
}
class DebugVertexView extends View {
  static say(pointsList, color, type) {
    Companion_getInstance_57();
    color = color === VOID ? Colors_getInstance().e41_1 : color;
    type = type === VOID ? Companion_getInstance_14().z6s_1 : type;
    var $this = this.qcw();
    $this.m4h(color);
    $this.may_1 = colorMul$factory($this);
    $this.nay_1 = pointsList;
    $this.oay_1 = type;
    var tmp = $this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.pay_1 = new Float32Array([0.0, 0.0, 100.0, 0.0, 0.0, 100.0, 100.0, 100.0]);
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.qay_1 = ArrayList.h1();
    $this.ray_1 = Companion_getInstance_32().m26();
    updatedPoints($this);
    return $this;
  }
  jaz(value) {
    if (!(this.nay_1 === value)) {
      this.nay_1 = value;
      updatedPoints(this);
    }
  }
  sag() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.ray_1);
  }
  vag(ctx) {
    ctx.c86();
    ctx.o8c();
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = ctx.n6q(UB_getInstance());
      var _unary__edvuaz = this_0.c6s();
      this_0.f7f(_unary__edvuaz + 1 | 0);
      this_0.g7f(this_0.c6s() + 1 | 0);
      var blockSize = this_0.g6q_1;
      var index0 = imul(this_0.c6s() - 1 | 0, blockSize);
      var index1 = imul(this_0.c6s(), blockSize);
      var texBlockSize = this_0.d6q_1.c6y().e1();
      var texIndex0 = imul(this_0.c6s() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.c6s(), texBlockSize);
      if (this_0.c6s() > 0) {
        arraycopy(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
      } else {
        arrayfill(this_0.i6q_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.view.debug.DebugVertexView.renderInternal.<anonymous>' call
      var $this$push = this_0.d6q_1;
      var it = this_0.j6q_1;
      it.p7f($this$push.cdb(), this.aam());
      it.v7f($this$push.ddb(), toMatrix4(this.t9y()));
      if (true && this_0.c6s() >= 1) {
        var equals = arrayequal(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.c6s();
          this_0.f7f(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    $l$block_0: {
      // Inline function 'korlibs.datastructure.Pool.alloc' call
      var this_1 = ctx.p84_1;
      var temp = this_1.c2q();
      try {
        temp.o6m(this.pay_1);
        var vData = AGVertexArrayObject.h6s([new AGVertexData(DefaultShaders_getInstance().q6w_1, temp)], true);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_2 = this.qay_1;
        var n = 0;
        while (n < this_2.e1()) {
          // Inline function 'korlibs.korge.view.debug.DebugVertexView.renderInternal.<anonymous>.<anonymous>' call
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var batch = this_2.d1(_unary__edvuaz_1);
          var tmp0_$receiver = ctx.q83_1;
          var tmp1_frameBuffer = ctx.t84_1;
          var tmp2_drawType = this.oay_1;
          var tmp3_program = Companion_getInstance_57().edb_1;
          var tmp4_uniformBlocks = ctx.j8e(Companion_getInstance_57().edb_1);
          var tmp5_textureUnits = ctx.z83_1.wx();
          var tmp6_vertexCount = batch.gdb_1;
          var tmp7_drawOffset = batch.fdb_1;
          var tmp8_blending = this.zal().f86_1;
          draw(tmp0_$receiver, tmp1_frameBuffer, vData, tmp3_program, tmp2_drawType, tmp6_vertexCount, VOID, VOID, tmp7_drawOffset, tmp8_blending, tmp4_uniformBlocks, tmp5_textureUnits);
        }
        break $l$block_0;
      }finally {
        this_1.d2q(temp);
      }
    }
  }
}
class ColorTransformUB extends UniformBlock {
  constructor() {
    ColorTransformUB_instance = null;
    super(5);
    ColorTransformUB_instance = this;
    this.ldb_1 = this.l6y().z6x(this, u_ColorMul$factory());
    this.mdb_1 = this.l6y().z6x(this, u_ColorAdd$factory());
  }
  ndb() {
    return this.ldb_1.no(this, u_ColorMul$factory_0());
  }
  odb() {
    return this.mdb_1.no(this, u_ColorAdd$factory_0());
  }
}
class BaseProgramProvider {
  constructor() {
    Companion_getInstance_62();
    this.xdb_1 = Companion_getInstance_6().a8b_1.x6q_1;
    this.ydb_1 = Companion_getInstance_63().pdb_1;
    var tmp = this;
    tmp.zdb_1 = lazy(ShaderFilter$BaseProgramProvider$_program$delegate$lambda(this));
  }
  adc(vertex, fragment) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.graphics.shader.appending' call
      if (fragment.i7o()) {
        tmp$ret$0 = fragment;
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = ProgramBuilderDefault.i70().x71(fragment);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.BaseProgramProvider.createProgram.<anonymous>' call
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this_0.y72(this_0.w70(this_0.q70(), 'a'), this_0.t70(0.0));
      var body = this_0.e71();
      // Inline function 'korlibs.korge.view.filter.BaseProgramProvider.createProgram.<anonymous>.<anonymous>' call
      body.z71();
      var stmIf = new If(cond, body.g71());
      // Inline function 'kotlin.collections.plusAssign' call
      this_0.m70_1.h(stmIf);
      var pair = this_0.v70();
      tmp$ret$0 = new Shader(fragment.k7g_1, pair.hl_1, pair.il_1);
    }
    return new Program(vertex, tmp$ret$0);
  }
  bdc() {
    return this.xdb_1;
  }
  wdb() {
    return this.ydb_1;
  }
  cdc() {
    return _get__program__9g4ap2(this);
  }
}
class Companion_17 extends BaseProgramProvider {
  constructor() {
    Companion_instance_32 = null;
    super();
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.filter.Companion.fragment.<anonymous>' call
    this_0.n70(this_0.q70(), Companion_getInstance_63().rdb(this_0, Companion_getInstance_63().qdb(this_0)));
    this_0.n70(this_0.q70(), this_0.s72(this_0.r70(this_0.q70(), ColorTransformUB_getInstance().ndb()), ColorTransformUB_getInstance().odb()));
    tmp.vdb_1 = FragmentShader(this_0.v70());
  }
  wdb() {
    return this.vdb_1;
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_36().y28_1;
}
class ShaderFilter {
  constructor() {
    Companion_getInstance_63();
    this.odc_1 = true;
    this.pdc_1 = Vector2D.h28();
    this.qdc_1 = Vector2D.h28();
    this.rdc_1 = Vector2D.h28();
    this.sdc_1 = Companion_getInstance_62();
    this.tdc_1 = AGTextureUnits.u6m();
    this.udc_1 = 0;
  }
  vdc() {
    return this.odc_1;
  }
  wdc(texWidth, texHeight) {
    return Companion_getInstance_36().y28_1;
  }
  mdc() {
    return this.sdc_1;
  }
  ndc(ctx, filterScale) {
  }
  v29() {
    return false;
  }
  xdc(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    if (this.v29())
      return Companion_getInstance_61().xdc(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale);
    var _margin = getBorder(this, texWidth, texHeight);
    var marginLeft = toIntCeil(_margin.c29_1 * filterScale);
    var marginRight = toIntCeil(_margin.a29_1 * filterScale);
    var marginTop = toIntCeil(_margin.z28_1 * filterScale);
    var marginBottom = toIntCeil(_margin.b29_1 * filterScale);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.o84_1;
    var this_1 = this_0.x84_1;
    if (!(this_1.s84_1 === this_0)) {
      this_1.s84_1 = this_0;
      this_1.c86();
    }
    var slice = texture.d3h(-marginLeft | 0, -marginTop | 0, texture.x3f_1 + marginRight | 0, texture.y3f_1 + marginBottom | 0, VOID, false);
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.temporalTextureUnit' call
      var sampler = DefaultShaders_getInstance().x70();
      var tex = slice.o3f_1.y88_1;
      var info = Companion_getInstance_18().a6n_1;
      var oldTex = this_0.x84_1.z83_1.s6m_1[sampler.n6n_1];
      var oldInfo = AGTextureUnitInfoArray__get_impl_xhvpef(this_0.x84_1.z83_1.t6m_1, sampler.n6n_1);
      this_0.x84_1.z83_1.b6n(sampler, tex, info);
      try {
        _updateUniforms(this, ctx, filterScale, texture, texWidth, texHeight);
        this_0.e86(slice, -marginLeft, -marginTop, VOID, VOID, matrix, this.vdc(), renderColorMul, blendMode, this.mdc().cdc());
        break $l$block;
      }finally {
        this_0.i8b();
        this_0.x84_1.z83_1.b6n(sampler, oldTex, oldInfo);
      }
    }
    _restoreUniforms(this, ctx, filterScale);
  }
}
class ColorTransformFilter extends ShaderFilter {
  constructor(colorTransform) {
    Companion_getInstance_58();
    super();
    this.kdc_1 = colorTransform.r4g();
    this.ldc_1 = colorTransform.s4g();
  }
  mdc() {
    return Companion_getInstance_58();
  }
  ndc(ctx, filterScale) {
    super.ndc(ctx, filterScale);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = ctx.n6q(ColorTransformUB_getInstance());
      var _unary__edvuaz = this_0.c6s();
      this_0.f7f(_unary__edvuaz + 1 | 0);
      this_0.g7f(this_0.c6s() + 1 | 0);
      var blockSize = this_0.g6q_1;
      var index0 = imul(this_0.c6s() - 1 | 0, blockSize);
      var index1 = imul(this_0.c6s(), blockSize);
      var texBlockSize = this_0.d6q_1.c6y().e1();
      var texIndex0 = imul(this_0.c6s() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.c6s(), texBlockSize);
      if (this_0.c6s() > 0) {
        arraycopy(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
      } else {
        arrayfill(this_0.i6q_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.view.filter.ColorTransformFilter.updateUniforms.<anonymous>' call
      var $this$push = this_0.d6q_1;
      var it = this_0.j6q_1;
      it.p7f($this$push.ndb(), this.kdc_1);
      it.s7f($this$push.odb(), this.ldc_1);
      if (true && this_0.c6s() >= 1) {
        var equals = arrayequal(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.c6s();
          this_0.f7f(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
}
class Companion_18 {
  zdc(left, right) {
    var tmp;
    if (left == null && right == null) {
      tmp = null;
    } else {
      if (left == null) {
        tmp = right;
      } else {
        if (right == null) {
          tmp = left;
        } else {
          var tmp_0;
          if (left instanceof ComposedFilter) {
            tmp_0 = right instanceof ComposedFilter;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp = ComposedFilter.cdd(plus_0(left.add_1, right.add_1));
          } else {
            if (left instanceof ComposedFilter) {
              tmp = ComposedFilter.cdd(plus(left.add_1, right));
            } else {
              if (right instanceof ComposedFilter) {
                tmp = ComposedFilter.cdd(plus(listOf(left), right));
              } else {
                tmp = ComposedFilter.bdd([left, right]);
              }
            }
          }
        }
      }
    }
    return tmp;
  }
}
class ComposedFilter {
  static ddd(filters, unit) {
    unit = unit === VOID ? Unit_instance : unit;
    var $this = createThis(this);
    $this.add_1 = filters;
    return $this;
  }
  static edd() {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tmp$ret$0 = ArrayList.h1();
    return this.cdd(tmp$ret$0);
  }
  static cdd(filters) {
    var tmp;
    if (filters instanceof FastArrayList) {
      tmp = filters;
    } else {
      tmp = FastArrayList.fz(filters);
    }
    return this.ddd(tmp);
  }
  static bdd(filters) {
    return this.cdd(toList(filters));
  }
  ydc() {
    var out = 1.0;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.add_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.filter.ComposedFilter.<get-recommendedFilterScale>.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      out = out * array[_unary__edvuaz].ydc();
    }
    return out;
  }
  wdc(texWidth, texHeight) {
    var sumLeft = 0;
    var sumTop = 0;
    var sumRight = 0;
    var sumBottom = 0;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.add_1.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.filter.ComposedFilter.computeBorder.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var out = array[_unary__edvuaz].wdc(texWidth, texHeight);
      sumLeft = sumLeft + out.c29_1 | 0;
      sumRight = sumRight + out.a29_1 | 0;
      sumTop = sumTop + out.z28_1 | 0;
      sumBottom = sumBottom + out.b29_1 | 0;
    }
    return MarginInt.d29(sumTop, sumRight, sumBottom, sumLeft);
  }
  v29() {
    return false;
  }
  xdc(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    var mat = matrix;
    var tex = texture;
    var last = null;
    var texWidth_0 = texWidth;
    var texHeight_0 = texHeight;
    var filterScale_0 = filterScale;
    var resultPool = get_renderToTextureResultPool(ctx);
    if (!this.v29()) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.add_1.qy_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.filter.ComposedFilter.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var filter = array[_unary__edvuaz];
        var result = resultPool.c2q();
        this.fdd();
        renderToTextureWithBorderUnsafe(filter, ctx, mat, tex, texWidth_0, texHeight_0, filterScale_0, result);
        result.mda();
        ctx.c86();
        resultPool.e2q(last);
        last = result;
        mat = result.mdd_1;
        tex = ensureNotNull(result.pdd_1);
        texWidth_0 = result.hdd_1;
        texHeight_0 = result.idd_1;
      }
    }
    Companion_getInstance_61().xdc(ctx, mat, tex, texWidth_0, texHeight_0, renderColorMul, blendMode, filterScale_0);
    resultPool.e2q(last);
  }
  fdd() {
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.sdd_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  tdd(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.sdd_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class RenderToTextureResult {
  constructor() {
    this.gdd_1 = null;
    this.hdd_1 = 0;
    this.idd_1 = 0;
    this.jdd_1 = 0;
    this.kdd_1 = 0;
    this.ldd_1 = 1.0;
    this.mdd_1 = Companion_getInstance_34().g29_1;
    this.ndd_1 = null;
    this.odd_1 = null;
    this.pdd_1 = null;
    this.qdd_1 = null;
  }
  mda() {
    var tmp0_elvis_lhs = this.odd_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var fb = tmp;
    var tmp1_elvis_lhs = this.qdd_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var ctx = tmp_0;
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.z8e(fb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.o84_1;
      var this_1 = this_0.x84_1;
      if (!(this_1.s84_1 === this_0)) {
        this_1.s84_1 = this_0;
        this_1.c86();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.b6u(0, 0, fb.a6j_1, fb.b6j_1);
        var temp = this_0.v85_1;
        this_0.e8c();
        this_0.v85_1 = scissor;
        try {
          if (true) {
            ctx.s8e(Colors_getInstance().j41_1);
          }
          // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.render.<anonymous>' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.o84_1;
          var matrix = Companion_getInstance_34().g29_1;
          var this_3 = this_2.x84_1;
          this_3.c86();
          var temp4 = this_3.d84_1;
          var temp2d = this_3.e84_1;
          this_3.e84_1 = matrix;
          this_3.d84_1 = toMatrix4(matrix);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_4 = this_3.n6q(ProjViewUB_getInstance());
            var _unary__edvuaz = this_4.c6s();
            this_4.f7f(_unary__edvuaz + 1 | 0);
            this_4.g7f(this_4.c6s() + 1 | 0);
            var blockSize = this_4.g6q_1;
            var index0 = imul(this_4.c6s() - 1 | 0, blockSize);
            var index1 = imul(this_4.c6s(), blockSize);
            var texBlockSize = this_4.d6q_1.c6y().e1();
            var texIndex0 = imul(this_4.c6s() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_4.c6s(), texBlockSize);
            if (this_4.c6s() > 0) {
              arraycopy(this_4.i6q_1, index0, this_4.i6q_1, index1, blockSize);
            } else {
              arrayfill(this_4.i6q_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_4.d6q_1;
            this_4.j6q_1.v7f($this$push.b6y(), this_3.d84_1);
            if (true && this_4.c6s() >= 1) {
              var equals = arrayequal(this_4.i6q_1, index0, this_4.i6q_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_4.c6s();
                this_4.f7f(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp0_safe_receiver = this.ndd_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp0_safe_receiver_0 = this.gdd_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.xdc(ctx, Companion_getInstance_34().g29_1.l2a(this.jdd_1, this.kdd_1), tmp0_safe_receiver, this.hdd_1, this.idd_1, Colors_getInstance().e41_1, Companion_getInstance_13().v82_1, this.ldd_1);
              }
            }
            tmp_1 = Unit_instance;
          }finally {
            this_3.c86();
            this_3.d84_1 = temp4;
            this_3.e84_1 = temp2d;
            this_3.n6q(ProjViewUB_getInstance()).h7f();
          }
          break $l$block_0;
        }finally {
          this_0.e8c();
          this_0.v85_1 = temp;
        }
      }
    }finally {
      ctx.a8f();
    }
    this.pdd_1 = Texture_0(fb).f3h(0, 0, this.hdd_1, this.idd_1);
  }
  l18() {
    if (this.odd_1 == null || this.qdd_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.odd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.qdd_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.y8e(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.gdd_1 = null;
    this.ndd_1 = null;
    this.odd_1 = null;
    this.qdd_1 = null;
    this.pdd_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_61();
    this.rdd_1 = smoothing;
  }
  xdc(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.o84_1;
    var this_1 = this_0.x84_1;
    if (!(this_1.s84_1 === this_0)) {
      this_1.s84_1 = this_0;
      this_1.c86();
    }
    this_0.e86(texture, VOID, VOID, VOID, VOID, matrix, this.rdd_1, renderColorMul, blendMode, Companion_getInstance_6().a8b_1);
  }
}
class Companion_20 extends IdentityFilter {
  constructor() {
    Companion_instance_35 = null;
    super(true);
    Companion_instance_35 = this;
  }
}
class Companion_21 extends BaseProgramProvider {
  constructor() {
    Companion_instance_36 = null;
    super();
    Companion_instance_36 = this;
  }
}
class TexInfoUB extends UniformBlock {
  constructor() {
    TexInfoUB_instance = null;
    super(4);
    TexInfoUB_instance = this;
    this.ydd_1 = this.j6y().z6x(this, u_TextureSize$factory());
    this.zdd_1 = this.j6y().z6x(this, u_MaxTexCoords$factory());
    this.ade_1 = this.j6y().z6x(this, u_StdTexDerivates$factory());
    this.bde_1 = this.h6y().z6x(this, u_filterScale$factory());
  }
  cde() {
    return this.ydd_1.no(this, u_TextureSize$factory_0());
  }
  dde() {
    return this.zdd_1.no(this, u_MaxTexCoords$factory_0());
  }
  ede() {
    return this.ade_1.no(this, u_StdTexDerivates$factory_0());
  }
  fde() {
    return this.bde_1.no(this, u_filterScale$factory_0());
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_37 = this;
    this.pdb_1 = Companion_getInstance_6().a8b_1.y6q_1;
  }
  gde(_this__u8e3s4) {
    return _this__u8e3s4.w70(DefaultShaders_getInstance().d6w_1, 'xy');
  }
  qdb(_this__u8e3s4) {
    return _this__u8e3s4.r70(this.gde(_this__u8e3s4), TexInfoUB_getInstance().cde());
  }
  rdb(_this__u8e3s4, coords) {
    return _this__u8e3s4.y70(DefaultShaders_getInstance().x70(), _this__u8e3s4.c71(coords, TexInfoUB_getInstance().cde()));
  }
}
class ViewRenderPhaseBackdropFilter {}
class Companion_23 {
  constructor() {
    this.jde_1 = -200;
  }
}
class ViewRenderPhaseFilter {
  constructor(filter) {
    filter = filter === VOID ? null : filter;
    this.ide_1 = filter;
  }
  od9() {
    return -200;
  }
  rd9(view, ctx) {
    if (!(this.ide_1 == null)) {
      renderFiltered(view, ctx, ensureNotNull(this.ide_1), false);
    } else {
      render_0.call(this, view, ctx);
    }
  }
}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.udf_1 = bounds;
    this.vdf_1 = vertexCount;
    this.wdf_1 = vertexStart;
    this.xdf_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static od2(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.qcw();
    $this.pd1_1 = autoScaling;
    $this.qd1_1 = true;
    $this.rd1_1 = true;
    $this.sd1_1 = true;
    $this.td1_1 = new GpuShapeViewCommands();
    $this.ud1_1 = 1000;
    $this.vd1_1 = 1000;
    $this.wd1_1 = Companion_getInstance_27().n24_1;
    $this.xd1_1 = true;
    $this.yd1_1 = false;
    $this.zd1_1 = antialiased;
    $this.ad2_1 = shape;
    $this.bd2_1 = false;
    $this.cd2_1 = false;
    $this.dd2_1 = false;
    $this.ed2_1 = 0;
    $this.fd2_1 = Companion_getInstance_33().j29();
    $this.gd2_1 = Companion_getInstance_33().j29();
    $this.hd2_1 = false;
    $this.id2_1 = 1.0;
    $this.jd2_1 = NaN;
    $this.kd2_1 = Companion_getInstance_34().j29();
    $this.ld2_1 = 100000;
    $this.md2_1 = false;
    $this.nd2_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  gc0(value) {
    this.wd1_1 = value;
    this.oaj();
  }
  ocn() {
    return this.wd1_1;
  }
  qd2(value) {
    this.zd1_1 = value;
    invalidateShape(this);
  }
  pd2(value) {
    this.ad2_1 = value;
    invalidateShape(this);
  }
  hak() {
    return _get_shapeBounds__actvvf(this).y25_1 * this.ocn().w24_1;
  }
  iak() {
    return _get_shapeBounds__actvvf(this).z25_1 * this.ocn().x24_1;
  }
  oaj() {
    super.oaj();
    invalidateShape(this);
  }
  sag() {
    return new Rectangle(_get_shapeBounds__actvvf(this).w25_1 - this.hak(), _get_shapeBounds__actvvf(this).x25_1 - this.iak(), _get_shapeBounds__actvvf(this).y25_1, _get_shapeBounds__actvvf(this).z25_1);
  }
  zdf(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.a63_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.g1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.zdf(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.zdf(_this__u8e3s4.t63());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.y62();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  vag(ctx) {
    this.id2_1 = this.t9y().u2a().s2b() * ctx.r83_1.k8d();
    if (!(this.jd2_1 === this.id2_1)) {
      invalidateShape(this);
    }
    ctx.c86();
    var doRequireTexture = this.zdf(this.ad2_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.ej();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.q83_1.h6j();
      this.ud1_1 = currentFrameBuffer.a6j_1;
      this.vd1_1 = currentFrameBuffer.b6j_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.ud1_1;
      var height = this.vd1_1;
      ctx.c86();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.x8e(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.z8e(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.o84_1;
          var this_1 = this_0.x84_1;
          if (!(this_1.s84_1 === this_0)) {
            this_1.s84_1 = this_0;
            this_1.c86();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.b6u(0, 0, rb.a6j_1, rb.b6j_1);
            var temp = this_0.v85_1;
            this_0.e8c();
            this_0.v85_1 = scissor;
            try {
              if (true) {
                ctx.s8e(Colors_getInstance().j41_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.e8c();
              this_0.v85_1 = temp;
            }
          }
        }finally {
          ctx.a8f();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).f3h(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.o84_1;
        var this_3 = this_2.x84_1;
        if (!(this_3.s84_1 === this_2)) {
          this_3.s84_1 = this_2;
          this_3.c86();
        }
        this_2.e86(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.r83_1.b8d()));
        ctx.c86();
      }finally {
        ctx.y8e(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.adg_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.adg_1.toString() + ')';
  }
  hashCode() {
    return this.adg_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.adg_1.equals(tmp0_other_with_cast.adg_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.bdg_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.bdg_1 + ')';
  }
  hashCode() {
    return this.bdg_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.bdg_1 === tmp0_other_with_cast.bdg_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_14().v6s_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_24().k6k_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_19().h6k_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_20().f6k_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_23().v6k_1 : cullFace;
    this.cdg_1 = drawType;
    this.ddg_1 = vertexIndex;
    this.edg_1 = vertexEnd;
    this.fdg_1 = paintShader;
    this.gdg_1 = program;
    this.hdg_1 = colorMask;
    this.idg_1 = stencilOpFunc;
    this.jdg_1 = stencilRef;
    this.kdg_1 = blendMode;
    this.ldg_1 = cullFace;
  }
  m8b() {
    return this.edg_1 - this.ddg_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.cdg_1) + ', vertexIndex=' + this.ddg_1 + ', vertexEnd=' + this.edg_1 + ', paintShader=' + toString_0(this.fdg_1) + ', program=' + toString_0(this.gdg_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.hdg_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.idg_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.jdg_1) + ', blendMode=' + toString_0(this.kdg_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.ldg_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.cdg_1);
    result = imul(result, 31) + this.ddg_1 | 0;
    result = imul(result, 31) + this.edg_1 | 0;
    result = imul(result, 31) + (this.fdg_1 == null ? 0 : this.fdg_1.hashCode()) | 0;
    result = imul(result, 31) + (this.gdg_1 == null ? 0 : this.gdg_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.hdg_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.idg_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.jdg_1) | 0;
    result = imul(result, 31) + (this.kdg_1 == null ? 0 : this.kdg_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.ldg_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.cdg_1 === tmp0_other_with_cast.cdg_1))
      return false;
    if (!(this.ddg_1 === tmp0_other_with_cast.ddg_1))
      return false;
    if (!(this.edg_1 === tmp0_other_with_cast.edg_1))
      return false;
    if (!equals(this.fdg_1, tmp0_other_with_cast.fdg_1))
      return false;
    if (!equals(this.gdg_1, tmp0_other_with_cast.gdg_1))
      return false;
    if (!(this.hdg_1 === tmp0_other_with_cast.hdg_1))
      return false;
    if (!(this.idg_1 === tmp0_other_with_cast.idg_1))
      return false;
    if (!equals(this.jdg_1, tmp0_other_with_cast.jdg_1))
      return false;
    if (!equals(this.kdg_1, tmp0_other_with_cast.kdg_1))
      return false;
    if (!(this.ldg_1 === tmp0_other_with_cast.ldg_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.kde_1 = 0;
    this.lde_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.mde_1 = ArrayList.h1();
    this.nde_1 = null;
    this.ode_1 = FastArrayList.sy();
    this.pde_1 = 0;
    this.qde_1 = 0;
    this.rde_1 = MatrixTransform.q2b();
    this.sde_1 = FastArrayList.sy();
    this.tde_1 = AGTextureUnits.u6m();
  }
  l3() {
    this.kde_1 = 0;
    this.lde_1.l3();
    this.mde_1.l3();
  }
  yde(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.pde_1;
      this.pde_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.lde_1.s2j(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.kde_1;
    this.kde_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  xde() {
    this.qde_1 = this.kde_1;
    return this.qde_1;
  }
  zde() {
    return this.kde_1;
  }
  ydf(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.mde_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  tdf(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_24().k6k_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_19().h6k_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_20().f6k_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().v82_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_23().v6k_1 : cullFace;
    startIndex = startIndex === VOID ? this.qde_1 : startIndex;
    endIndex = endIndex === VOID ? this.kde_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.ydf(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ydf.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  t79(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.mde_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  ude(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.t79(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.t79.call(this, i);
    }
    return tmp;
  }
  vde(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.mde_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  j6j() {
    var tmp0_safe_receiver = this.nde_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.ode_1.h(tmp0_safe_receiver);
    }
    this.nde_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.lde_1.x2j())));
  }
  wde(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.nde_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.k84_1.q8a(this.ode_1);
    this.ode_1.l3();
    ctx.c86();
    var ag = ctx.q83_1;
    var vao = AGVertexArrayObject.g6s(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().jdf_1, ctx.n8a(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.o84_1;
    var this_1 = this_0.x84_1;
    if (!(this_1.s84_1 === this_0)) {
      this_1.s84_1 = this_0;
      this_1.c86();
    }
    this_0.o8c();
    var tempMat = (doRequireTexture ? Companion_getInstance_34().g29_1 : this_0.k8b()).s2a(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.x84_1;
    this_2.c86();
    var temp4 = this_2.d84_1;
    var temp2d = this_2.e84_1;
    this_2.e84_1 = tempMat;
    this_2.d84_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.n6q(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.c6s();
      this_3.f7f(_unary__edvuaz + 1 | 0);
      this_3.g7f(this_3.c6s() + 1 | 0);
      var blockSize = this_3.g6q_1;
      var index0 = imul(this_3.c6s() - 1 | 0, blockSize);
      var index1 = imul(this_3.c6s(), blockSize);
      var texBlockSize = this_3.d6q_1.c6y().e1();
      var texIndex0 = imul(this_3.c6s() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.c6s(), texBlockSize);
      if (this_3.c6s() > 0) {
        arraycopy(this_3.i6q_1, index0, this_3.i6q_1, index1, blockSize);
      } else {
        arrayfill(this_3.i6q_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.d6q_1;
      this_3.j6q_1.v7f($this$push.b6y(), this_2.d84_1);
      if (true && this_3.c6s() >= 1) {
        var equals = arrayequal(this_3.i6q_1, index0, this_3.i6q_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.c6s();
          this_3.f7f(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.rde_1 = globalMatrix.u2a();
      var program = GpuShapeViewPrograms_getInstance().qdf_1;
      var scissor = Companion_getInstance_16().t6k_1;
      var this_4 = this.mde_1;
      var n = 0;
      while (n < this_4.e1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.d1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.adg_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.bdg_1;
            ctx.s8e(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.fdg_1;
              this_0.u8c(cmd.m8b());
              var pixelScale = this.rde_1.s2b() / ctx.r83_1.k8d();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.x84_1.n6q(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.c6s();
                  this_5.f7f(_unary__edvuaz_2 + 1 | 0);
                  this_5.g7f(this_5.c6s() + 1 | 0);
                  var blockSize_0 = this_5.g6q_1;
                  var index0_0 = imul(this_5.c6s() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.c6s(), blockSize_0);
                  var texBlockSize_0 = this_5.d6q_1.c6y().e1();
                  var texIndex0_0 = imul(this_5.c6s() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.c6s(), texBlockSize_0);
                  if (this_5.c6s() > 0) {
                    arraycopy(this_5.i6q_1, index0_0, this_5.i6q_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.i6q_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.d6q_1;
                  var it = this_5.j6q_1;
                  it.j7f(paintShader.mdg_1);
                  it.k7f($this$push_0.bdh(), pixelScale);
                  it.r7f($this$push_0.ndb(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.c6s() >= 1) {
                    var equals_0 = arrayequal(this_5.i6q_1, index0_0, this_5.i6q_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.c6s();
                      this_5.f7f(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.ndg_1 == null)) {
                  var tex = ctx.g84_1.c2q();
                  tex.u6o(paintShader.ndg_1);
                  this.tde_1.p6n(DefaultShaders_getInstance().x70(), tex);
                  this.sde_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.gdg_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.t84_1.t6i_1;
              var tmp5_frameBufferInfo = ctx.t84_1.z6k();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.j8e(_program);
              var tmp8_textureUnits = this.tde_1.wx();
              var tmp9_stencilOpFunc = cmd.idg_1;
              var tmp10_stencilRef = cmd.jdg_1;
              var tmp11_colorMask = cmd.hdg_1;
              var tmp3_elvis_lhs = cmd.kdg_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().v82_1 : tmp3_elvis_lhs).f86_1;
              var tmp13_cullFace = cmd.ldg_1;
              var tmp14_drawType = cmd.cdg_1;
              var tmp15_drawOffset = cmd.ddg_1;
              var tmp16_vertexCount = cmd.m8b();
              draw_0(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.c86();
      this_2.d84_1 = temp4;
      this_2.e84_1 = temp2d;
      this_2.n6q(ProjViewUB_getInstance()).h7f();
    }
    var _iterator__ex2g4s = this.sde_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var tex_0 = _iterator__ex2g4s.c1();
      ctx.g84_1.d2q(tex_0);
    }
    this.sde_1.l3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.tdg_1 = this.h6y().z6x(this, u_ProgramType$factory());
    this.udg_1 = this.l6y().z6x(this, u_Color$factory());
    this.vdg_1 = this.l6y().z6x(this, u_ColorMul$factory_1());
    this.wdg_1 = this.h6y().z6x(this, u_GlobalAlpha$factory());
    this.xdg_1 = this.h6y().z6x(this, u_GlobalPixelScale$factory());
    this.ydg_1 = this.p6x().z6x(this, u_Transform$factory());
    this.zdg_1 = this.l6y().z6x(this, u_Gradientp0$factory());
    this.adh_1 = this.l6y().z6x(this, u_Gradientp1$factory());
  }
  cdh() {
    return this.tdg_1.no(this, u_ProgramType$factory_0());
  }
  ddh() {
    return this.udg_1.no(this, u_Color$factory_0());
  }
  ndb() {
    return this.vdg_1.no(this, u_ColorMul$factory_2());
  }
  edh() {
    return this.wdg_1.no(this, u_GlobalAlpha$factory_0());
  }
  bdh() {
    return this.xdg_1.no(this, u_GlobalPixelScale$factory_0());
  }
  fdh() {
    return this.ydg_1.no(this, u_Transform$factory_0());
  }
  gdh() {
    return this.zdg_1.no(this, u_Gradientp0$factory_0());
  }
  hdh() {
    return this.adh_1.no(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().qdf_1 : program;
    this.mdg_1 = uniforms;
    this.ndg_1 = texture;
    this.odg_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.mdg_1.toString() + ', texture=' + toString_0(this.ndg_1) + ', program=' + this.odg_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.mdg_1);
    result = imul(result, 31) + (this.ndg_1 == null ? 0 : hashCode(this.ndg_1)) | 0;
    result = imul(result, 31) + this.odg_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.mdg_1, tmp0_other_with_cast.mdg_1))
      return false;
    if (!equals(this.ndg_1, tmp0_other_with_cast.ndg_1))
      return false;
    if (!this.odg_1.equals(tmp0_other_with_cast.odg_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.adf_1 = Attribute.h6z('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.bdf_1 = Attribute.h6z('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.cdf_1 = Varying.t6z('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.ddf_1 = Varying.t6z('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.edf_1 = ProgramLayout.q6s([DefaultShaders_getInstance().a6w_1]);
    this.fdf_1 = ProgramLayout.q6s([DefaultShaders_getInstance().b6w_1]);
    this.gdf_1 = ProgramLayout.q6s([this.bdf_1]);
    this.hdf_1 = ProgramLayout.q6s([DefaultShaders_getInstance().a6w_1, DefaultShaders_getInstance().b6w_1]);
    this.idf_1 = ProgramLayout.q6s([DefaultShaders_getInstance().a6w_1, this.bdf_1]);
    this.jdf_1 = ProgramLayout.q6s([DefaultShaders_getInstance().a6w_1, this.bdf_1, this.adf_1]);
    this.kdf_1 = 0;
    this.ldf_1 = 1;
    this.mdf_1 = 2;
    this.ndf_1 = 3;
    this.odf_1 = 4;
    this.pdf_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.n70(this_0.q70(), this_0.r70(this_0.r70(this_0.a6y(), this_0.b6y()), this_0.u70([this_0.s70(), this_0.t70(0.0), this_0.t70(1.0)])));
    this_0.n70(this_0.j70(), DefaultShaders_getInstance().a6w_1);
    this_0.n70(GpuShapeViewPrograms_getInstance().ddf_1, GpuShapeViewPrograms_getInstance().bdf_1);
    this_0.n70(GpuShapeViewPrograms_getInstance().cdf_1, GpuShapeViewPrograms_getInstance().adf_1);
    var tmp0_vertex = VertexShader(this_0.v70());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.i70();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.v72(GpuShapeViewPrograms_getInstance().cdh(), this_1.t70(5));
    var body = this_1.e71();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.n70(body.q70(), body.u70([body.t70(1.0), body.t70(0.0), body.t70(0.0), body.t70(1.0)]));
    body.b72();
    var stmIf = new If(cond, body.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.m70_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.z72(this_1.h72(GpuShapeViewPrograms_getInstance().ddf_1), GpuShapeViewPrograms_getInstance().cdf_1);
    var body_0 = this_1.e71();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.z71();
    var stmIf_0 = new If(cond_0, body_0.g71());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.m70_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().cdh();
    this_1.w71(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.q72(this_1.t70(1.0), this_1.j72(this_1.q72(this_1.r70(GpuShapeViewPrograms_getInstance().cdf_1, GpuShapeViewPrograms_getInstance().bdh()), this_1.t70(1.5)), this_1.r70(GpuShapeViewPrograms_getInstance().cdf_1, GpuShapeViewPrograms_getInstance().bdh()), this_1.h72(this_1.r70(GpuShapeViewPrograms_getInstance().ddf_1, GpuShapeViewPrograms_getInstance().bdh()))));
    this_1.n70(this_1.q70(), this_1.r70(this_1.r70(this_1.r70(this_1.q70(), GpuShapeViewPrograms_getInstance().ndb()), GpuShapeViewPrograms_getInstance().edh()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.v70());
    tmp.qdf_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.t2q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.c6s();
      this_2.f7f(_unary__edvuaz + 1 | 0);
      this_2.g7f(this_2.c6s() + 1 | 0);
      var blockSize = this_2.g6q_1;
      var index0 = imul(this_2.c6s() - 1 | 0, blockSize);
      var index1 = imul(this_2.c6s(), blockSize);
      var texBlockSize = this_2.d6q_1.c6y().e1();
      var texIndex0 = imul(this_2.c6s() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.c6s(), texBlockSize);
      if (this_2.c6s() > 0) {
        arraycopy(this_2.i6q_1, index0, this_2.i6q_1, index1, blockSize);
      } else {
        arrayfill(this_2.i6q_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.d6q_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.j6q_1.l7f(ShapeViewUB_getInstance().cdh(), 5);
      if (true && this_2.c6s() >= 1) {
        var equals = arrayequal(this_2.i6q_1, index0, this_2.i6q_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.c6s();
          this_2.f7f(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.rdf_1 = new PaintShader(this_2, null);
  }
  cdh() {
    return ShapeViewUB_getInstance().cdh().w6r_1;
  }
  ddh() {
    return ShapeViewUB_getInstance().ddh().w6r_1;
  }
  ndb() {
    return ShapeViewUB_getInstance().ndb().w6r_1;
  }
  edh() {
    return ShapeViewUB_getInstance().edh().w6r_1;
  }
  bdh() {
    return ShapeViewUB_getInstance().bdh().w6r_1;
  }
  fdh() {
    return ShapeViewUB_getInstance().fdh().w6r_1;
  }
  gdh() {
    return ShapeViewUB_getInstance().gdh().w6r_1;
  }
  hdh() {
    return ShapeViewUB_getInstance().hdh().w6r_1;
  }
  idh(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_25().z7l_1;
    return $this$ExpressionBuilder.f72(_this__u8e3s4, $this$ExpressionBuilder.t70(2.0));
  }
  sdf(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.t2q();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.c6s();
          this_0.f7f(_unary__edvuaz + 1 | 0);
          this_0.g7f(this_0.c6s() + 1 | 0);
          var blockSize = this_0.g6q_1;
          var index0 = imul(this_0.c6s() - 1 | 0, blockSize);
          var index1 = imul(this_0.c6s(), blockSize);
          var texBlockSize = this_0.d6q_1.c6y().e1();
          var texIndex0 = imul(this_0.c6s() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.c6s(), texBlockSize);
          if (this_0.c6s() > 0) {
            arraycopy(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
          } else {
            arrayfill(this_0.i6q_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.d6q_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.j6q_1;
          it.l7f($this$push.cdh(), 0);
          it.r7f($this$push.ddh(), _RGBA___get_premultiplied__impl__3bulqc(paint.t4h_1));
          it.l7f($this$push.edh(), globalAlpha);
          if (true && this_0.c6s() >= 1) {
            var equals = arrayequal(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.c6s();
              this_0.f7f(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_34().g29_1.z2a(paint.t5s_1).z2a(stateTransform).t2a().g2a(1.0 / paint.s5s_1.x3z_1, 1.0 / paint.s5s_1.y3z_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.t2q();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.c6s();
            this_1.f7f(_unary__edvuaz_1 + 1 | 0);
            this_1.g7f(this_1.c6s() + 1 | 0);
            var blockSize_0 = this_1.g6q_1;
            var index0_0 = imul(this_1.c6s() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.c6s(), blockSize_0);
            var texBlockSize_0 = this_1.d6q_1.c6y().e1();
            var texIndex0_0 = imul(this_1.c6s() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.c6s(), texBlockSize_0);
            if (this_1.c6s() > 0) {
              arraycopy(this_1.i6q_1, index0_0, this_1.i6q_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.i6q_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.d6q_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.j6q_1;
            it_0.l7f($this$push_0.cdh(), 1);
            it_0.v7f($this$push_0.fdh(), toMatrix4(mat));
            it_0.l7f($this$push_0.edh(), globalAlpha);
            if (true && this_1.c6s() >= 1) {
              var equals_0 = arrayequal(this_1.i6q_1, index0_0, this_1.i6q_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.c6s();
                this_1.f7f(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.s5s_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.q3z(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.b40_1;
            if (true) {
              gradientBitmap.k40();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.e5s(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.n3z_1));
            }finally {
              result = true ? gradientBitmap.m40(rect) : 0;
            }
            var npaint = paint.f5s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_34().g29_1.z2a(paint.a5g_1).z2a(stateTransform));
            var mat_0 = paint.q5f_1.r3_1 === 0 ? npaint.g5g_1 : npaint.a5g_1.t2a();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.t2q();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.c6s();
              this_2.f7f(_unary__edvuaz_3 + 1 | 0);
              this_2.g7f(this_2.c6s() + 1 | 0);
              var blockSize_1 = this_2.g6q_1;
              var index0_1 = imul(this_2.c6s() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.c6s(), blockSize_1);
              var texBlockSize_1 = this_2.d6q_1.c6y().e1();
              var texIndex0_1 = imul(this_2.c6s() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.c6s(), texBlockSize_1);
              if (this_2.c6s() > 0) {
                arraycopy(this_2.i6q_1, index0_1, this_2.i6q_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.i6q_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.d6q_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.j6q_1;
              var tmp_0 = $this$push_1.cdh();
              var tmp0 = paint.q5f_1.r3_1;
              it_1.l7f(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.v7f($this$push_1.fdh(), toMatrix4(mat_0));
              it_1.t7f($this$push_1.gdh(), new Vector4F(paint.r5f_1, paint.s5f_1, paint.t5f_1, 1.0));
              it_1.t7f($this$push_1.hdh(), new Vector4F(paint.u5f_1, paint.v5f_1, paint.w5f_1, 1.0));
              it_1.l7f($this$push_1.edh(), globalAlpha);
              if (true && this_2.c6s() >= 1) {
                var equals_1 = arrayequal(this_2.i6q_1, index0_1, this_2.i6q_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.c6s();
                  this_2.f7f(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.td('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.v9j($this.k9i_1.u9j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.l9i_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_40() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().v1v($this.r9j_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.y9j(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.o9m(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.g1o($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_41() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.m9p_1.p9i_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.n9p_1.p9o_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_37()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_28().p2g_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.jl();
    var height = size.kl();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.z2i();
      rwidth = tmp1_elvis_lhs == null ? views_0.p9o_1.z2i() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.a2j();
      rheight = tmp3_elvis_lhs == null ? views_0.p9o_1.a2j() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.q9u(views_0, defaultTransition, name, Size2D.l2e(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).r9u($this.m9p_1.p9i_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.o9p_1($this.n9p_1.p9o_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.m9p_1.x9i_1) {
    var tmp_3 = $this.p9p_1.i8n($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.s9u_1, $this.t9u_1, $this.u9u_1, $this.v9u_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.g1o($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_39().lu()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().u67();
    try {
      var tmp0_elvis_lhs = $this.y9u_1.f9j_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().f41_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.w9u_1, $this.x9u_1, $this.y9u_1.e9j_1, null, $this.y9u_1.w9i_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().u67();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.u8m(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().u67();
    try {
      try {
        if (!($this.z9u_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().bi($this.z9u_1), $this.a9v_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.w8m(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_40().w9j_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.a2u(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.b2u(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().u67();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.u8m('setIcon', tmp$ret$5);
    }
  }
  $this$loop.b8n($this$loop.k8e());
  if (Companion_getInstance_39().lu()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.rc();
  var this_3 = Views.c9v(tmp$ret$6.dn(gameWindow.p8m()).dn(new InjectorContext($this.y9u_1.r9i_1)).dn(SupervisorJob()).dn(CoroutineName.v1b('Views')), $this.y9u_1.m9j_1 ? AGPrint.l7d() : $this$loop.o8m(), $this.y9u_1.r9i_1, input, $this.y9u_1.q9i_1, stats, gameWindow, $this.y9u_1.y9i_1, $this.y9u_1.z9i_1, $this.y9u_1.a9j_1, VOID, $this.y9u_1.p9j_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.g23($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_39().ou()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.r2x(), 'views', this_3);
  }
  var views = this_3;
  $this.y9u_1.r9i_1.a67(getKClass(GameWindow), gameWindow);
  $this.y9u_1.r9i_1.a67(getKClass(Korge), $this.y9u_1);
  views.s9o_1 = $this$loop.d8n();
  views.d9v($this.y9u_1.n9j_1);
  views.e9v($this.y9u_1.o9j_1);
  views.j9o_1 = numberToInt($this.y9u_1.c9j_1.r26_1);
  views.k9o_1 = numberToInt($this.y9u_1.c9j_1.s26_1);
  views.n9o_1 = $this.y9u_1.d9j_1.w9m_1;
  views.m9o_1 = $this.y9u_1.d9j_1.v9m_1;
  views.o9o_1 = $this.y9u_1.d9j_1.x9m_1;
  views.d9p_1 = $this.y9u_1.q9j_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().u67();
    try {
      KorgeReload_getInstance().t82(gameWindow);
      var tmp_4 = KorgeRunner_instance.f9v(views, gameWindow, true, $this$loop.a8n(), Companion_instance_1.d1v(), $this.y9u_1.j9j_1, $this.y9u_1.s9i_1).s17($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().u67();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.u8m(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().u67();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().u67();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.u8m(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.y9u_1, views, $this.b9v_1, gameWindow));
  if ($this.y9u_1.x9i_1) {
    var tmp_5 = gameWindow.i8n($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.g8n();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().z35();
      if (get_workerImpl().a36()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().t5o([config.n9i_1]);
      var iconPath = config.h9j_1;
      var imageFormats = config.n9i_1;
      var entry = config.l9j_1;
      var windowSize = config.b9j_1;
      if (!Companion_getInstance_39().ou()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().bi('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.o9i_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.rc().ed(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.k9j_1.m8o(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.e9j_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.f9j_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().f41_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.z8m(tmp_1);
      var tmp_3 = realGameWindow.j8n(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.l8d(Vector2D.w27(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.x87(button, true);
  input.w87(p, false);
  input.w87(p, true);
  $views.g9v();
  downPos._v = input.v87();
  downTime._v = new DateTime(Companion_getInstance_5().x1u());
  input.h87_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.x87(button, false);
  input.w87(p, false);
  $views.g9v();
  upPos._v = $views.g9n_1.v87();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.g9n_1.w87(p, false);
  $views.g9n_1.h87_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.g9v();
  moveTime._v = new DateTime(Companion_getInstance_5().x1u());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.g9n_1.w87(p, false);
  $views.g9v();
  moveTime._v = new DateTime(Companion_getInstance_5().x1u());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.i6e_1 = 0;
  mouseTouchEvent.l6e_1 = true;
  mouseTouchEvent.j6e_1 = Companion_getInstance_5().x1u();
  mouseTouchEvent.k6e_1 = false;
  mouseTouchEvent.t6e(type);
  mouseTouchEvent.y6e(button.z6h_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.u6e();
  $views.g6a(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.t6f_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.r87_1[gamepad.u6f_1].c6g(gamepad);
  }
  input.y87();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.i9v($fixedSizeStep, $views.h9v(), event.w6a_1, event.x6a_1);
    $views.g9n_1.g87_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.g9n_1.g87_1 = true;
      $views.g9n_1.h87_1 = false;
      $views.g9v();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_40().w9j_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.a2u(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.b2u(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.r9n_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.j9v($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().w9j_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.i6c_1, e.j6c_1, e.t6c_1);
    var tmp_0;
    switch (e.g6c_1.r3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.k6c_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.k6c_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.k6c_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.k6c_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.k6c_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().w9j_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().w9j_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.g6a(e);
    get_nativeSoundProvider().p2r(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.g6a(e);
    get_nativeSoundProvider().p2r(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.g6a(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().w9j_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.u87(e);
    var ee = $input.z86_1;
    var _iterator__ex2g4s = ee.q6e().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.v6d_1 = prepareViewsBase$getRealXY($views, t.a6e(), t.b6e(), e.k6e_1);
    }
    $views.g6a(ee);
    var tmp_0;
    if (ee.r6e() === 1) {
      var start = ee.b6f();
      var end = ee.c6f();
      var t_0 = first(ee.q6e());
      var p = t_0.v6d_1;
      var x = t_0.a6e();
      var y = t_0.b6e();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.h6c_1 = 0;
      this_1.k6c_1 = button;
      this_1.l6c_1 = end ? 0 : 1 << button.z6h_1;
      this_1.i6c_1 = numberToInt(x);
      this_1.j6c_1 = numberToInt(y);
      this_1.t6c_1 = false;
      this_1.u6c_1 = true;
      this_1.g6c_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.g6a(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_40().w9j_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.a2u(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.b2u(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.g6a(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.l9v($ag.h6j().a6j_1, $ag.h6j().b6j_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.g6a(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.x6a_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.c9o_1;
      var frameBuffer = this_0.h6j();
      this_0.x83_1.t2q();
      this_0.q83_1.l6j();
      var tmp_0;
      try {
        this_0.z8e(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.j1b(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.a8f();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.q83_1.u6e();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_40().x9j_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().t8a_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().f88_1.r26_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().f88_1.s26_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.t26(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.r26_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.s26_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.t26(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_26().i2g_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_27().z24() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().f41_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().e41_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).t9m(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.y9j(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.o9m(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.y9j(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_simpleAnimator(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = simpleAnimator$delegate;
    var property = simpleAnimator$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var simpleAnimator$delegate;
function _get_totalTime__xgts5c($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.x9v_1;
  totalTime$factory();
  return this_0.u1().f1v_1;
}
function Animator$TweenNode$computedVs$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.r9v_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.animate.TweenNode.computedVs$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item();
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    return toMutableList(tmp1_elvis_lhs == null ? toList(this$0.q9v_1) : tmp1_elvis_lhs);
  };
}
function Animator$TweenNode$totalTime$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.t9v_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0 = tmp0_safe_receiver();
      tmp = tmp_0 == null ? null : tmp_0.f1v_1;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new FastDuration(tmp_2)) == null) {
      tmp_1 = this$0.s9v_1;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return new FastDuration(tmp_1);
  };
}
var Companion_instance_16;
function Companion_getInstance_42() {
  if (Companion_instance_16 === VOID)
    new Companion_1();
  return Companion_instance_16;
}
function ensure($this) {
  if (!($this.j9w_1 == null))
    return ensure($this.j9w_1);
  if (!($this.u9w().q9w_1 == null))
    return Unit_instance;
  var tmp = $this.u9w();
  var tmp_0 = $this.u9w().m9w_1;
  tmp.q9w_1 = addFastUpdater($this.d9w_1, tmp_0, VOID, Animator$ensure$lambda($this));
}
function ensureInit($this) {
  var tmp0_elvis_lhs = $this.k9w_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var linit = tmp;
  $this.k9w_1 = null;
  linit($this);
}
function Animator$removeProps$lambda($props) {
  return function (it) {
    return !$props.z2(it.v8h_1);
  };
}
function Animator$ensure$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var tmp;
    if (this$0.r9w_1) {
      this$0.d9w_1.e9x();
      tmp = Unit_instance;
    }
    var tmp_0;
    if (FastDuration__compareTo_impl_4fhnj7(this$0.t9w_1.y9w(dt.f1v_1), Companion_instance_1.c1v()) >= 0) {
      if (this$0.i9w_1) {
        invoke(this$0.n9w_1);
      } else {
        this$0.f9x();
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function animator(_this__u8e3s4, defaultTime, defaultSpeed, defaultEasing, parallel, looped, startImmediately, block) {
  defaultTime = defaultTime === VOID ? Companion_getInstance_42().z9v_1 : defaultTime;
  defaultSpeed = defaultSpeed === VOID ? Companion_getInstance_42().a9w_1 : defaultSpeed;
  defaultEasing = defaultEasing === VOID ? Companion_getInstance_42().b9w_1 : defaultEasing;
  parallel = parallel === VOID ? false : parallel;
  looped = looped === VOID ? false : looped;
  startImmediately = startImmediately === VOID ? Companion_getInstance_42().c9w_1 : startImmediately;
  var tmp;
  if (block === VOID) {
    tmp = animator$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.apply' call
  var tmp0_fastDefaultTime = get_fast(defaultTime);
  var this_0 = new Animator(_this__u8e3s4, tmp0_fastDefaultTime, defaultSpeed, defaultEasing, parallel, looped, null, VOID, 0, startImmediately);
  // Inline function 'kotlin.contracts.contract' call
  block(this_0);
  return this_0;
}
function tween(_this__u8e3s4, vs, time, easing, name, replace) {
  time = time === VOID ? _this__u8e3s4.g9x() : time;
  easing = easing === VOID ? _this__u8e3s4.g9w_1 : easing;
  name = name === VOID ? null : name;
  replace = replace === VOID ? true : replace;
  _init_properties_Animator_kt__gicf47();
  return _this__u8e3s4.k9x(vs.slice(), VOID, get_fast(time), VOID, easing, name, replace);
}
function block(_this__u8e3s4, name, callback) {
  name = name === VOID ? null : name;
  _init_properties_Animator_kt__gicf47();
  _this__u8e3s4.i9x(new BlockNode(name, callback));
}
function simpleAnimator$delegate$lambda($this$PropertyThis) {
  _init_properties_Animator_kt__gicf47();
  // Inline function 'kotlin.also' call
  var this_0 = animator($this$PropertyThis, VOID, VOID, VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.animate.simpleAnimator$delegate.<anonymous>.<anonymous>' call
  this_0.r9w_1 = true;
  return this_0;
}
function animator$lambda(_this__u8e3s4) {
  _init_properties_Animator_kt__gicf47();
  return Unit_instance;
}
function simpleAnimator$factory() {
  return getPropertyCallableRef('simpleAnimator', 1, KProperty1, function (receiver) {
    return get_simpleAnimator(receiver);
  }, null);
}
function computedVs$factory() {
  return getPropertyCallableRef('computedVs', 1, KProperty1, function (receiver) {
    return receiver.z9w();
  }, null);
}
function totalTime$factory() {
  return getPropertyCallableRef('totalTime', 1, KProperty1, function (receiver) {
    return new FastDuration(_get_totalTime__xgts5c(receiver));
  }, null);
}
var properties_initialized_Animator_kt_opr5o7;
function _init_properties_Animator_kt__gicf47() {
  if (!properties_initialized_Animator_kt_opr5o7) {
    properties_initialized_Animator_kt_opr5o7 = true;
    simpleAnimator$delegate = new PropertyThis(VOID, simpleAnimator$delegate$lambda);
  }
}
function get_viewStageComponent(_this__u8e3s4) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = viewStageComponent$delegate;
    var property = viewStageComponent$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var viewStageComponent$delegate;
function set_viewsToTrack(_this__u8e3s4, _set____db54di) {
  _init_properties_StageComponent_kt__9w4k8v();
  var this_0 = viewsToTrack$delegate;
  var property = viewsToTrack$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_viewsToTrack(_this__u8e3s4) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = viewsToTrack$delegate;
    var property = viewsToTrack$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var viewsToTrack$delegate;
function onNewAttachDetach(_this__u8e3s4, onAttach, onDetach) {
  var tmp;
  if (onAttach === VOID) {
    tmp = onNewAttachDetach$lambda;
  } else {
    tmp = onAttach;
  }
  onAttach = tmp;
  var tmp_0;
  if (onDetach === VOID) {
    tmp_0 = onNewAttachDetach$lambda_0;
  } else {
    tmp_0 = onDetach;
  }
  onDetach = tmp_0;
  _init_properties_StageComponent_kt__9w4k8v();
  var view = _this__u8e3s4;
  var closeable = new CancellableGroup();
  var viewStageComponent = get_viewStageComponent(_this__u8e3s4);
  deferWithViews(view, VOID, VOID, onNewAttachDetach$lambda_1(view));
  closeable.cs(viewStageComponent.m9x_1.b1w(onNewAttachDetach$lambda_2(onAttach, view)));
  closeable.cs(viewStageComponent.n9x_1.b1w(onNewAttachDetach$lambda_3(onDetach, view)));
  return closeable;
}
function registerStageComponent(_this__u8e3s4, view) {
  _init_properties_StageComponent_kt__9w4k8v();
  var firstRun = get_viewsToTrack(_this__u8e3s4) == null;
  if (firstRun) {
    // Inline function 'kotlin.collections.linkedSetOf' call
    var tmp$ret$0 = LinkedHashSet.j1();
    set_viewsToTrack(_this__u8e3s4, tmp$ret$0);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  ensureNotNull(get_viewsToTrack(_this__u8e3s4)).h(view);
  if (!firstRun)
    return Unit_instance;
  var componentsInStagePrev = FastArrayList.sy();
  // Inline function 'kotlin.collections.linkedSetOf' call
  var componentsInStageCur = LinkedHashSet.j1();
  // Inline function 'kotlin.collections.linkedSetOf' call
  var componentsInStage = LinkedHashSet.j1();
  _this__u8e3s4.b9p_1.h1w(registerStageComponent$lambda(componentsInStagePrev, componentsInStageCur, _this__u8e3s4, componentsInStage));
}
function viewStageComponent$delegate$lambda($this$PropertyThis) {
  _init_properties_StageComponent_kt__9w4k8v();
  return new ViewStageComponent($this$PropertyThis);
}
function viewsToTrack$delegate$lambda() {
  _init_properties_StageComponent_kt__9w4k8v();
  return null;
}
function onNewAttachDetach$lambda(_this__u8e3s4, it) {
  _init_properties_StageComponent_kt__9w4k8v();
  return Unit_instance;
}
function onNewAttachDetach$lambda_0(_this__u8e3s4, it) {
  _init_properties_StageComponent_kt__9w4k8v();
  return Unit_instance;
}
function onNewAttachDetach$lambda_1($view) {
  return function (it) {
    registerStageComponent(it, $view);
    return Unit_instance;
  };
}
function onNewAttachDetach$lambda_2($onAttach, $view) {
  return function (it) {
    $onAttach(it, $view);
    return Unit_instance;
  };
}
function onNewAttachDetach$lambda_3($onDetach, $view) {
  return function (it) {
    $onDetach(it, $view);
    return Unit_instance;
  };
}
function registerStageComponent$lambda($componentsInStagePrev, $componentsInStageCur, $this_registerStageComponent, $componentsInStage) {
  return function (it) {
    $componentsInStagePrev.l3();
    var this_0 = $componentsInStagePrev;
    var elements = $componentsInStageCur;
    addAll(this_0, elements);
    $componentsInStageCur.l3();
    var tmp0_iterator = ensureNotNull(get_viewsToTrack($this_registerStageComponent)).a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.korge.component.registerStageComponent.<anonymous>.<anonymous>' call
      if (hasExtra(element, '__viewStageComponent') && !(element.o9x() == null)) {
        var it_0 = get_viewStageComponent(element);
        // Inline function 'kotlin.collections.plusAssign' call
        $componentsInStageCur.h(it_0);
        if (!$componentsInStage.z2(it_0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          $componentsInStage.h(it_0);
          it_0.m9x_1.i1w($this_registerStageComponent.q9n_1);
        }
      }
    }
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = $componentsInStagePrev.qy_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.component.registerStageComponent.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_1 = array[_unary__edvuaz];
      if (!$componentsInStageCur.z2(it_1)) {
        it_1.n9x_1.i1w($this_registerStageComponent.q9n_1);
        ensureNotNull(get_viewsToTrack($this_registerStageComponent)).m3(it_1.l9x_1);
      }
    }
    return Unit_instance;
  };
}
function viewStageComponent$factory() {
  return getPropertyCallableRef('viewStageComponent', 1, KProperty1, function (receiver) {
    return get_viewStageComponent(receiver);
  }, null);
}
function viewsToTrack$factory() {
  return getPropertyCallableRef('viewsToTrack', 1, KMutableProperty1, function (receiver) {
    return get_viewsToTrack(receiver);
  }, function (receiver, value) {
    return set_viewsToTrack(receiver, value);
  });
}
function viewsToTrack$factory_0() {
  return getPropertyCallableRef('viewsToTrack', 1, KMutableProperty1, function (receiver) {
    return get_viewsToTrack(receiver);
  }, function (receiver, value) {
    return set_viewsToTrack(receiver, value);
  });
}
var properties_initialized_StageComponent_kt_b9koe7;
function _init_properties_StageComponent_kt__9w4k8v() {
  if (!properties_initialized_StageComponent_kt_b9koe7) {
    properties_initialized_StageComponent_kt_b9koe7 = true;
    viewStageComponent$delegate = new PropertyThis('__viewStageComponent', viewStageComponent$delegate$lambda);
    viewsToTrack$delegate = new Property(VOID, viewsToTrack$delegate$lambda);
  }
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  if ($this.p9x_1.z2(it.p6b_1)) {
    var tmp = $this.q9x_1(it, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  var tmp = $this.r9x_1(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, e, $completion) {
  if ($this.s9x_1.z2(e.p6b_1)) {
    var tmp = $this.t9x_1(e, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, it, $completion) {
  var tmp = $this.u9x_1(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.b9y_1.z9x_1.u1w($this.c9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = $this.d9y_1.x9x_1.u1w($this.e9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.f9y_1.y9x_1.u1w($this.g9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$down$slambda_1($keys, $callback) {
  var i = new KeysEvents$down$slambda($keys, $callback);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$down$slambda_2($callback) {
  var i = new KeysEvents$down$slambda_0($callback);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$up$slambda_0($keys, $callback) {
  var i = new KeysEvents$up$slambda($keys, $callback);
  var l = function (e, $completion) {
    return i.h9y(e, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$typed$slambda_0($callback) {
  var i = new KeysEvents$typed$slambda($callback);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.n6a_1;
    tmp.w9x_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.i9y().d9n_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.n6a_1;
    tmp.w9x_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.i9y().d9n_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.n6a_1;
    tmp.w9x_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.i9y().d9n_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.g9n_1)) {
    set_mouseHitSearch(views.g9n_1, true);
    set_mouseHitResult(views.g9n_1, views.p9o_1.q9y(views.p9y()));
    var view = get_mouseHitResult(views.g9n_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.x23();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.j9n_1.n8m(), newCursor)) {
      views.j9n_1.m8m(newCursor);
    }
  }
  return get_mouseHitResult(views.g9n_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.m8e();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.b8d();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_17, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.r9y();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.s9y(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.c9o_1.o84_1;
      var this_1 = this_0.x84_1;
      if (!(this_1.s84_1 === this_0)) {
        this_1.s84_1 = this_0;
        this_1.c86();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.d86(tmp$ret$1);
      var tmp1_x = bounds.w25_1;
      var tmp2_y = bounds.x25_1;
      var tmp3_width = bounds.y25_1;
      var tmp4_height = bounds.z25_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().g41_1, 0.3);
      var tmp6_m = mouseHit.t9y();
      this_0.e86(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.c9o_1;
      var tmp8_font = _this__u8e3s4.u9y();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.p9y().m25_1 + ',' + $views.p9y().n25_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.n84_1;
      var tmp12_blendMode = Companion_getInstance_13().f83_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.g9n_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.r9y();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.c9o_1.o84_1;
      var this_3 = this_2.x84_1;
      if (!(this_3.s84_1 === this_2)) {
        this_3.s84_1 = this_2;
        this_3.c86();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.d86(tmp$ret$4);
      var tmp1_x_0 = bounds_0.w25_1;
      var tmp2_y_0 = bounds_0.x25_1;
      var tmp3_width_0 = bounds_0.y25_1;
      var tmp4_height_0 = bounds_0.z25_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().o4f(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.t9y();
      this_2.e86(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.c9o_1;
        var tmp8_font_0 = _this__u8e3s4.u9y();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.n84_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().f83_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.x23();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.ka0(views, dt.kj_1);
    return Unit_instance;
  };
}
var Companion_instance_17;
function Companion_getInstance_43() {
  return Companion_instance_17;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.fa0_1;
  var tmp = $this;
  tmp.fa0_1 = lastEventNew == null ? $this.fa0_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.fa0_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.w9y_1.pa0()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.n6a_1;
    tmp_0.x9y_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.ea0_1 = event;
    this$0.fa0_1.y6c(event);
    this$0.ga0_1 = event.u6c_1;
    this$0.da0_1 = true;
    var tmp_2;
    switch (event.g6c_1.r3_1) {
      case 2:
        this$0.ha0_1.y6c(event);
        this$0.y9z_1 = this$0.qa0().g9n_1.v87();
        this$0.v9z_1 = PerformanceCounter_getInstance().v67();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.v9z_1, this$0.w9z_1);
        var tmp_3;
        if (this$0.y9z_1.i2h(this$0.x9z_1) < this$0.qa0().g9n_1.c87_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.qa0().g9n_1.b87_1) < 0) {
          var _unary__edvuaz = this$0.ca0_1;
          this$0.ca0_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.ra0()) {
            this$0.z9y_1.i1w(this$0);
            var tmp_5;
            if (this$0.z9y_1.m1w() > 0) {
              event.a6d(this$0.w9y_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.r6c_1) {
          set_mouseDebugLastFrameClicked(this$0.qa0(), true);
        }

        this$0.w9z_1 = PerformanceCounter_getInstance().v67();
        this$0.x9z_1 = this$0.qa0().g9n_1.v87();
        var tmp_6;
        if (this$0.y9y_1.n1w()) {
          var tmp_7;
          if (this$0.ra0()) {
            this$0.y9y_1.i1w(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.ra0()) {
          this$0.o9z_1.i1w(this$0);
        } else {
          this$0.q9z_1.i1w(this$0);
        }

        this$0.p9z_1.i1w(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.f9z_1.i1w(this$0);
      tmp = Unit_instance;
    } else {
      this$0.g9z_1.i1w(this$0);
      this$0.i9z_1.i1w(this$0);
      tmp = Unit_instance;
    }
    this$0.j9z_1.i1w(this$0);
    return Unit_instance;
  };
}
function doubleClick(_this__u8e3s4, callback) {
  _init_properties_MouseEvents_kt__io5soc();
  return multiClick(_this__u8e3s4, 2, callback);
}
function multiClick(_this__u8e3s4, count, callback) {
  _init_properties_MouseEvents_kt__io5soc();
  var clickCount = {_v: 0};
  var lastClickTime = {_v: new DateTime(Companion_getInstance_5().t1u_1)};
  return _this__u8e3s4.z9y_1.h1w(multiClick$lambda(lastClickTime, clickCount, count, callback));
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function multiClick$lambda($lastClickTime, $clickCount, $count, $callback) {
  return function (it) {
    var currentClickTime = Companion_getInstance_5().x1u();
    var tmp;
    var tmp_0 = DateTime__minus_impl_10njw8(currentClickTime, $lastClickTime._v.a1v_1);
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(tmp_0, tmp$ret$0) > 0) {
      $clickCount._v = 0;
      tmp = Unit_instance;
    }
    $lastClickTime._v = new DateTime(currentClickTime);
    var _unary__edvuaz = $clickCount._v;
    $clickCount._v = _unary__edvuaz + 1 | 0;
    it.ca0_1 = $clickCount._v;
    var tmp_1;
    if ($clickCount._v === $count) {
      tmp_1 = $callback(it);
    }
    return Unit_instance;
  };
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function get_touch(_this__u8e3s4) {
  _init_properties_TouchEvents_kt__159jsq();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = touch$delegate;
    var property = touch$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var touch$delegate;
function onTouchEvent($this, views, e) {
  $this.wa1_1.l3();
  var now = views.h9n_1.x1u();
  if (e.h6e_1.equals(Type_START_getInstance())) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = e.q6e();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (!it.x6d_1.equals(Status_KEEP_getInstance())) {
        var info = $this.ya1($this.xa1($this.ua1_1.c2q(), it));
        info.ea1_1 = now;
        info.ia1_1 = views;
        // Inline function 'korlibs.datastructure.set' call
        var this_1 = $this.va1_1;
        var key = info.ba1_1;
        // Inline function 'kotlin.js.asDynamic' call
        this_1.set(key, info);
        $this.na1_1.i1w(info);
      }
    }
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_2 = e.q6e();
  var n_0 = 0;
  while (n_0 < this_2.e1()) {
    // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
    var _unary__edvuaz_0 = n_0;
    n_0 = _unary__edvuaz_0 + 1 | 0;
    var it_0 = this_2.d1(_unary__edvuaz_0);
    // Inline function 'korlibs.datastructure.get' call
    var this_3 = $this.va1_1;
    var key_0 = it_0.u6d_1;
    // Inline function 'kotlin.js.asDynamic' call
    var info_0 = this_3.get(key_0);
    if (!(info_0 == null)) {
      info_0.ha1_1 = now;
      $this.wa1_1.h($this.xa1(info_0, it_0));
    }
  }
  if (e.h6e_1.equals(Type_START_getInstance())) {
    $this.pa1_1.i1w($this);
  }
  if (e.h6e_1.equals(Type_MOVE_getInstance())) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = $this.wa1_1.qy_1;
    var n_1 = 0;
    while (n_1 < array.length) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_1 = array[_unary__edvuaz_1];
      $this.oa1_1.i1w(it_1);
    }
    $this.qa1_1.i1w($this);
  }
  if (e.h6e_1.equals(Type_END_getInstance())) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = e.q6e();
    var n_2 = 0;
    while (n_2 < this_4.e1()) {
      // Inline function 'korlibs.korge.input.TouchEvents.onTouchEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var it_2 = this_4.d1(_unary__edvuaz_2);
      if (!it_2.x6d_1.equals(Status_KEEP_getInstance())) {
        // Inline function 'korlibs.datastructure.get' call
        var this_5 = $this.va1_1;
        var key_1 = it_2.u6d_1;
        // Inline function 'kotlin.js.asDynamic' call
        var info_1 = this_5.get(key_1);
        if (!(info_1 == null)) {
          $this.ta1_1.i1w($this.xa1(info_1, it_2));
          $this.ra1_1.i1w($this);
          // Inline function 'korlibs.datastructure.remove' call
          var this_6 = $this.va1_1;
          var key_2 = info_1.ba1_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_6.delete(key_2);
          $this.ua1_1.d2q(info_1);
        }
      }
    }
  }
  $this.sa1_1.i1w($this);
}
function TouchEvents$infoPool$lambda(it) {
  return new Info(it);
}
function TouchEvents$lambda(this$0) {
  return function (e) {
    var tmp = e.n6a_1;
    onTouchEvent(this$0, tmp instanceof Views ? tmp : THROW_CCE(), e);
    return Unit_instance;
  };
}
function singleTouch(_this__u8e3s4, removeTouch, supportStartAnywhere, block) {
  removeTouch = removeTouch === VOID ? false : removeTouch;
  supportStartAnywhere = supportStartAnywhere === VOID ? false : supportStartAnywhere;
  _init_properties_TouchEvents_kt__159jsq();
  var ids = FastIntMap();
  touch(_this__u8e3s4, singleTouch$lambda(_this__u8e3s4, supportStartAnywhere, ids, block, removeTouch));
}
function touch(_this__u8e3s4, block) {
  _init_properties_TouchEvents_kt__159jsq();
  return block(get_touch(_this__u8e3s4));
}
function singleTouch$getById(ids, $block, id) {
  var tmp$ret$2;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var res = ids.get(id);
    if (!(res == null)) {
      tmp$ret$2 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new singleTouch$SingleTouchInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.input.singleTouch.getById.<anonymous>.<anonymous>' call
    $block(this_0.ia2_1, id);
    var out = this_0;
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'kotlin.js.asDynamic' call
    ids.set(id, out);
    tmp$ret$2 = out;
  }
  return tmp$ret$2;
}
function touch$delegate$lambda($this$PropertyThis) {
  _init_properties_TouchEvents_kt__159jsq();
  return new TouchEvents($this$PropertyThis);
}
function singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.ba1_1);
    var handler = info.ia2_1;
    info.ja2_1 = !($this_singleTouch.ka2(it.fa1_1) == null);
    var tmp;
    if (handler.aa2_1.n1w() && info.ja2_1) {
      handler.aa2_1.i1w(it);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($supportStartAnywhere) {
      handler.ba2_1.i1w(it);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.ba1_1);
    var tmp;
    if (!$supportStartAnywhere && !info.ja2_1) {
      return Unit_instance;
    }
    var handler = info.ia2_1;
    var tmp_0;
    if (handler.ca2_1.n1w() && !($this_singleTouch.ka2(it.fa1_1) == null)) {
      handler.ca2_1.i1w(it);
      tmp_0 = Unit_instance;
    }
    handler.da2_1.i1w(it);
    return Unit_instance;
  };
}
function singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block) {
  return function (it) {
    var info = singleTouch$getById($ids, $block, it.ba1_1);
    var tmp;
    if (!$supportStartAnywhere && !info.ja2_1) {
      return Unit_instance;
    }
    var handler = info.ia2_1;
    var hitTest = handler.ea2_1.n1w() || handler.ga2_1.n1w() ? !($this_singleTouch.ka2(it.fa1_1) == null) : false;
    var tmp_0;
    if (hitTest) {
      handler.ea2_1.i1w(it);
      tmp_0 = Unit_instance;
    }
    handler.fa2_1.i1w(it);
    var tmp_1;
    if (Companion_getInstance_29().d2h(it.ga1_1, it.fa1_1) <= it.qa0().g9n_1.c87_1 && Duration__compareTo_impl_pchp0f(it.ja1(), it.qa0().g9n_1.b87_1) <= 0) {
      if (info.ja2_1 && hitTest) {
        handler.ga2_1.i1w(it);
      }
      handler.ha2_1.i1w(it);
      tmp_1 = Unit_instance;
    }
    var tmp_2;
    if ($removeTouch) {
      var this_0 = $ids;
      var key = it.ba1_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_0.delete(key);
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  };
}
function singleTouch$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block, $removeTouch) {
  return function ($this$touch) {
    $this$touch.na1_1.h1w(singleTouch$lambda$lambda($this_singleTouch, $supportStartAnywhere, $ids, $block));
    $this$touch.oa1_1.h1w(singleTouch$lambda$lambda_0($supportStartAnywhere, $this_singleTouch, $ids, $block));
    $this$touch.ta1_1.h1w(singleTouch$lambda$lambda_1($supportStartAnywhere, $this_singleTouch, $removeTouch, $ids, $block));
    return Unit_instance;
  };
}
function touch$factory() {
  return getPropertyCallableRef('touch', 1, KProperty1, function (receiver) {
    return get_touch(receiver);
  }, null);
}
var properties_initialized_TouchEvents_kt_a232zc;
function _init_properties_TouchEvents_kt__159jsq() {
  if (!properties_initialized_TouchEvents_kt_a232zc) {
    properties_initialized_TouchEvents_kt_a232zc = true;
    touch$delegate = new PropertyThis(VOID, touch$delegate$lambda);
  }
}
function materialRoundRect(_this__u8e3s4, x, y, width, height, color, radius, shadowOffset, shadowColor, shadowRadius, highlightPos, highlightRadius, highlightColor, borderSize, borderColor) {
  color = color === VOID ? Colors_getInstance().g41_1 : color;
  radius = radius === VOID ? Companion_getInstance_30().u2d_1 : radius;
  shadowOffset = shadowOffset === VOID ? Companion_getInstance_29().o25_1 : shadowOffset;
  shadowColor = shadowColor === VOID ? Colors_getInstance().f41_1 : shadowColor;
  shadowRadius = shadowRadius === VOID ? 0.0 : shadowRadius;
  highlightPos = highlightPos === VOID ? Companion_getInstance_29().o25_1 : highlightPos;
  highlightRadius = highlightRadius === VOID ? 0.0 : highlightRadius;
  highlightColor = highlightColor === VOID ? Colors_getInstance().e41_1 : highlightColor;
  borderSize = borderSize === VOID ? 0.0 : borderSize;
  borderColor = borderColor === VOID ? Colors_getInstance().e41_1 : borderColor;
  $l$block: {
    // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
    var this_0 = _this__u8e3s4.h65().n6q(MaterialBlockUB_getInstance());
    var _unary__edvuaz = this_0.c6s();
    this_0.f7f(_unary__edvuaz + 1 | 0);
    this_0.g7f(this_0.c6s() + 1 | 0);
    var blockSize = this_0.g6q_1;
    var index0 = imul(this_0.c6s() - 1 | 0, blockSize);
    var index1 = imul(this_0.c6s(), blockSize);
    var texBlockSize = this_0.d6q_1.c6y().e1();
    var texIndex0 = imul(this_0.c6s() - 1 | 0, texBlockSize);
    var texIndex1 = imul(this_0.c6s(), texBlockSize);
    if (this_0.c6s() > 0) {
      arraycopy(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
    } else {
      arrayfill(this_0.i6q_1, 0, 0, blockSize);
    }
    // Inline function 'korlibs.korge.render.materialRoundRect.<anonymous>' call
    var $this$push = this_0.d6q_1;
    var it = this_0.j6q_1;
    it.u7f($this$push.aa3(), radius);
    it.m7f($this$push.ba3(), Vector2F.q2i(width, height));
    it.r7f($this$push.ca3(), _RGBA___get_premultipliedFast__impl__qiau4g(color));
    it.o7f($this$push.da3(), times(highlightPos, Size2D.l2e(width, height)));
    var tmp = $this$push.ea3();
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    it.l7f(tmp, highlightRadius * tmp$ret$0 * 1.25);
    it.r7f($this$push.fa3(), _RGBA___get_premultipliedFast__impl__qiau4g(highlightColor));
    it.k7f($this$push.ga3(), borderSize * 0.5);
    it.r7f($this$push.ha3(), _RGBA___get_premultipliedFast__impl__qiau4g(borderColor));
    it.r7f($this$push.ia3(), _RGBA___get_premultipliedFast__impl__qiau4g(shadowColor));
    it.o7f($this$push.ja3(), shadowOffset);
    it.l7f($this$push.ka3(), shadowRadius);
    if (true && this_0.c6s() >= 1) {
      var equals = arrayequal(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
      if (equals) {
        var _unary__edvuaz_0 = this_0.c6s();
        this_0.f7f(_unary__edvuaz_0 - 1 | 0);
        break $l$block;
      }
    }
  }
  _this__u8e3s4.r8f(x, y, width, height, MaterialRender_getInstance().wa3_1, Margin.u28(shadowRadius + shadowOffset.a()));
}
function drawText_0(_this__u8e3s4, placements, textRangeStart, textRangeEnd, filtering) {
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.n8f_1 : filtering;
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n_0 = 0;
  while (n_0 < placements.e1()) {
    // Inline function 'korlibs.korge.render.drawText.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    var it = placements.d1(_unary__edvuaz);
    var tmp = get_lazyBitmap(it.w5v_1);
    var tmp_0 = it.x5v_1;
    var tmp_1;
    if (tmp_0 == null ? true : tmp_0 instanceof RGBA) {
      var tmp_2 = tmp_0;
      tmp_1 = tmp_2 == null ? null : tmp_2.t4h_1;
    } else {
      tmp_1 = null;
    }
    var tmp0_elvis_lhs = tmp_1;
    var tmp_3;
    var tmp_4 = tmp0_elvis_lhs;
    if ((tmp_4 == null ? null : new RGBA(tmp_4)) == null) {
      tmp_3 = Colors_getInstance().e41_1;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    drawText_1(_this__u8e3s4, it.t5v_1, tmp, it.v5v_1, it.u5v_1, tmp_3, true, textRangeStart - n | 0, textRangeEnd - n | 0, filtering);
    n = n + it.t5v_1.length | 0;
  }
}
var MaterialBlockUB_instance;
function MaterialBlockUB_getInstance() {
  if (MaterialBlockUB_instance === VOID)
    new MaterialBlockUB();
  return MaterialBlockUB_instance;
}
var MaterialRender_instance;
function MaterialRender_getInstance() {
  if (MaterialRender_instance === VOID)
    new MaterialRender();
  return MaterialRender_instance;
}
function drawText_1(_this__u8e3s4, text, font, textSize, pos, color, baseline, textRangeStart, textRangeEnd, filtering) {
  textSize = textSize === VOID ? 16.0 : textSize;
  pos = pos === VOID ? Companion_getInstance_29().o25_1 : pos;
  color = color === VOID ? Colors_getInstance().e41_1 : color;
  baseline = baseline === VOID ? false : baseline;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.n8f_1 : filtering;
  var scale = font.r4t(textSize);
  var sx = pos.m25_1;
  var sy = pos.n25_1 + (baseline ? -font.x3g() * scale : 0.0);
  var n = 0;
  var inductionVariable = 0;
  var last = text.length;
  while (inductionVariable < last) {
    var char = charSequenceGet(text, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var glyph = font.t4t(char);
    if (textRangeStart <= n ? n < textRangeEnd : false) {
      _this__u8e3s4.p8f(new Rectangle(sx + glyph.c4s_1 * scale, sy + glyph.d4s_1 * scale, glyph.k4s() * scale, glyph.l4s() * scale), RGBA__times_impl_wehs9n(color, _this__u8e3s4.m8f_1), filtering, glyph.b4s_1, get_agProgram(font));
    }
    sx = sx + glyph.e4s_1 * scale;
    n = n + 1 | 0;
  }
}
function u_ShadowColor$factory() {
  return getPropertyCallableRef('u_ShadowColor', 1, KProperty1, function (receiver) {
    return receiver.ia3();
  }, null);
}
function u_ShadowRadius$factory() {
  return getPropertyCallableRef('u_ShadowRadius', 1, KProperty1, function (receiver) {
    return receiver.ka3();
  }, null);
}
function u_ShadowOffset$factory() {
  return getPropertyCallableRef('u_ShadowOffset', 1, KProperty1, function (receiver) {
    return receiver.ja3();
  }, null);
}
function u_HighlightPos$factory() {
  return getPropertyCallableRef('u_HighlightPos', 1, KProperty1, function (receiver) {
    return receiver.da3();
  }, null);
}
function u_HighlightRadius$factory() {
  return getPropertyCallableRef('u_HighlightRadius', 1, KProperty1, function (receiver) {
    return receiver.ea3();
  }, null);
}
function u_HighlightColor$factory() {
  return getPropertyCallableRef('u_HighlightColor', 1, KProperty1, function (receiver) {
    return receiver.fa3();
  }, null);
}
function u_Size$factory() {
  return getPropertyCallableRef('u_Size', 1, KProperty1, function (receiver) {
    return receiver.ba3();
  }, null);
}
function u_Radius$factory() {
  return getPropertyCallableRef('u_Radius', 1, KProperty1, function (receiver) {
    return receiver.aa3();
  }, null);
}
function u_BorderSizeHalf$factory() {
  return getPropertyCallableRef('u_BorderSizeHalf', 1, KProperty1, function (receiver) {
    return receiver.ga3();
  }, null);
}
function u_BorderColor$factory() {
  return getPropertyCallableRef('u_BorderColor', 1, KProperty1, function (receiver) {
    return receiver.ha3();
  }, null);
}
function u_BackgroundColor$factory() {
  return getPropertyCallableRef('u_BackgroundColor', 1, KProperty1, function (receiver) {
    return receiver.ca3();
  }, null);
}
function u_ShadowColor$factory_0() {
  return getPropertyCallableRef('u_ShadowColor', 1, KProperty1, function (receiver) {
    return receiver.ia3();
  }, null);
}
function u_ShadowRadius$factory_0() {
  return getPropertyCallableRef('u_ShadowRadius', 1, KProperty1, function (receiver) {
    return receiver.ka3();
  }, null);
}
function u_ShadowOffset$factory_0() {
  return getPropertyCallableRef('u_ShadowOffset', 1, KProperty1, function (receiver) {
    return receiver.ja3();
  }, null);
}
function u_HighlightPos$factory_0() {
  return getPropertyCallableRef('u_HighlightPos', 1, KProperty1, function (receiver) {
    return receiver.da3();
  }, null);
}
function u_HighlightRadius$factory_0() {
  return getPropertyCallableRef('u_HighlightRadius', 1, KProperty1, function (receiver) {
    return receiver.ea3();
  }, null);
}
function u_HighlightColor$factory_0() {
  return getPropertyCallableRef('u_HighlightColor', 1, KProperty1, function (receiver) {
    return receiver.fa3();
  }, null);
}
function u_Size$factory_0() {
  return getPropertyCallableRef('u_Size', 1, KProperty1, function (receiver) {
    return receiver.ba3();
  }, null);
}
function u_Radius$factory_0() {
  return getPropertyCallableRef('u_Radius', 1, KProperty1, function (receiver) {
    return receiver.aa3();
  }, null);
}
function u_BorderSizeHalf$factory_0() {
  return getPropertyCallableRef('u_BorderSizeHalf', 1, KProperty1, function (receiver) {
    return receiver.ga3();
  }, null);
}
function u_BorderColor$factory_0() {
  return getPropertyCallableRef('u_BorderColor', 1, KProperty1, function (receiver) {
    return receiver.ha3();
  }, null);
}
function u_BackgroundColor$factory_0() {
  return getPropertyCallableRef('u_BackgroundColor', 1, KProperty1, function (receiver) {
    return receiver.ca3();
  }, null);
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.r83_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.oa4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.b15(), SceneCancellationException.da4($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.qa0().d9n_1.dn(new InjectorContext(this$0.pa4())).dn(SupervisorJob(this$0.qa0().d9n_1.ed(Key_instance))).dn(CoroutineName.v1b('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.ra4(this$0.qa4().e1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.ja4_1.aa7(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.pa4().j67(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.b15();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.da7();
  }, null);
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var scene = $this.iaa_1.n9u_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.iaa_1.n9u_1) + ' . doFullReload=' + $this.jaa_1.qaa());
    var tmp;
    if ($this.jaa_1.qaa()) {
      tmp = $this.jaa_1.raa(getKClassFromExpression(scene), scene.pa4());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.iaa_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.l9u_1;
    var sceneInjector = this_0.k9u_1.f9n_1.c67().a67(getKClass(SceneContainer), this_0).a67(getKClass(Resources), new Resources(this_0.b15(), this_0.k9u_1.m9v().x33_1, this_0.k9u_1.m9v()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.a67(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.j67(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.jaa_1.n82(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_44().saa_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.a2u(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.b2u(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.l67(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.k9u_1.f9n_1.e67(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.jaa_1, scene));
    }
    var tmp_5 = this_0.uaa(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.qa0().s9y(scene_0.da7());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.j67($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.n82($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.vaa_1.da7();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.vaa_1.qa9(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.waa_1.da7();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.waa_1.ra9(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = $this.xaa_1.ta9($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.yaa_1.ua9($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.yaa_1.va9();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.zaa_1.wa9($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.aab_1.sa9($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.k9u_1.f9n_1.c67().a67(getKClass(SceneContainer), $this).a67(getKClass(Resources), new Resources($this.b15(), $this.k9u_1.m9v().x33_1, $this.k9u_1.m9v()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a67(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.j67(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_44().saa_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.a2u(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.b2u(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.l67(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.k9u_1.f9n_1.e67(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.uaa(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.n9u_1;
  $this.n9u_1 = newScene;
  $this.m9u_1.mad(newScene.ja4_1, transition);
  try {
    var tmp = newScene.b15();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.b15();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.m9u_1);
    var initial = Companion_getInstance_38().ox_1;
    var end = Companion_getInstance_38().rx_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween_0($this.m9u_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.m9u_1.jad_1 = Companion_getInstance_38().rx_1;
  }
  $this.m9u_1.nad();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.b15();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.b15();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_18;
function Companion_getInstance_44() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.n9u_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.j67($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.nx_1, p1.nx_1, p2.nx_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.jad_1);
  }, function (value) {
    $b0.jad_1 = value.nx_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.lad_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.sal();
  var nextAlpha = next.sal();
  try {
    prev.ral(1.0 - Ratio__toFloat_impl_1ftup5(ratio.nx_1));
    next.ral(Ratio__toFloat_impl_1ftup5(ratio.nx_1));
    prev.rag(ctx);
    next.rag(ctx);
  }finally {
    prev.ral(prevAlpha);
    next.ral(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function get_styles(_this__u8e3s4) {
  _init_properties_ViewStyles_kt__hdc4op();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = styles$delegate;
    var property = styles$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var styles$delegate;
var textFont$delegate;
var textSize$delegate;
var textColor$delegate;
var buttonBackColor$delegate;
var textAlignment$delegate;
function styles$delegate$lambda($this$PropertyThis) {
  _init_properties_ViewStyles_kt__hdc4op();
  return new ViewStyles($this$PropertyThis);
}
function styles$factory() {
  return getPropertyCallableRef('styles', 1, KProperty1, function (receiver) {
    return get_styles(receiver);
  }, null);
}
var properties_initialized_ViewStyles_kt_405jyh;
function _init_properties_ViewStyles_kt__hdc4op() {
  if (!properties_initialized_ViewStyles_kt_405jyh) {
    properties_initialized_ViewStyles_kt_405jyh = true;
    styles$delegate = new PropertyThis(VOID, styles$delegate$lambda);
    textFont$delegate = new ViewStyle(get_DefaultTtfFontAsBitmap());
    textSize$delegate = new ViewStyle(16.0);
    textColor$delegate = new ViewStyle(new RGBA(Colors_getInstance().e41_1));
    buttonBackColor$delegate = new ViewStyle(new RGBA(Colors_getInstance().h42_1));
    textAlignment$delegate = new ViewStyle(Companion_getInstance_3().q4z_1);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.no(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.a72($this$FUNC.z7m($this$FUNC.y7m(a, b), $this$FUNC.y7m($this$FUNC.z7m(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.n70($this$IF_ELSE_BINARY_LOOKUP.q70(), $this$IF_ELSE_BINARY_LOOKUP.y70(Companion_getInstance_6().r8a_1[n], $this$IF_ELSE_BINARY_LOOKUP.w70($$this$buildShader.j70(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function *_generator_invoke__zhh2q8_18($this, it, $completion) {
  if (!get_focused($this.fao_1))
    return Unit_instance;
  switch (it.p6b_1.r3_1) {
    case 25:
    case 44:
    case 48:
    case 23:
    case 46:
      if ($this.fao_1.lap(it)) {
        switch (it.p6b_1.r3_1) {
          case 48:
            if (it.s6b_1) {
              $this.fao_1.eap();
            } else {
              $this.fao_1.dap();
            }

            break;
          case 25:
          case 46:
            var tmp;
            // Inline function 'kotlin.text.isNotEmpty' call

            var this_0 = $this.fao_1.fap();
            if (charSequenceLength(this_0) > 0) {
              tmp = new TextClipboardData($this.fao_1.fap());
            } else {
              tmp = null;
            }

            var oldText = tmp;
            if (it.p6b_1.equals(Key_X_getInstance())) {
              var selection = $this.fao_1.gap();
              $this.fao_1.hap(withoutRange($this.fao_1.b5u(), $this.fao_1.gap()));
              $this.fao_1.iap(false, selection.d2_1);
            }

            if (oldText == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp_0 = _get_gameWindow__b33wdz($this.fao_1).x8n(oldText, $completion);
              if (tmp_0 === get_COROUTINE_SUSPENDED())
                tmp_0 = yield tmp_0;
            }

            break;
          case 44:
            var tmp_1 = _get_gameWindow__b33wdz($this.fao_1).y8n($completion);
            if (tmp_1 === get_COROUTINE_SUSPENDED())
              tmp_1 = yield tmp_1;
            var tmp_2 = tmp_1;
            var tmp3_safe_receiver = (tmp_2 == null ? true : tmp_2 instanceof TextClipboardData) ? tmp_2 : null;
            var rtext = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.n8o_1;
            if (!(rtext == null)) {
              $this.fao_1.jap(rtext);
            }

            break;
          case 23:
            $this.fao_1.kap();
            break;
          default:
            break;
        }
      }

      break;
    case 59:
    case 61:
      var range = $this.fao_1.gap();
      if (get_length(range) > 0) {
        $this.fao_1.hap(withoutRange($this.fao_1.b5u(), range));
        $this.fao_1.nap(range.d2_1);
      } else {
        if (it.p6b_1.equals(Key_BACKSPACE_getInstance())) {
          if ($this.fao_1.map() > 0) {
            var oldCursorIndex = $this.fao_1.map();
            $this.fao_1.hap(withoutIndex($this.fao_1.b5u(), $this.fao_1.map() - 1 | 0));
            $this.fao_1.nap(oldCursorIndex - 1 | 0);
          }
        } else {
          if ($this.fao_1.map() < $this.fao_1.b5u().length) {
            $this.fao_1.hap(withoutIndex($this.fao_1.b5u(), $this.fao_1.map()));
          }
        }
      }

      break;
    case 63:
      if ($this.fao_1.rap(it)) {
        $this.fao_1.iap(it.s6b_1, 0);
      } else {
        $this.fao_1.iap(it.s6b_1, $this.fao_1.qap($this.fao_1.oap(), $this.fao_1.pap(it)));
      }

      break;
    case 62:
      if ($this.fao_1.rap(it)) {
        $this.fao_1.iap(it.s6b_1, $this.fao_1.b5u().length);
      } else {
        $this.fao_1.iap(it.s6b_1, $this.fao_1.sap($this.fao_1.oap(), $this.fao_1.pap(it)));
      }

      break;
    case 74:
      $this.fao_1.iap(it.s6b_1, 0);
      break;
    case 75:
      $this.fao_1.iap(it.s6b_1, $this.fao_1.b5u().length);
      break;
    default:
      break;
  }
  return Unit_instance;
}
function setTextNoSnapshot($this, text, out) {
  if (!$this.cap_1($this.hao_1.b5u(), text))
    return null;
  out.tap_1 = $this.hao_1.b5u();
  out.uap_1 = $this.gap();
  $this.hao_1.hap(text);
  reclampSelection($this);
  $this.pao_1.i1w($this);
  return out;
}
function setTextNoSnapshot$default($this, text, out, $super) {
  out = out === VOID ? new TextSnapshot('', numberRangeToNumber(0, 0)) : out;
  return setTextNoSnapshot($this, text, out);
}
function clampIndex($this, index) {
  return clamp(index, 0, $this.b5u().length);
}
function reclampSelection($this) {
  $this.tat($this.oap(), $this.sat());
  $this.uat($this.oap());
}
function _get_gameWindow__b33wdz($this) {
  return ensureNotNull($this.hao_1.o9x()).qa0().j9n_1;
}
function TextEditController$lambda($this$onNewAttachDetach, it) {
  get_uiFocusManager($this$onNewAttachDetach.p9o_1);
  return Unit_instance;
}
function TextEditController$acceptTextChange$lambda(old, new_0) {
  return true;
}
function TextEditController$lambda_0(this$0) {
  return function () {
    var tmp;
    if (!get_focused(this$0)) {
      this$0.vao_1.y8m(false);
      tmp = Unit_instance;
    } else {
      var tmp_0;
      if (this$0.vat() === 0) {
        this$0.vao_1.y8m(!this$0.vao_1.val());
        tmp_0 = Unit_instance;
      } else {
        this$0.vao_1.y8m(true);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function TextEditController$slambda_1(this$0) {
  var i = new TextEditController$slambda(this$0);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function TextEditController$slambda_2(this$0) {
  var i = new TextEditController$slambda_0(this$0);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function TextEditController$lambda_1(this$0) {
  return function (it) {
    this$0.sao_1.i1w(this$0);
    var tmp0_safe_receiver = this$0.kao_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.iaw_1 = true;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_2(this$0) {
  return function (it) {
    this$0.tao_1.i1w(this$0);
    var tmp0_safe_receiver = this$0.kao_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.iaw_1 = false;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_3(this$0, $dragging) {
  return function (it) {
    this$0.nap(this$0.kaw(it.ua0()));
    $dragging._v = false;
    set_focused(this$0, true);
    return Unit_instance;
  };
}
function TextEditController$lambda_4(this$0, $dragging) {
  return function (it) {
    this$0.nap(this$0.kaw(it.ua0()));
    $dragging._v = false;
    return Unit_instance;
  };
}
function TextEditController$lambda_5($dragging, this$0) {
  return function (it) {
    $dragging._v = false;
    var tmp;
    if (get_focused(this$0)) {
      set_focused(this$0, false);
      blur(this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_6(this$0, $dragging) {
  return function (it) {
    var tmp;
    if (get_focused(this$0) && it.ya0()) {
      $dragging._v = true;
      this$0.law(this$0.kaw(it.ua0()));
      it.xa0();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_7($dragging, this$0) {
  return function (it) {
    var tmp;
    if (!$dragging._v && get_focused(this$0)) {
      blur(this$0);
      tmp = Unit_instance;
    }
    $dragging._v = false;
    return Unit_instance;
  };
}
function TextEditController$lambda_8(this$0) {
  return function (it) {
    var index = this$0.kaw(it.ua0());
    this$0.tat(this$0.qap(index, true), this$0.sap(index, true));
    return Unit_instance;
  };
}
function color$factory($b0) {
  return getPropertyCallableRef('color', 0, KMutableProperty0, function () {
    return new RGBA($b0.m5h());
  }, function (value) {
    return $b0.saz(value.t4h_1);
  });
}
function get_timers(_this__u8e3s4) {
  _init_properties_TimerComponents_kt__j84oeh();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = timers$delegate;
    var property = timers$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var timers$delegate;
function ensureUpdater($this) {
  if (!($this.yay_1 == null))
    return Unit_instance;
  var tmp = $this;
  tmp.yay_1 = addFastUpdater_0($this.uay_1, TimerComponents$ensureUpdater$lambda($this));
}
function addTimer($this, autoRemove, callback) {
  if ($this.xay_1.x27()) {
    var index = $this.xay_1.p3($this.xay_1.e1() - 1 | 0);
    $this.vay_1.o3(index, callback);
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = autoRemove ? 1 : 0;
    $this.way_1.n2k(index, tmp$ret$0);
    ensureUpdater($this);
    return _TimerRef___init__impl__cysrar(index);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  $this.vay_1.h(callback);
  // Inline function 'korlibs.math.toInt' call
  var tmp$ret$1 = autoRemove ? 1 : 0;
  $this.way_1.g2k(tmp$ret$1);
  ensureUpdater($this);
  return _TimerRef___init__impl__cysrar($this.vay_1.e1() - 1 | 0);
}
function removeTimer($this, ref) {
  $this.vay_1.o3(_TimerRef___get_index__impl__pnrx4q(ref), null);
  $this.way_1.n2k(_TimerRef___get_index__impl__pnrx4q(ref), 0);
  $this.xay_1.g2k(_TimerRef___get_index__impl__pnrx4q(ref));
}
function _interval($this, time, repeat, callback) {
  var elapsed = {_v: new FastDuration(get_fastMilliseconds_0(0))};
  var ref = {_v: new TimerRef(_TimerRef___init__impl__cysrar(-1))};
  ref._v = new TimerRef(addTimer($this, false, TimerComponents$_interval$lambda(elapsed, time, repeat, $this, ref, callback)));
  return Closeable(TimerComponents$_interval$lambda_0($this, ref));
}
function TimerComponents$ensureUpdater$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var this_0 = this$0.vay_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.time.TimerComponents.ensureUpdater.<anonymous>.<anonymous>' call
      var index = n;
      var tmp0_safe_receiver = this_0.d1(n);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(dt);
      if (!(this$0.way_1.d1(index) === 0)) {
        removeTimer(this$0, _TimerRef___init__impl__cysrar(index));
      }
      n = n + 1 | 0;
    }
    var tmp;
    if (this$0.vay_1.g1()) {
      var tmp0_safe_receiver_0 = this$0.yay_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.f6();
      }
      this$0.yay_1 = null;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda($elapsed, $time, $repeat, this$0, $ref, $callback) {
  return function (dt) {
    $elapsed._v = new FastDuration(FastDuration__plus_impl_q1enab($elapsed._v.f1v_1, dt.f1v_1));
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7($elapsed._v.f1v_1, $time) >= 0) {
      if (!$repeat) {
        removeTimer(this$0, $ref._v.taz_1);
      }
      $elapsed._v = new FastDuration(FastDuration__minus_impl_evs237($elapsed._v.f1v_1, $time));
      $callback();
      if (!$repeat)
        break $l$loop;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda_0(this$0, $ref) {
  return function () {
    removeTimer(this$0, $ref._v.taz_1);
    return Unit_instance;
  };
}
function _TimerRef___init__impl__cysrar(index) {
  return index;
}
function _TimerRef___get_index__impl__pnrx4q($this) {
  return $this;
}
function TimerRef__toString_impl_8hh2j7($this) {
  return 'TimerRef(index=' + $this + ')';
}
function TimerRef__hashCode_impl_d9ou9o($this) {
  return $this;
}
function TimerRef__equals_impl_2fvpr4($this, other) {
  if (!(other instanceof TimerRef))
    return false;
  if (!($this === (other instanceof TimerRef ? other.taz_1 : THROW_CCE())))
    return false;
  return true;
}
function timers$delegate$lambda($this$PropertyThis) {
  _init_properties_TimerComponents_kt__j84oeh();
  return new TimerComponents($this$PropertyThis);
}
function timers$factory() {
  return getPropertyCallableRef('timers', 1, KProperty1, function (receiver) {
    return get_timers(receiver);
  }, null);
}
var properties_initialized_TimerComponents_kt_v7ywzv;
function _init_properties_TimerComponents_kt__j84oeh() {
  if (!properties_initialized_TimerComponents_kt_v7ywzv) {
    properties_initialized_TimerComponents_kt_v7ywzv = true;
    timers$delegate = new PropertyThis('__ViewTimerComponents', timers$delegate$lambda);
  }
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_1(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.d1v() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds_0(300));
      } else {
        tmp_0 = Companion_instance_1.d1v();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.jb0(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_1(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.d1v() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.cb0_1) {
    $this.vaz_1.e9x();
  }
  if ($this.fb0_1) {
    return $this.ob0();
  }
  $this.db0_1 = FastDuration__plus_impl_q1enab($this.db0_1, dt);
  var ratio = clamp_0(FastDuration__div_impl_rlslck($this.db0_1, $this.eb0_1), 0.0, 1.0);
  $this.jb0($this.db0_1);
  $this.zaz_1($this.yaz_1.hx(ratio));
  var tmp;
  var tmp_0 = $this.pb0();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7_0($this.db0_1, $this.pb0()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.qb0();
  }
  if (ratio >= 1.0) {
    return $this.ob0();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.d8p_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.fb0_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.d1v()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.rc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_19($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.r19();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.rb0_1;
  $this.sb0_1._v = new TweenComponent(view, toList($this.tb0_1), $this.ub0_1, $this.vb0_1, $this.wb0_1, cancellable, $this.xb0_1, $this.yb0_1);
  var tmp$ret$0 = cancellable.d17();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.g1o($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_37());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function *_generator_invoke__zhh2q8_20($this, $completion) {
  var tmp = $this.zb0_1($this.ab1_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_21($this, $completion) {
  var tmp = $this.bb1_1($this.cb1_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_19;
function Companion_getInstance_45() {
  if (Companion_instance_19 === VOID)
    new Companion_4();
  return Companion_instance_19;
}
function _get_halfSide__37ya73($this) {
  // Inline function 'kotlin.math.min' call
  var a = $this.z2i();
  var b = $this.a2j();
  var tmp$ret$0 = Math.min(a, b);
  return numberToInt(tmp$ret$0) / 2 | 0;
}
function setInitialState($this) {
  var width = $this.z2i();
  var height = $this.a2j();
  size($this.ib4_1, width, height);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_30();
  var corner = $this.vb4();
  var tmp$ret$0 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  $this.ib4_1.bb8(tmp$ret$0);
  $this.ib4_1.cb8($this.hb4_1 ? 10.0 : 0.0);
  size($this.jb4_1, width, height);
  var tmp = Companion_getInstance_46();
  var tmp0_elvis_lhs = $this.rb4_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    tmp_0 = get_Bitmaps_transparent();
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  tmp.gb8($this.lb4_1, tmp_0, width, height, Companion_getInstance_27().r24_1);
  $this.lb4_1.ral(!$this.hb8() ? 0.5 : $this.mb4_1 ? 1.0 : 1.0);
  $this.e9x();
}
function UIButton$lambda$lambda(this$0) {
  return function (it) {
    this$0.ib8(it.ka1() / this$0.z2i(), it.la1() / this$0.a2j());
    var tmp;
    if (this$0.maz()) {
      set_focused(this$0, true);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function UIButton$lambda$lambda_0(this$0) {
  return function (it) {
    this$0.fbb();
    return Unit_instance;
  };
}
function UIButton$lambda$lambda_1(this$0) {
  return function (it) {
    this$0.sb4_1.i1w(it);
    return Unit_instance;
  };
}
function UIButton$lambda(this$0) {
  return function ($this$singleTouch, it) {
    $this$singleTouch.aa2_1.h1w(UIButton$lambda$lambda(this$0));
    $this$singleTouch.fa2_1.h1w(UIButton$lambda$lambda_0(this$0));
    $this$singleTouch.ga2_1.h1w(UIButton$lambda$lambda_1(this$0));
    return Unit_instance;
  };
}
function UIButton$slambda_3($$this$mouse, this$0) {
  var i = new UIButton$slambda($$this$mouse, this$0);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$lambda$slambda_1($handler, $it) {
  var i = new UIButton$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function UIButton$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately_0(tmp, UIButton$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function UIButton$slambda_4($$this$mouse, this$0) {
  var i = new UIButton$slambda_0($$this$mouse, this$0);
  var l = function (it, $completion) {
    return i.ibb(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$lambda$slambda_2($handler, $it) {
  var i = new UIButton$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function UIButton$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.ta0();
    launchImmediately_0(tmp, UIButton$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function _interpolateColor$ref() {
  var l = function (p0, p1, p2) {
    return new RGBA(_interpolateColor(p0.nx_1, p1.t4h_1, p2.t4h_1));
  };
  l.callableName = '_interpolateColor';
  return l;
}
function UIButton$slambda_5(this$0) {
  var i = new UIButton$slambda_1(this$0);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function UIButton$slambda_6(this$0, $$this$keys) {
  var i = new UIButton$slambda_2(this$0, $$this$keys);
  var l = function (it, $completion) {
    return i.h9y(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function align$factory($b0) {
  return getPropertyCallableRef('align', 0, KMutableProperty0, function () {
    return $b0.qbe_1;
  }, function (value) {
    return $b0.xbh(value);
  });
}
function text$factory($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.pbe_1;
  }, function (value) {
    return $b0.ybh(value);
  });
}
function over$factory() {
  return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
    return receiver.a9z_1;
  }, null);
}
function out$factory() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.b9z_1;
  }, null);
}
function bgColor$factory($b0) {
  return getPropertyCallableRef('bgColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.qb7_1);
  }, function (value) {
    return $b0.wbh(value.t4h_1);
  });
}
function get_UI_DEFAULT_SIZE() {
  _init_properties_UIDefaults_kt__ebmksm();
  return UI_DEFAULT_SIZE;
}
var UI_DEFAULT_SIZE;
var properties_initialized_UIDefaults_kt_arkqjc;
function _init_properties_UIDefaults_kt__ebmksm() {
  if (!properties_initialized_UIDefaults_kt_arkqjc) {
    properties_initialized_UIDefaults_kt_arkqjc = true;
    UI_DEFAULT_SIZE = Size2D.t26(100, 32);
  }
}
function set__focusable(_this__u8e3s4, _set____db54di) {
  _init_properties_UIFocusManager_kt__odyms7();
  var this_0 = _focusable$delegate;
  var property = _focusable$factory();
  var tmp0_elvis_lhs = this_0.cy_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _focusable$delegate;
    var property = _focusable$factory_0();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _focusable$delegate;
function get_uiFocusManager(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = uiFocusManager$delegate;
    var property = uiFocusManager$factory();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var uiFocusManager$delegate;
function set_focused(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.baz(Scope_instance).o9x();
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_uiFocusManager(tmp0_safe_receiver);
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.qbz(value ? _this__u8e3s4 : null);
  }
}
function get_focused(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.baz(Scope_instance).o9x();
  return equals(tmp0_safe_receiver == null ? null : get_uiFocusedView(tmp0_safe_receiver), _this__u8e3s4);
}
function focus(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, true);
}
function blur(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, false);
}
var Scope_instance;
function Scope_getInstance() {
  return Scope_instance;
}
function _get_rfocusView__qys03k(_this__u8e3s4, $this) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIFocusManager.<get-rfocusView>.<anonymous>' call
  return _this__u8e3s4.baz(Scope_instance);
}
function UIFocusManager$changeFocusIndex$lambda(it) {
  return !(get_focusable(it) == null);
}
function UIFocusManager$changeFocusIndex$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
  var tmp = a.laz();
  // Inline function 'korlibs.korge.ui.UIFocusManager.changeFocusIndex.<anonymous>' call
  var tmp$ret$1 = b.laz();
  return compareValues(tmp, tmp$ret$1);
}
function UIFocusManager$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it.p6b_1.equals(Key_TAB_getInstance())) {
      this$0.sbz(it.s6b_1 ? -1 : 1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function get_uiFocusedView(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  return get_uiFocusManager(_this__u8e3s4).qaz_1;
}
function set_focusable(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  set__focusable(_this__u8e3s4, value);
}
function get_focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, UIFocusable) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? get__focusable(_this__u8e3s4) : tmp0_elvis_lhs;
}
function _focusable$delegate$lambda() {
  _init_properties_UIFocusManager_kt__odyms7();
  return null;
}
function uiFocusManager$delegate$lambda($this$PropertyThis) {
  _init_properties_UIFocusManager_kt__odyms7();
  return new UIFocusManager($this$PropertyThis);
}
function _focusable$factory() {
  return getPropertyCallableRef('_focusable', 1, KMutableProperty1, function (receiver) {
    return get__focusable(receiver);
  }, function (receiver, value) {
    return set__focusable(receiver, value);
  });
}
function _focusable$factory_0() {
  return getPropertyCallableRef('_focusable', 1, KMutableProperty1, function (receiver) {
    return get__focusable(receiver);
  }, function (receiver, value) {
    return set__focusable(receiver, value);
  });
}
function uiFocusManager$factory() {
  return getPropertyCallableRef('uiFocusManager', 1, KProperty1, function (receiver) {
    return get_uiFocusManager(receiver);
  }, null);
}
var properties_initialized_UIFocusManager_kt_a5rjit;
function _init_properties_UIFocusManager_kt__odyms7() {
  if (!properties_initialized_UIFocusManager_kt_a5rjit) {
    properties_initialized_UIFocusManager_kt_a5rjit = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _focusable$delegate$lambda;
    _focusable$delegate = new Property(null, default_0);
    uiFocusManager$delegate = new PropertyThis(VOID, uiFocusManager$delegate$lambda);
  }
}
function _interpolate$ref() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.nx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function UIMaterialLayer$Highlights$addHighlight$lambda(this$0) {
  return function (it) {
    this$0.vbz_1.e9x();
    return Unit_instance;
  };
}
function _interpolate$ref_0() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.nx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function _interpolate$ref_1() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.nx_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function UIMaterialLayer$Highlights$removeHighlight$lambda(this$0) {
  return function (it) {
    this$0.vbz_1.e9x();
    return Unit_instance;
  };
}
function UIMaterialLayer$Highlights$removeHighlight$lambda_0(this$0, $highlight) {
  return function () {
    this$0.wbz_1.m3($highlight);
    return Unit_instance;
  };
}
function _get_computedRadius__cigsus($this) {
  var tmp0_safe_receiver = $this.sb7_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = $this.z2i();
    var b = $this.a2j();
    var tmp$ret$0 = Math.min(a, b);
    tmp = tmp0_safe_receiver.d2e(tmp$ret$0 / 2.0);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? $this.rb7_1 : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? Companion_getInstance_30().u2d_1 : tmp2_elvis_lhs;
}
function radiusRatio$factory($b0) {
  return getPropertyCallableRef('radiusRatio', 0, KMutableProperty0, function () {
    return $b0.zbz_1;
  }, function (value) {
    $b0.zbz_1 = value;
    return Unit_instance;
  });
}
function radiusRatio$factory_0($b0) {
  return getPropertyCallableRef('radiusRatio', 0, KMutableProperty0, function () {
    return $b0.zbz_1;
  }, function (value) {
    $b0.zbz_1 = value;
    return Unit_instance;
  });
}
function alpha$factory($b0) {
  return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
    return $b0.ac0_1;
  }, function (value) {
    $b0.ac0_1 = value;
    return Unit_instance;
  });
}
function containerPos$factory() {
  return getPropertyCallableRef('containerPos', 1, KMutableProperty1, function (receiver) {
    return receiver.bc4();
  }, function (receiver, value) {
    return receiver.cc4(value);
  });
}
function containerPos$factory_0() {
  return getPropertyCallableRef('containerPos', 1, KMutableProperty1, function (receiver) {
    return receiver.bc4();
  }, function (receiver, value) {
    return receiver.cc4(value);
  });
}
function set_uiTextInputBackgroundRender(_this__u8e3s4, _set____db54di) {
  _init_properties_UITextInput_kt__kefnmf();
  uiTextInputBackgroundRender$delegate;
  var property = uiTextInputBackgroundRender$factory();
  if (_this__u8e3s4.san_1 == null)
    _this__u8e3s4.san_1 = linkedHashMapOf([]);
  // Inline function 'kotlin.collections.set' call
  var this_0 = ensureNotNull(_this__u8e3s4.san_1);
  var key = property.callableName;
  this_0.i3(key, _set____db54di);
  _this__u8e3s4.xan();
  return Unit_instance;
}
function get_uiTextInputBackgroundRender(_this__u8e3s4) {
  _init_properties_UITextInput_kt__kefnmf();
  // Inline function 'korlibs.korge.style.ViewStyle.getValue' call
  var this_0 = uiTextInputBackgroundRender$delegate;
  var property = uiTextInputBackgroundRender$factory_0();
  var tmp = _this__u8e3s4.uan(property, this_0.yan_1);
  var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var message = "Can't cast " + toString(property) + ' to T';
    throw IllegalStateException.z4(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
var uiTextInputBackgroundRender$delegate;
function UITextInput$bg$lambda($this$renderableView) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UITextInput.bg.<anonymous>.<anonymous>' call
  get_uiTextInputBackgroundRender(get_styles($this$renderableView)).ec4($this$renderableView);
  return Unit_instance;
}
function uiTextInputBackgroundRender$delegate$lambda($this$ViewRenderer) {
  _init_properties_UITextInput_kt__kefnmf();
  $this$ViewRenderer.rcc().q8f(new Rectangle(0.0, 0.0, $this$ViewRenderer.z2i(), $this$ViewRenderer.a2j()), Colors_getInstance().e41_1);
  return Unit_instance;
}
function uiTextInputBackgroundRender$factory() {
  return getPropertyCallableRef('uiTextInputBackgroundRender', 1, KMutableProperty1, function (receiver) {
    return get_uiTextInputBackgroundRender(receiver);
  }, function (receiver, value) {
    return set_uiTextInputBackgroundRender(receiver, value);
  });
}
function uiTextInputBackgroundRender$factory_0() {
  return getPropertyCallableRef('uiTextInputBackgroundRender', 1, KMutableProperty1, function (receiver) {
    return get_uiTextInputBackgroundRender(receiver);
  }, function (receiver, value) {
    return set_uiTextInputBackgroundRender(receiver, value);
  });
}
function viewRenderer$factory($b0) {
  return getPropertyCallableRef('viewRenderer', 0, KMutableProperty0, function () {
    return $b0.gaw_1;
  }, function (value) {
    $b0.gaw_1 = value;
    return Unit_instance;
  });
}
function text$factory_0($b0) {
  return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
    return $b0.b5u();
  }, function (value) {
    return $b0.hap(value);
  });
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.faz();
  }, function (value) {
    return $b0.eaz(value);
  });
}
function font$factory($b0) {
  return getPropertyCallableRef('font', 0, KMutableProperty0, function () {
    return $b0.y53();
  }, function (value) {
    return $b0.caz(value);
  });
}
function onReturnPressed$factory($b0) {
  return getPropertyCallableRef('onReturnPressed', 0, KProperty0, function () {
    return $b0.oao_1;
  }, null);
}
function onEscPressed$factory($b0) {
  return getPropertyCallableRef('onEscPressed', 0, KProperty0, function () {
    return $b0.nao_1;
  }, null);
}
function onFocusLost$factory($b0) {
  return getPropertyCallableRef('onFocusLost', 0, KProperty0, function () {
    return $b0.rao_1;
  }, null);
}
function selectionRange$factory($b0) {
  return getPropertyCallableRef('selectionRange', 0, KMutableProperty0, function () {
    return $b0.gap();
  }, function (value) {
    return $b0.gaz(value);
  });
}
function selectionStart$factory($b0) {
  return getPropertyCallableRef('selectionStart', 0, KMutableProperty0, function () {
    return $b0.oap();
  }, function (value) {
    return $b0.uat(value);
  });
}
function selectionEnd$factory($b0) {
  return getPropertyCallableRef('selectionEnd', 0, KMutableProperty0, function () {
    return $b0.sat();
  }, function (value) {
    return $b0.law(value);
  });
}
function selectionLength$factory($b0) {
  return getPropertyCallableRef('selectionLength', 0, KProperty0, function () {
    return $b0.vat();
  }, null);
}
function text$factory_1() {
  return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
    return receiver.b5u();
  }, function (receiver, value) {
    return receiver.hap(value);
  });
}
function text$factory_2() {
  return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
    return receiver.b5u();
  }, function (receiver, value) {
    return receiver.hap(value);
  });
}
var properties_initialized_UITextInput_kt_7ksi6x;
function _init_properties_UITextInput_kt__kefnmf() {
  if (!properties_initialized_UITextInput_kt_7ksi6x) {
    properties_initialized_UITextInput_kt_7ksi6x = true;
    var tmp = uiTextInputBackgroundRender$delegate$lambda;
    uiTextInputBackgroundRender$delegate = new ViewStyle(new sam$korlibs_korge_view_ViewRenderer$0_0(tmp));
  }
}
function registerUISupportOnce($this) {
  if ($this.jag_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.o9x();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.jag_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_20;
function Companion_getInstance_46() {
  if (Companion_instance_20 === VOID)
    new Companion_5();
  return Companion_instance_20;
}
function get_centered(_this__u8e3s4) {
  return center(_this__u8e3s4);
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.gc0(anchor);
  return _this__u8e3s4;
}
function center(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.anchor' call
  return anchor(_this__u8e3s4, Anchor2D.a25(numberToDouble(0.5), numberToDouble(0.5)));
}
function clearBitmaps($this, onParentChanged) {
  if ($this.gck_1.g1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.gck_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.d1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.lck_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j84_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.f8a(it, 'BaseGraphics');
      }
    }
  }
  $this.gck_1.l3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.c5m().z2i();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.c5m().a2j();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.w25_1 - $this.hak(), bounds.x25_1 - $this.iak(), bounds.y25_1, bounds.z25_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.pck_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.kck_1) {
    $this.kck_1 = false;
    $this.rck_1 = $this.sck(false);
    $this.qck_1 = $this.sck(true);
  }
  return strokes ? $this.qck_1 : $this.rck_1;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.v62();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.aa7(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.pcw();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.xaj(this_0);
  return this_0;
}
var Companion_instance_21;
function Companion_getInstance_47() {
  return Companion_instance_21;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().w67())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.qa0().b9p_1;
  tmp.h1w(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.qa0().c9o_1).r8d_1;
  tmp_0.h1w(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.qa0().c9o_1.o84_1.w85_1;
  tmp_1.h1w(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.qa0().c9o_1.o84_1.x85_1;
  tmp_2.h1w(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.qa0();
  tmp_3.rcw(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.z8d_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.m8b() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.u9y();
  var tmp1_colMul = $ctx.n84_1;
  var tmp2_blendMode = Companion_getInstance_13().f83_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.m8e();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().w67();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.f1v_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, get_fastMilliseconds_0(4)) > 0) {
        $longWindow.ycw(elapsedTime);
        $shortWindow.ycw(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.q9n_1.b8d();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.wcw(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_39().ku() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.c9o_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.q8d_1;
    if (!(this_2.s84_1 === this_1)) {
      this_2.s84_1 = this_1;
      this_2.c86();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.c8e_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().f83_1;
          var doUpdate = !(this_1.b8e_1 === blending);
          var old = this_1.b8e_1;
          try {
            if (doUpdate) {
              this_1.q8d_1.c86();
              this_1.b8e_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().u46_1;
            var oldColor = this_1.t8d_1;
            this_1.t8d_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.h8e(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.h8e(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.t8d_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().e41_1 : Colors_getInstance().f41_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.t8d_1;
                this_1.t8d_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.e1() / $longWindow.scw_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.e1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange_0(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var p1 = convertRange_0(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds_0(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.e1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.xcw(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.xcw(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.h8e(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.t8d_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.q8d_1.c86();
            }
            this_1.b8e_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.c8e_1;
  }, function (value) {
    $b0.c8e_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.hcz_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.icz_1 : tmp0_elvis_lhs);
}
function ensure_0($this) {
  if ($this.ocz_1.r3_1 === 2) {
    if (!($this.hcz_1 == null)) {
      var tmp1_safe_receiver = $this.hcz_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.qam();
      }
      $this.hcz_1 = null;
    }
    if ($this.icz_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.od2(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).n4y();
      this_0.pd2(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.qd2($this.jcz_1);
      this_1.pd1_1 = $this.mcz_1;
      this_1.rd1_1 = $this.lcz_1;
      this_1.pd2($this.ncz_1);
      tmp.icz_1 = this_1;
    }
  } else {
    if (!($this.icz_1 == null)) {
      var tmp2_safe_receiver = $this.icz_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.qam();
      }
      $this.icz_1 = null;
    }
    if ($this.hcz_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.kcu(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).n4y();
      this_2.lcu(tmp$ret$9);
      if (false) {
        this_2.ecl();
      }
      this_2.kck_1 = true;
      this_2.dam();
      this_2.ecl();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.ecu_1 = $this.jcz_1;
      this_2.cck_1 = $this.mcz_1;
      this_2.icn_1 = $this.lcz_1;
      this_2.lcu($this.ncz_1);
      tmp_0.hcz_1 = this_2;
    }
    var tmp3_safe_receiver = $this.hcz_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.ccl($this.ocz_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.wd2($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.bi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.acf(tmp_0);
    $this.wak(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.acf(tmp$ret$0);
      $this.wak(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.obh_1.wd2(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.zce_1.dz();
  if (!(source == null)) {
    $this.yce_1 = true;
    $this.ucn(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.gd3();
  }, function (value) {
    return $b0.fd3(value);
  });
}
var Companion_instance_22;
function Companion_getInstance_48() {
  return Companion_instance_22;
}
var Companion_instance_23;
function Companion_getInstance_49() {
  return Companion_instance_23;
}
function _set_animationNumberOfFramesRequested__tjl77x($this, value) {
  if (value === 0) {
    $this.nd8();
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    if ($this.bd8_1 === _AnimationType___init__impl__l3ftd1(0)) {
      triggerEvent($this, $this.pd8());
    } else {
      triggerEvent($this, $this.od8());
    }
  }
  $this.ad8_1 = value;
}
function _set_animationRemainingDuration__f6834h($this, value) {
  var tmp;
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
  if (FastDuration__compareTo_impl_4fhnj7_0(value, tmp$ret$1) <= 0) {
    var tmp_0 = $this.bd8_1;
    // Inline function 'korlibs.korge.view.Companion.DURATION' call
    tmp = tmp_0 === _AnimationType___init__impl__l3ftd1(2);
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.nd8();
    triggerEvent($this, $this.cd8_1);
  }
  $this.jd8_1 = value;
}
function _set_currentSpriteIndex__7b2y7x($this, value) {
  $this.ld8_1 = umod(value, $this.qd8());
  var tmp0_safe_receiver = $this.kd8_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.td8(value);
  $this.acf(tmp1_elvis_lhs == null ? $this.c5m() : tmp1_elvis_lhs);
}
function nextSprite($this, frameTime) {
  $this.id8_1 = FastDuration__plus_impl_q1enab($this.id8_1, frameTime);
  if (FastDuration__compareTo_impl_4fhnj7(FastDuration__plus_impl_q1enab($this.id8_1, frameTime), $this.gd8_1) >= 0) {
    var tmp0_subject = $this.bd8_1;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    if (tmp0_subject === _AnimationType___init__impl__l3ftd1(0)) {
      if ($this.ad8_1 > 0) {
        var _unary__edvuaz = $this.ad8_1;
        _set_animationNumberOfFramesRequested__tjl77x($this, _unary__edvuaz - 1 | 0);
      }
    } else {
      // Inline function 'korlibs.korge.view.Companion.DURATION' call
      if (tmp0_subject === _AnimationType___init__impl__l3ftd1(2)) {
        _set_animationRemainingDuration__f6834h($this, FastDuration__minus_impl_evs237($this.jd8_1, $this.id8_1));
      } else {
        // Inline function 'korlibs.korge.view.Companion.LOOPED' call
        _AnimationType___init__impl__l3ftd1(1);
      }
    }
    if ($this.md8_1) {
      _set_currentSpriteIndex__7b2y7x($this, $this.ld8_1 - 1 | 0);
    } else {
      _set_currentSpriteIndex__7b2y7x($this, $this.ld8_1 + 1 | 0);
    }
    $this.zd7_1 = $this.zd7_1 + 1 | 0;
    triggerEvent($this, $this.fd8_1);
    $this.id8_1 = get_fastSeconds(0);
  }
}
function triggerEvent($this, signal) {
  if (!(signal == null)) {
    var tmp0_safe_receiver = $this.kd8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      signal.i1w(tmp0_safe_receiver);
    }
  }
}
function Sprite$lambda($this$addFastUpdater, frameTime) {
  if ($this$addFastUpdater.yd7_1) {
    nextSprite($this$addFastUpdater, frameTime.f1v_1);
  }
  return Unit_instance;
}
function _AnimationType___init__impl__l3ftd1(id) {
  return id;
}
var Companion_instance_24;
function Companion_getInstance_50() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_51() {
  return Companion_instance_25;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.o9o_1;
  }, function (value) {
    $b0.o9o_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.bd9();
  }, function (value) {
    return $b0.cd9(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.v62();
  }, function (receiver, value) {
    return receiver.ad9(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.v62();
  }, function (receiver, value) {
    return receiver.ad9(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.qag();
  }, function (receiver, value) {
    return receiver.pag(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.qag();
  }, function (receiver, value) {
    return receiver.pag(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.p4s()) {
    case 'msdf':
      return MsdfRender_getInstance().zan_1;
    case 'psdf':
      return MsdfRender_getInstance().cao_1;
    case 'sdf':
      return MsdfRender_getInstance().cao_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_22($this, $completion) {
  var tmp = $this.dd9_1.gd9(ensureNotNull(get_views($this.ed9_1)).a9o_1, $this.fd9_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_26;
function Companion_getInstance_52() {
  return Companion_instance_26;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.b5u();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.jas_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.hd9(sourceFile);
  $this.was_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.bi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.daz(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.jl();
  var y = pos.kl();
  if ($this.bat_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.tas_1.i51_1, $this.aat_1.y25_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.tas_1.j51_1, $this.aat_1.z25_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.uas_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory_0($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.oas_1;
  }, function (value) {
    return $b0.eaz(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.zas_1;
  }, function (value) {
    return $b0.hd9(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.n4s();
  }, function (receiver, value) {
    return receiver.jd9(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.n4s();
  }, function (receiver, value) {
    return receiver.jd9(value);
  });
}
function _get_allBitmap__bdn8f($this) {
  if ($this.dbf_1 == null) {
    var tmp = $this;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = $this.pbe_1.p5u();
      var tmp_0;
      if (isInterface(this_0, Collection)) {
        tmp_0 = this_0.g1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.TextBlock.<get-allBitmap>.<anonymous>' call
        if (!isInterface(element, BitmapFont)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp.dbf_1 = tmp$ret$0;
  }
  return ensureNotNull($this.dbf_1);
}
function invalidateText($this) {
  invalidProps($this);
  if ($this.ybe_1) {
    // Inline function 'korlibs.korge.view.size' call
    var width = $this.pbe_1.z2i();
    var height = $this.pbe_1.a2j();
    size($this, numberToDouble(width), numberToDouble(height));
  }
  $this.dbf_1 = null;
}
function invalidProps($this) {
  $this.obe_1 = true;
  $this.e9x();
}
function ensureTexture($this) {
  if (!$this.obe_1)
    return Unit_instance;
  $this.obe_1 = false;
  var bmp = NativeImage(toIntCeil($this.z2i()), toIntCeil($this.a2j()));
  if ($this.cbf_1 == null) {
    var tmp = $this;
    // Inline function 'korlibs.korge.view.image' call
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var texture = get_Bitmaps_transparent();
    var anchor = Companion_getInstance_27().n24_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Image.qbh(texture, anchor);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp.cbf_1 = addTo(this_0, $this);
  }
  var tmp0_safe_receiver = $this.cbf_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.acf(slice(bmp));
  }
  var tmp1_safe_receiver = $this.cbf_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    var tmp_0 = tmp1_safe_receiver;
    var tmp_1 = $this.pbe_1.a5v_1.d5u_1;
    var tmp2_safe_receiver = isInterface(tmp_1, BitmapFont) ? tmp_1 : null;
    tmp_0.mcn_1 = tmp2_safe_receiver == null ? null : get_agProgram(tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = $this.cbf_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.icn_1 = $this.bbf_1;
  }
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = bmp.b40_1;
  if (true) {
    bmp.k40();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = bmp.t47(true);
    try {
      // Inline function 'korlibs.korge.view.TextBlock.ensureTexture.<anonymous>' call
      var tmp0_text = $this.pbe_1;
      var tmp1_bounds = Companion_getInstance_33().h2e($this.xbe_1.s28_1, $this.xbe_1.p28_1, ctx.z2i() - $this.xbe_1.q28_1, ctx.a2j() - $this.xbe_1.r28_1);
      var tmp2_includePartialLines = $this.rbe_1;
      var tmp3_wordWrap = $this.vbe_1;
      var tmp4_ellipsis = $this.wbe_1;
      var tmp5_align = $this.qbe_1;
      var tmp6_fill = $this.tbe_1;
      var tmp7_stroke = $this.ube_1;
      var tmp8_textRangeStart = $this.zbe_1;
      var tmp9_textRangeEnd = $this.abf_1;
      drawRichText(ctx, tmp0_text, tmp1_bounds, tmp3_wordWrap, tmp2_includePartialLines, tmp4_ellipsis, tmp6_fill, tmp7_stroke, tmp5_align, true, tmp8_textRangeStart, tmp9_textRangeEnd);
    }finally {
      ctx.l18();
    }
  }finally {
    result = true ? bmp.m40(rect) : 0;
  }
}
var Companion_instance_27;
function Companion_getInstance_53() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
function setText(_this__u8e3s4, text) {
  foreachDescendant(_this__u8e3s4, setText$lambda(text));
}
function setText$lambda($text) {
  return function (it) {
    var tmp;
    if (isInterface(it, IText)) {
      it.hap($text);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var Companion_instance_28;
function Companion_getInstance_54() {
  return Companion_instance_28;
}
function updateRenderColorTransform($this) {
  $this.c9r_1 = $this.h9r_1;
  $this.j9r_1 = true;
  var parent = $this.x23();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.b9r_1.o4h($this.a9r_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.b9r_1.p4h($this.a9r_1, parent.yal());
    } else {
      $this.b9r_1.o4h($this.a9r_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.c9r_1 === $this.h9r_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.e9r_1 = $this.g9r_1;
  $this.i9r_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.g9q_1.equals(Companion_getInstance_13().w82_1)) {
    var tmp1_safe_receiver = $this.x23();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zal();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().v82_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.g9q_1;
  }
  tmp.d9r_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.e9r_1 === $this.g9r_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function View$addRenderPhase$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
  var tmp = a.od9();
  // Inline function 'korlibs.korge.view.View.addRenderPhase.<anonymous>' call
  var tmp$ret$1 = b.od9();
  return compareValues(tmp, tmp$ret$1);
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.c1v() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.v69(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_29;
  return _this__u8e3s4.v69(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.x23();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.cal(Scale.q2d(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.w27(x, y));
}
function size(_this__u8e3s4, width, height) {
  return size_0(_this__u8e3s4, Size2D.l2e(width, height));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.h1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.u9p_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.naj();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.d1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function scrollParentsToMakeVisible(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.firstAncestorOfType' call
  var tmp = firstAncestor(_this__u8e3s4, false, scrollParentsToMakeVisible$lambda);
  var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof UIScrollable) ? tmp : THROW_CCE();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.ac4(_this__u8e3s4);
  }
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.x23();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.x23();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.x23();
  }
  return count;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.b54(p);
  return _this__u8e3s4;
}
function size_0(_this__u8e3s4, size) {
  _this__u8e3s4.jal(size);
  return _this__u8e3s4;
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance().lj_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.v69(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function firstAncestor(_this__u8e3s4, includeThis, condition) {
  includeThis = includeThis === VOID ? true : includeThis;
  if (_this__u8e3s4 == null)
    return null;
  if (includeThis && condition(_this__u8e3s4))
    return _this__u8e3s4;
  var tmp0_safe_receiver = _this__u8e3s4.x23();
  return tmp0_safe_receiver == null ? null : firstAncestor(tmp0_safe_receiver, true, condition);
}
function rotation(_this__u8e3s4, rot) {
  _this__u8e3s4.gal(rot);
  return _this__u8e3s4;
}
function xy_0(_this__u8e3s4, x, y) {
  _this__u8e3s4.sak(x, y);
  return _this__u8e3s4;
}
function foreachDescendant(_this__u8e3s4, handler) {
  if (!(_this__u8e3s4 == null)) {
    handler(_this__u8e3s4);
    if (_this__u8e3s4.u9p_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.naj();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.foreachDescendant.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.d1(_unary__edvuaz);
          foreachDescendant(child, handler);
        }
        tmp = Unit_instance;
      }
    }
  }
}
function bounds(_this__u8e3s4, rect) {
  return bounds_0(_this__u8e3s4, rect.d26(), rect.f26(), rect.e26(), rect.g26());
}
function bounds_0(_this__u8e3s4, left, top, right, bottom) {
  return size(xy_0(_this__u8e3s4, left, top), right - left, bottom - top);
}
function deferWithViews(_this__u8e3s4, views, tryImmediate, block) {
  views = views === VOID ? null : views;
  tryImmediate = tryImmediate === VOID ? true : tryImmediate;
  if (tryImmediate) {
    var tmp;
    if (views == null) {
      var tmp1_safe_receiver = _this__u8e3s4.o9x();
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.qa0();
    } else {
      tmp = views;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      block(tmp2_safe_receiver);
      return _this__u8e3s4;
    }
  }
  onNextFrame(_this__u8e3s4, deferWithViews$lambda(block));
  return _this__u8e3s4;
}
function onNextFrame(_this__u8e3s4, block) {
  var closeable = {_v: null};
  closeable._v = addUpdaterWithViews(_this__u8e3s4, onNextFrame$lambda(block, closeable));
  return closeable._v;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.d8p_1, $this_addFastUpdater.rak())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.ud9_1, new Duration(Duration__times_impl_sfuzvp(it.wd9(), $this_addUpdaterWithViews.rak())));
    return Unit_instance;
  };
}
function scrollParentsToMakeVisible$lambda(it) {
  return it instanceof UIScrollable;
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return function (it) {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.e8p(), $this_addUpdater.rak())));
    return Unit_instance;
  };
}
function deferWithViews$lambda($block) {
  return function ($this$onNextFrame, it) {
    $block(it);
    return Unit_instance;
  };
}
function onNextFrame$lambda($block, $closeable) {
  return function ($this$addUpdaterWithViews, views, _unused_var__etf5q3) {
    $block($this$addUpdaterWithViews, views);
    var tmp0_safe_receiver = $closeable._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f6();
    }
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.xak();
  }, function (value) {
    return $b0.wak(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.gak();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.c8e_1;
  }, function (value) {
    $b0.c8e_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_23($this, $completion) {
  var tmp = $this.xd9_1.dd3(ensureNotNull(get_views($this.yd9_1)), VOID, $this.zd9_1.yd2_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_24($this, $completion) {
  var tmp = $this.bda_1.cda($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.y9n_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().u82();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.l9o_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.d1(_unary__edvuaz).s1p($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.l9o_1.l3();
  cancel($this.d9n_1);
  $this.j9n_1.h8n();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.o9m(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.l9n_1 == null) ? ensureNotNull(this$0.l9n_1) : StandardPaths_instance.z2y(this$0.dda());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.ud($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.sy();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.c9o_1.e8a();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.c9o_1.v8e();
    return Unit_instance;
  };
}
var Companion_instance_29;
function Companion_getInstance_55() {
  return Companion_instance_29;
}
var Companion_instance_30;
function Companion_getInstance_56() {
  return Companion_instance_30;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.u9n_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.d8p_1 = delta;
  _this__u8e3s4.g6a(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.v9n_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.vd9_1 = delta;
  _this__u8e3s4.g6a(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_26().l2g() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_27().z24() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.j2r(reqVirtualSize_0);
  targetSize.j2r(scaleMode.o2g(virtualSize.u1(), actualSize_0));
  var ratioX = targetSize.u1().v2g_1 / reqVirtualSize_0.v2g_1;
  var ratioY = targetSize.u1().w2g_1 / reqVirtualSize_0.w2g_1;
  var actualVirtualWidth = toIntRound(actualSize_0.v2g_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.w2g_1 / ratioY);
  _this__u8e3s4.e8d(Companion_getInstance_34().g29_1.i2a(ratioX, ratioY).r2a(toIntRound((actualVirtualWidth - reqVirtualSize_0.v2g_1 | 0) * anchor.w24_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.w2g_1 | 0) * anchor.x24_1)));
  _this__u8e3s4.a8d(_this__u8e3s4.f8d().t2a());
  _this__u8e3s4.g8d(_this__u8e3s4.f8d().u2a());
  _this__u8e3s4.c8d(_this__u8e3s4.b8d().u2a());
  var tl = _this__u8e3s4.l8d(Vector2D.j28(0, 0));
  var br = _this__u8e3s4.l8d(Vector2D.w27(actualSize_0.v2g_1, actualSize_0.w2g_1));
  _this__u8e3s4.i8d(Companion_getInstance_33().h2e(tl.m25_1, tl.n25_1, br.m25_1, br.n25_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.j67(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.k8e();
  }, function (value) {
    return $b0.b8n(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.l8n();
  }, function (value) {
    return $b0.k8n(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.m84_1;
  }, function (value) {
    $b0.m84_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.n84_1);
  }, function (value) {
    $b0.n84_1 = value.t4h_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.v8k_1;
  }, function (value) {
    $b0.v8k_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.h9v();
  }, function (receiver, value) {
    return receiver.n9v(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.h9v();
  }, function (receiver, value) {
    return receiver.n9v(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.ida();
  }, function (receiver, value) {
    return receiver.d9v(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.ida();
  }, function (receiver, value) {
    return receiver.d9v(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.jda());
  }, function (receiver, value) {
    return receiver.e9v(value.t4h_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.jda());
  }, function (receiver, value) {
    return receiver.e9v(value.t4h_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.y9o_1;
  }, function (value) {
    $b0.y9o_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.a9p_1;
  }, function (value) {
    $b0.a9p_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.pda();
  }, function (receiver, value) {
    return receiver.vda(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.pda();
  }, function (receiver, value) {
    return receiver.vda(value);
  });
}
function centerOnStage(_this__u8e3s4) {
  return centerYOnStage(centerXOnStage(_this__u8e3s4));
}
function centerXOn(_this__u8e3s4, other) {
  return alignX(_this__u8e3s4, other, 0.5, true);
}
function alignLeftToRightOf(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignX(_this__u8e3s4, other, 1.0, false, padding);
}
function alignTopToTopOf(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignY(_this__u8e3s4, other, 0.0, true, padding);
}
function centerYOnStage(_this__u8e3s4) {
  return centerYOn(_this__u8e3s4, _this__u8e3s4.r23());
}
function centerXOnStage(_this__u8e3s4) {
  return centerXOn(_this__u8e3s4, _this__u8e3s4.r23());
}
function alignX(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, true, padding);
}
function alignY(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, false, padding);
}
function centerYOn(_this__u8e3s4, other) {
  return alignY(_this__u8e3s4, other, 0.5, true);
}
function alignXY(_this__u8e3s4, other, ratio, inside, doX, padding) {
  padding = padding === VOID ? 0.0 : padding;
  var bounds = other.ban(_this__u8e3s4.x23());
  var localBounds = _this__u8e3s4.r9y();
  var ratioM1_1 = ratio * 2 - 1;
  var rratioM1_1 = inside ? ratioM1_1 : -ratioM1_1;
  var iratio = inside ? ratio : 1.0 - ratio;
  if (doX) {
    _this__u8e3s4.tak(bounds.w25_1 + bounds.y25_1 * ratio - localBounds.d26() - _this__u8e3s4.pal() * iratio - padding * rratioM1_1);
  } else {
    _this__u8e3s4.uak(bounds.x25_1 + bounds.z25_1 * ratio - localBounds.f26() - _this__u8e3s4.qal() * iratio - padding * rratioM1_1);
  }
  return _this__u8e3s4;
}
var UB_instance;
function UB_getInstance() {
  if (UB_instance === VOID)
    new UB();
  return UB_instance;
}
var Companion_instance_31;
function Companion_getInstance_57() {
  if (Companion_instance_31 === VOID)
    new Companion_16();
  return Companion_instance_31;
}
function updatedPoints($this) {
  var tmp = $this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var tmp0_iterator = $this.nay_1.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    var tmp_0 = sum;
    // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>' call
    sum = tmp_0 + element.e1() | 0;
  }
  var tmp$ret$1 = sum;
  tmp.pay_1 = new Float32Array(imul(tmp$ret$1, 2));
  var buffer = $this.pay_1;
  var n = 0;
  $this.qay_1.l3();
  $this.ray_1 = Companion_getInstance_32().m26();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.nay_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    var points = this_0.d1(_unary__edvuaz);
    $this.qay_1.h(new Batch(n / 2 | 0, points.e1()));
    if (points.a28() >= 5) {
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable = 0;
      var last = points.e1();
      if (inductionVariable < last)
        do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>.<anonymous>' call
          var x = points.y27(n_1, 0);
          var y = points.y27(n_1, 1);
          var dx = points.y27(n_1, 2);
          var dy = points.y27(n_1, 3);
          var scale = points.y27(n_1, 4);
          var px = x + dx * scale;
          var py = y + dy * scale;
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          buffer[_unary__edvuaz_0] = px;
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          buffer[_unary__edvuaz_1] = py;
          $this.ray_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.ray_1, Vector2D.w27(px, py));
        }
         while (inductionVariable < last);
    } else {
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable_0 = 0;
      var last_0 = points.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n_2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.korge.view.debug.DebugVertexView.updatedPoints.<anonymous>.<anonymous>' call
          var x_0 = points.y27(n_2, 0);
          var y_0 = points.y27(n_2, 1);
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          buffer[_unary__edvuaz_2] = x_0;
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          buffer[_unary__edvuaz_3] = y_0;
          $this.ray_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.ray_1, Vector2D.w27(x_0, y_0));
        }
         while (inductionVariable_0 < last_0);
    }
  }
}
function colorMul$factory($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.r4g());
  }, function (value) {
    return $b0.m4h(value.t4h_1);
  });
}
function u_Col$factory() {
  return getPropertyCallableRef('u_Col', 1, KProperty1, function (receiver) {
    return receiver.cdb();
  }, null);
}
function u_Matrix$factory() {
  return getPropertyCallableRef('u_Matrix', 1, KProperty1, function (receiver) {
    return receiver.ddb();
  }, null);
}
function u_Col$factory_0() {
  return getPropertyCallableRef('u_Col', 1, KProperty1, function (receiver) {
    return receiver.cdb();
  }, null);
}
function u_Matrix$factory_0() {
  return getPropertyCallableRef('u_Matrix', 1, KProperty1, function (receiver) {
    return receiver.ddb();
  }, null);
}
var ColorTransformUB_instance;
function ColorTransformUB_getInstance() {
  if (ColorTransformUB_instance === VOID)
    new ColorTransformUB();
  return ColorTransformUB_instance;
}
var Companion_instance_32;
function Companion_getInstance_58() {
  if (Companion_instance_32 === VOID)
    new Companion_17();
  return Companion_instance_32;
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.ndb();
  }, null);
}
function u_ColorAdd$factory() {
  return getPropertyCallableRef('u_ColorAdd', 1, KProperty1, function (receiver) {
    return receiver.odb();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.ndb();
  }, null);
}
function u_ColorAdd$factory_0() {
  return getPropertyCallableRef('u_ColorAdd', 1, KProperty1, function (receiver) {
    return receiver.odb();
  }, null);
}
var Companion_instance_33;
function Companion_getInstance_59() {
  return Companion_instance_33;
}
function get_renderToTextureResultPool(_this__u8e3s4) {
  _init_properties_Filter_kt__xu8pbc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = renderToTextureResultPool$delegate;
    var property = renderToTextureResultPool$factory();
    var tmp = _this__u8e3s4.by();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.cy_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.dy_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.cy_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.cy_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var renderToTextureResultPool$delegate;
var Companion_instance_34;
function Companion_getInstance_60() {
  if (Companion_instance_34 === VOID)
    new Companion_19();
  return Companion_instance_34;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.i2f(getBorder(_this__u8e3s4, toIntCeil(inp.y25_1), toIntCeil(inp.z25_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.wdc(texWidth, texHeight);
}
function renderToTextureWithBorderUnsafe(_this__u8e3s4, ctx, matrix, texture, texWidth, texHeight, filterScale, result) {
  result = result === VOID ? new RenderToTextureResult() : result;
  _init_properties_Filter_kt__xu8pbc();
  var filter = _this__u8e3s4;
  var margin = getBorder(filter, texWidth, texHeight);
  var borderLeft = toIntCeil(margin.c29_1 * filterScale);
  var borderTop = toIntCeil(margin.z28_1 * filterScale);
  var newTexWidth = texWidth + toIntCeil(margin.w28() * filterScale) | 0;
  var newTexHeight = texHeight + toIntCeil(margin.x28() * filterScale) | 0;
  ctx.c86();
  var fb = ctx.x8e(newTexWidth, newTexHeight);
  result.jdd_1 = borderLeft;
  result.kdd_1 = borderTop;
  result.hdd_1 = newTexWidth;
  result.idd_1 = newTexHeight;
  result.ndd_1 = texture;
  result.gdd_1 = filter;
  result.ldd_1 = filterScale;
  result.mdd_1 = matrix.o2a(-borderLeft | 0, -borderTop | 0);
  result.qdd_1 = ctx;
  result.odd_1 = fb;
  return result;
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.z2p(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.l18();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
function renderToTextureResultPool$factory() {
  return getPropertyCallableRef('renderToTextureResultPool', 1, KProperty1, function (receiver) {
    return get_renderToTextureResultPool(receiver);
  }, null);
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_35;
function Companion_getInstance_61() {
  if (Companion_instance_35 === VOID)
    new Companion_20();
  return Companion_instance_35;
}
var Companion_instance_36;
function Companion_getInstance_62() {
  if (Companion_instance_36 === VOID)
    new Companion_21();
  return Companion_instance_36;
}
function _get__program__9g4ap2($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.zdb_1;
  _program$factory();
  return this_0.u1();
}
function ShaderFilter$BaseProgramProvider$_program$delegate$lambda(this$0) {
  return function () {
    return this$0.adc(this$0.bdc(), this$0.wdb());
  };
}
var TexInfoUB_instance;
function TexInfoUB_getInstance() {
  if (TexInfoUB_instance === VOID)
    new TexInfoUB();
  return TexInfoUB_instance;
}
var Companion_instance_37;
function Companion_getInstance_63() {
  if (Companion_instance_37 === VOID)
    new Companion_22();
  return Companion_instance_37;
}
function _restoreUniforms($this, ctx, filterScale) {
  // Inline function 'korlibs.memory.fastForEachOneBits' call
  var value = $this.udc_1;
  var index = 0;
  while (!(value === 0)) {
    var shift = countTrailingZeroBits(value);
    index = index + shift | 0;
    if (index < 32) {
      // Inline function 'korlibs.korge.view.filter.ShaderFilter._restoreUniforms.<anonymous>' call
      var it = index;
      ctx.z83_1.w6m($this.tdc_1, it);
      $this.tdc_1.y6m(it, null);
    }
    value = value >>> (shift + 1 | 0) | 0;
    index = index + 1 | 0;
  }
  $this.udc_1 = 0;
}
function _updateUniforms($this, ctx, filterScale, texture, texWidth, texHeight) {
  $this.pdc_1 = Vector2D.q2a(texture.o3f_1.z2i(), texture.o3f_1.a2j());
  $this.rdc_1 = Vector2D.q2a(1.0 / texture.o3f_1.z2i(), 1.0 / texture.o3f_1.a2j());
  $this.qdc_1 = Vector2D.q2a(texWidth / texture.o3f_1.z2i(), texHeight / texture.o3f_1.a2j());
  $l$block: {
    // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
    var this_0 = ctx.n6q(TexInfoUB_getInstance());
    var _unary__edvuaz = this_0.c6s();
    this_0.f7f(_unary__edvuaz + 1 | 0);
    this_0.g7f(this_0.c6s() + 1 | 0);
    var blockSize = this_0.g6q_1;
    var index0 = imul(this_0.c6s() - 1 | 0, blockSize);
    var index1 = imul(this_0.c6s(), blockSize);
    var texBlockSize = this_0.d6q_1.c6y().e1();
    var texIndex0 = imul(this_0.c6s() - 1 | 0, texBlockSize);
    var texIndex1 = imul(this_0.c6s(), texBlockSize);
    if (this_0.c6s() > 0) {
      arraycopy(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
    } else {
      arrayfill(this_0.i6q_1, 0, 0, blockSize);
    }
    // Inline function 'korlibs.korge.view.filter.ShaderFilter._updateUniforms.<anonymous>' call
    var $this$push = this_0.d6q_1;
    var it = this_0.j6q_1;
    it.k7f($this$push.fde(), filterScale);
    it.o7f($this$push.cde(), $this.pdc_1);
    it.o7f($this$push.dde(), $this.qdc_1);
    it.o7f($this$push.ede(), $this.rdc_1);
    if (true && this_0.c6s() >= 1) {
      var equals = arrayequal(this_0.i6q_1, index0, this_0.i6q_1, index1, blockSize);
      if (equals) {
        var _unary__edvuaz_0 = this_0.c6s();
        this_0.f7f(_unary__edvuaz_0 - 1 | 0);
        break $l$block;
      }
    }
  }
  $this.ndc(ctx, filterScale);
}
function u_TextureSize$factory() {
  return getPropertyCallableRef('u_TextureSize', 1, KProperty1, function (receiver) {
    return receiver.cde();
  }, null);
}
function u_MaxTexCoords$factory() {
  return getPropertyCallableRef('u_MaxTexCoords', 1, KProperty1, function (receiver) {
    return receiver.dde();
  }, null);
}
function u_StdTexDerivates$factory() {
  return getPropertyCallableRef('u_StdTexDerivates', 1, KProperty1, function (receiver) {
    return receiver.ede();
  }, null);
}
function u_filterScale$factory() {
  return getPropertyCallableRef('u_filterScale', 1, KProperty1, function (receiver) {
    return receiver.fde();
  }, null);
}
function u_TextureSize$factory_0() {
  return getPropertyCallableRef('u_TextureSize', 1, KProperty1, function (receiver) {
    return receiver.cde();
  }, null);
}
function u_MaxTexCoords$factory_0() {
  return getPropertyCallableRef('u_MaxTexCoords', 1, KProperty1, function (receiver) {
    return receiver.dde();
  }, null);
}
function u_StdTexDerivates$factory_0() {
  return getPropertyCallableRef('u_StdTexDerivates', 1, KProperty1, function (receiver) {
    return receiver.ede();
  }, null);
}
function u_filterScale$factory_0() {
  return getPropertyCallableRef('u_filterScale', 1, KProperty1, function (receiver) {
    return receiver.fde();
  }, null);
}
function _program$factory() {
  return getPropertyCallableRef('_program', 1, KProperty1, function (receiver) {
    return _get__program__9g4ap2(receiver);
  }, null);
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.m9r_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.hde_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.gy_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.ey_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.ey_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.fy_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.ey_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.r9y(VOID, false);
  if (bounds.y25_1 <= 0.0 || bounds.z25_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_60();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.ydc();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.tdd(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.y25_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.z25_1 * tryFilterScale), 1);
  var realFilterScale = clamp_1(texWidthNoBorder / bounds.y25_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.w25_1 + edgeSize;
  var addy = -bounds.x25_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.c86();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.x8e(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.z8e(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.o84_1;
      var this_1 = this_0.x84_1;
      if (!(this_1.s84_1 === this_0)) {
        this_1.s84_1 = this_0;
        this_1.c86();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.b6u(0, 0, rb.a6j_1, rb.b6j_1);
        var temp = this_0.v85_1;
        this_0.e8c();
        this_0.v85_1 = scissor;
        try {
          if (true) {
            ctx.s8e(Colors_getInstance().j41_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.xal().m2a(addx, addy).h2a(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.o84_1.x84_1;
          this_2.c86();
          var temp4 = this_2.d84_1;
          var temp2d = this_2.e84_1;
          this_2.e84_1 = mat;
          this_2.d84_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.n6q(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.c6s();
            this_3.f7f(_unary__edvuaz + 1 | 0);
            this_3.g7f(this_3.c6s() + 1 | 0);
            var blockSize = this_3.g6q_1;
            var index0 = imul(this_3.c6s() - 1 | 0, blockSize);
            var index1 = imul(this_3.c6s(), blockSize);
            var texBlockSize = this_3.d6q_1.c6y().e1();
            var texIndex0 = imul(this_3.c6s() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.c6s(), texBlockSize);
            if (this_3.c6s() > 0) {
              arraycopy(this_3.i6q_1, index0, this_3.i6q_1, index1, blockSize);
            } else {
              arrayfill(this_3.i6q_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.d6q_1;
            this_3.j6q_1.v7f($this$push.b6y(), this_2.d84_1);
            if (true && this_3.c6s() >= 1) {
              var equals = arrayequal(this_3.i6q_1, index0, this_3.i6q_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.c6s();
                this_3.f7f(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.ham(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.iam(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.c86();
            this_2.d84_1 = temp4;
            this_2.e84_1 = temp2d;
            this_2.n6q(ProjViewUB_getInstance()).h7f();
          }
          break $l$block_0;
        }finally {
          this_0.e8c();
          this_0.v85_1 = temp;
        }
      }
    }finally {
      ctx.a8f();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).f3h(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.t9y().r2a(-addx, -addy).j2a(1.0 / realFilterScale);
    filter.xdc(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.aam(), _this__u8e3s4.g9q_1, realFilterScale);
    ctx.c86();
  }finally {
    ctx.y8e(rb);
  }
}
function set_filter(_this__u8e3s4, value) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var enabled = !(value == null);
  if (enabled) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase' call
      // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
      var tmp0_safe_receiver = _this__u8e3s4.m9r_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp0_safe_receiver.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
            if (element instanceof ViewRenderPhaseFilter) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp = tmp$ret$1;
      }
      var tmp_0 = tmp;
      var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp$ret$3 = tmp0_safe_receiver_0;
        break $l$block_0;
      }
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.filter.<set-filter>.<anonymous>' call
      var this_0 = new ViewRenderPhaseFilter(value);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase.<anonymous>' call
      _this__u8e3s4.gam(this_0);
      tmp$ret$3 = this_0;
    }
    tmp$ret$3.ide_1 = value;
  } else {
    // Inline function 'korlibs.korge.view.View.removeRenderPhaseOfType' call
    var tmp0_safe_receiver_1 = _this__u8e3s4.m9r_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      removeAll(tmp0_safe_receiver_1, _set_filter_$lambda_rgmh04);
    }
  }
  _this__u8e3s4.oaj();
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.m9r_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ide_1;
}
var Companion_instance_38;
function Companion_getInstance_64() {
  return Companion_instance_38;
}
function addFilter(_this__u8e3s4, filter) {
  _init_properties_ViewFilter_kt__pd9xp9();
  set_filter(_this__u8e3s4, Companion_instance_33.zdc(get_filter(_this__u8e3s4), filter));
  return _this__u8e3s4;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_60().tdd(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function _set_filter_$lambda_rgmh04(it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return it instanceof ViewRenderPhaseFilter;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.gy_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.sd1_1 ? $this.dd2_1 : $this.cd2_1;
  if (!valid) {
    if ($this.sd1_1)
      $this.dd2_1 = true;
    else
      $this.cd2_1 = true;
    var result = $this.ad2_1.n62($this.sd1_1);
    if ($this.sd1_1)
      $this.gd2_1 = result;
    else
      $this.fd2_1 = result;
    return result;
  }
  return $this.sd1_1 ? $this.gd2_1 : $this.fd2_1;
}
function invalidateShape($this) {
  $this.ed2_1 = 0;
  $this.bd2_1 = false;
  $this.cd2_1 = false;
  $this.dd2_1 = false;
  $this.e9x();
}
function requireShape($this) {
  if ($this.bd2_1)
    return Unit_instance;
  $this.bd2_1 = true;
  $this.td1_1.l3();
  $this.td1_1.ude();
  $this.td1_1.vde(Companion_getInstance_16().t6k_1);
  $this.hd2_1 = true;
  renderShape($this, $this.ad2_1);
  $this.td1_1.j6j();
  $this.jd2_1 = $this.id2_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.t9y().u29(get_immutable(ctx.r83_1.f8d())) : $this.t9y();
  $this.kd2_1 = mat.p2a(-$this.hak(), -$this.iak());
  requireShape($this);
  $this.td1_1.wde(ctx, $this.kd2_1, $this.wal(), $this.xd1_1, $this.aam(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.a63_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var v = _iterator__ex2g4s.c1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.t63());
      } else {
        if (shape instanceof FillShape) {
          $this.ed2_1 = $this.ed2_1 + 1 | 0;
          if ($this.ed2_1 > $this.ld2_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.ed2_1 = $this.ed2_1 + 1 | 0;
            if ($this.ed2_1 > $this.ld2_1)
              return Unit_instance;
            renderStroke$default($this, shape.f63_1, shape.c63_1, shape.e63_1, shape.h63_1, shape.g63_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.td('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.td1_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.vde(Companion_getInstance_16().t6k_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.d1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.xde();
    var vector = points.q38();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.e1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.y27(n_0, 0);
        var y = vector.y27(n_0, 1);
        var dx = vector.y27(n_0, 2);
        var dy = vector.y27(n_0, 3);
        var len = vector.y27(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.y27(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.yde(px, py, $this.zd1_1 ? len : 0.0, $this.zd1_1 ? maxLen : $this.nd2_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.zde();
    var info = GpuShapeViewPrograms_getInstance().sdf(stateTransform, paint, globalAlpha, strokeInfo.z37_1);
    var tmp0_drawType = Companion_getInstance_14().z6s_1;
    var tmp1_blendMode = Companion_getInstance_13().v82_1;
    gpuShapeViewCommands.tdf(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_19().h6k_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_20().f6k_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.e1() < 3)
    return null;
  var vertexStart = $this.td1_1.xde();
  var bb = BoundsBuilder__plus_impl_cz7f7x_1(Companion_getInstance_32().m26(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.w27(xMid, yMid);
  var isStrip = type === Companion_getInstance_14().z6s_1;
  var antialiased = $this.zd1_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.td1_1.yde(xMid, yMid, 0.0, $this.nd2_1);
  }
  var inductionVariable = 0;
  var last = points.e1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.d1(n % points.e1() | 0);
      var x = p.jl();
      var y = p.kl();
      var len = isStripAndAntialiased ? Companion_getInstance_29().d2h(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.nd2_1;
      if (isStrip) {
        $this.td1_1.yde(xMid, yMid, 0.0, maxLen);
      }
      $this.td1_1.yde(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.td1_1.zde();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.e1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.h1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().sdf(shape.r62_1, shape.q62_1, shape.s62_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.md2_1;
  var drawAntialiasingBorder = $this.md2_1 ? true : $this.zd1_1;
  var shapeIsConvex = shape.y62();
  var isSimpleDraw = shapeIsConvex && shape.p62_1 == null && !$this.md2_1;
  var pathDataList = getPointsForPathList($this, shape.o62_1, isSimpleDraw ? Companion_getInstance_14().z6s_1 : Companion_getInstance_14().a6t_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_32().m26();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.d1(_unary__edvuaz);
    bb = plus_1(bb, it.udf_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.i2f(MarginInt.e29(2)));
  var clipDataStart = $this.td1_1.xde();
  var tmp1_safe_receiver = shape.p62_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_14().a6t_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.td1_1.zde();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.udf_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_16().t6k_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.hd2_1) {
    $this.hd2_1 = true;
    $this.td1_1.vde(isSimpleDraw ? Companion_getInstance_16().t6k_1 : !clipBounds.equals(Companion_getInstance_16().t6k_1) ? Companion_getInstance_16().g6u(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.hd2_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.e1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.d1(_unary__edvuaz_0);
      var tmp0_$this = $this.td1_1;
      var tmp1_drawType = Companion_getInstance_14().z6s_1;
      var tmp2_startIndex = pathData.wdf_1;
      var tmp3_endIndex = pathData.xdf_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.zal();
      tmp0_$this.tdf(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.o62_1.v3d_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_21().a6v_1;
  if (drawFill) {
    switch (winding.r3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_21().a6v_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().h6k_1, true), Companion_getInstance_21().z6u_1), Companion_getInstance_22().l6v_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_20().f6k_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.d1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.wdf_1, pathData_0.xdf_1, stencilOpFunc, stencilRef, Companion_getInstance_23().v6k_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_21().g6v_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().h6k_1, true), Companion_getInstance_21().z6u_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_20().f6k_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.d1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.wdf_1, pathData_1.xdf_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_22().k6v_1, Companion_getInstance_22().i6v_1), stencilRef_0, Companion_getInstance_23().v6k_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().h6k_1, true), Companion_getInstance_21().g6v_1), Companion_getInstance_22().l6v_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_20().f6k_1, 0), 255), Companion_getInstance_23().w6k_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().h6k_1, true), Companion_getInstance_21().z6u_1), Companion_getInstance_22().l6v_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_20().f6k_1, 2), Companion_getInstance_23().y6k_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.p62_1 == null) {
    renderStroke($this, shape.r62_1, shape.o62_1, shape.q62_1, shape.s62_1, new StrokeInfo(1.6 / $this.id2_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_19().h6k_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().h6k_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_20().f6k_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.td1_1.t79(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.td1_1;
  var tmp1_drawType = Companion_getInstance_14().a6t_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().rdf_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().x82_1;
  tmp0_$this.ydf(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.td1_1.xde();
  var x0 = pathBounds.d26();
  var y0 = pathBounds.f26();
  var x1 = pathBounds.e26();
  var y1 = pathBounds.g26();
  $this.td1_1.yde(x0, y0, 0.0, $this.nd2_1);
  $this.td1_1.yde(x1, y0, 0.0, $this.nd2_1);
  $this.td1_1.yde(x1, y1, 0.0, $this.nd2_1);
  $this.td1_1.yde(x0, y1, 0.0, $this.nd2_1);
  var vend = $this.td1_1.zde();
  var tmp0_$this = $this.td1_1;
  var tmp1_drawType = Companion_getInstance_14().a6t_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_19().h6k_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_20().f6k_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.zal();
  tmp0_$this.tdf(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.q70(), GpuShapeViewPrograms_getInstance().ddh());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.q70(), $this$IF_ELSE_LIST.y70($$this$FragmentShaderDefault.x70(), $this$IF_ELSE_LIST.i72($this$IF_ELSE_LIST.k72([$this$IF_ELSE_LIST.w70($this$IF_ELSE_LIST.r70(GpuShapeViewPrograms_getInstance().fdh(), $this$IF_ELSE_LIST.u70([$$this$FragmentShaderDefault.j70(), $this$IF_ELSE_LIST.t70(0.0), $this$IF_ELSE_LIST.t70(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.q70(), $this$IF_ELSE_LIST.y70($$this$FragmentShaderDefault.x70(), $this$IF_ELSE_LIST.w70($this$IF_ELSE_LIST.r70(GpuShapeViewPrograms_getInstance().fdh(), $this$IF_ELSE_LIST.u70([$this$IF_ELSE_LIST.l72($$this$FragmentShaderDefault.j70()), $this$IF_ELSE_LIST.m72($$this$FragmentShaderDefault.j70()), $this$IF_ELSE_LIST.t70(0.0), $this$IF_ELSE_LIST.t70(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.c72(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.w70(rpoint, 'xy'), $this$IF_ELSE_LIST.w70($this$IF_ELSE_LIST.r70(GpuShapeViewPrograms_getInstance().fdh(), $this$IF_ELSE_LIST.u70([$this$IF_ELSE_LIST.l72($$this$FragmentShaderDefault.j70()), $this$IF_ELSE_LIST.m72($$this$FragmentShaderDefault.j70()), $this$IF_ELSE_LIST.t70(0.0), $this$IF_ELSE_LIST.t70(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.l72(rpoint);
        var y = $this$IF_ELSE_LIST.m72(rpoint);
        var x0 = $this$IF_ELSE_LIST.l72(GpuShapeViewPrograms_getInstance().gdh());
        var y0 = $this$IF_ELSE_LIST.m72(GpuShapeViewPrograms_getInstance().gdh());
        var r0 = $this$IF_ELSE_LIST.n72(GpuShapeViewPrograms_getInstance().gdh());
        var x1 = $this$IF_ELSE_LIST.l72(GpuShapeViewPrograms_getInstance().hdh());
        var y1 = $this$IF_ELSE_LIST.m72(GpuShapeViewPrograms_getInstance().hdh());
        var r1 = $this$IF_ELSE_LIST.n72(GpuShapeViewPrograms_getInstance().hdh());
        var ratio = $this$IF_ELSE_LIST.l72($$this$FragmentShaderDefault.b71());
        var r0r1_2 = $this$IF_ELSE_LIST.m72($$this$FragmentShaderDefault.b71());
        var r0pow2 = $this$IF_ELSE_LIST.n72($$this$FragmentShaderDefault.b71());
        var r1pow2 = $this$IF_ELSE_LIST.o72($$this$FragmentShaderDefault.b71());
        var y0_y1 = $this$IF_ELSE_LIST.l72($$this$FragmentShaderDefault.c73());
        var x0_x1 = $this$IF_ELSE_LIST.m72($$this$FragmentShaderDefault.c73());
        var r0_r1 = $this$IF_ELSE_LIST.n72($$this$FragmentShaderDefault.c73());
        var radial_scale = $this$IF_ELSE_LIST.o72($$this$FragmentShaderDefault.c73());
        $this$IF_ELSE_LIST.n70(r0r1_2, $this$IF_ELSE_LIST.r70($this$IF_ELSE_LIST.r70($this$IF_ELSE_LIST.t70(2.0), r0), r1));
        $this$IF_ELSE_LIST.n70(r0pow2, GpuShapeViewPrograms_getInstance().idh(r0));
        $this$IF_ELSE_LIST.n70(r1pow2, GpuShapeViewPrograms_getInstance().idh(r1));
        $this$IF_ELSE_LIST.n70(x0_x1, $this$IF_ELSE_LIST.q72(x0, x1));
        $this$IF_ELSE_LIST.n70(y0_y1, $this$IF_ELSE_LIST.q72(y0, y1));
        $this$IF_ELSE_LIST.n70(r0_r1, $this$IF_ELSE_LIST.q72(r0, r1));
        $this$IF_ELSE_LIST.n70(radial_scale, $this$IF_ELSE_LIST.c71($this$IF_ELSE_LIST.t70(1.0), $this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.q72(GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(r0, r1)), GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(x0, x1))), GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(y0, y1)))));
        $this$IF_ELSE_LIST.n70(ratio, $this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.t70(1.0), $this$IF_ELSE_LIST.r70($this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.s72($this$IF_ELSE_LIST.s72($this$IF_ELSE_LIST.r70($this$IF_ELSE_LIST.p72(r1), r0_r1), $this$IF_ELSE_LIST.r70(x0_x1, $this$IF_ELSE_LIST.q72(x1, x))), $this$IF_ELSE_LIST.r70(y0_y1, $this$IF_ELSE_LIST.q72(y1, y))), $this$IF_ELSE_LIST.g72($this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.s72($this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.r70(r1pow2, $this$IF_ELSE_LIST.s72(GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(x0, x)), GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(y0, y)))), $this$IF_ELSE_LIST.r70(r0r1_2, $this$IF_ELSE_LIST.s72($this$IF_ELSE_LIST.r70($this$IF_ELSE_LIST.q72(x0, x), $this$IF_ELSE_LIST.q72(x1, x)), $this$IF_ELSE_LIST.r70($this$IF_ELSE_LIST.q72(y0, y), $this$IF_ELSE_LIST.q72(y1, y))))), $this$IF_ELSE_LIST.r70(r0pow2, $this$IF_ELSE_LIST.s72(GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(x1, x)), GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72(y1, y))))), GpuShapeViewPrograms_getInstance().idh($this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.s72($this$IF_ELSE_LIST.s72($this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.q72($this$IF_ELSE_LIST.r70(x1, y0), $this$IF_ELSE_LIST.r70(x, y0)), $this$IF_ELSE_LIST.r70(x0, y1)), $this$IF_ELSE_LIST.r70(x, y1)), $this$IF_ELSE_LIST.r70(x0, y)), $this$IF_ELSE_LIST.r70(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.q70(), $this$IF_ELSE_LIST.y70($$this$FragmentShaderDefault.x70(), $this$IF_ELSE_LIST.k72([ratio, $this$IF_ELSE_LIST.t70(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.c72(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.w70(rpoint_0, 'xy'), $this$IF_ELSE_LIST.w70($this$IF_ELSE_LIST.r70(GpuShapeViewPrograms_getInstance().fdh(), $this$IF_ELSE_LIST.u70([$this$IF_ELSE_LIST.l72($$this$FragmentShaderDefault.j70()), $this$IF_ELSE_LIST.m72($$this$FragmentShaderDefault.j70()), $this$IF_ELSE_LIST.t70(0.0), $this$IF_ELSE_LIST.t70(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.l72(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.m72(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.l72($$this$FragmentShaderDefault.b71());
        var angle = $this$IF_ELSE_LIST.m72($$this$FragmentShaderDefault.b71());
        var x0_0 = $this$IF_ELSE_LIST.l72(GpuShapeViewPrograms_getInstance().gdh());
        var y0_0 = $this$IF_ELSE_LIST.m72(GpuShapeViewPrograms_getInstance().gdh());
        var PI2 = $this$IF_ELSE_LIST.t70(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.n70(angle, $this$IF_ELSE_LIST.e72($this$IF_ELSE_LIST.q72(y_0, y0_0), $this$IF_ELSE_LIST.q72(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.w72(angle, $this$IF_ELSE_LIST.t70(0.0));
        var body = $this$IF_ELSE_LIST.e71();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.n70(angle, body.s72(angle, PI2));
        var stmIf = new If(cond, body.g71());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.m70_1.h(stmIf);
        $this$IF_ELSE_LIST.n70(ratio_0, $this$IF_ELSE_LIST.c71(angle, PI2));
        $this$IF_ELSE_LIST.n70($this$IF_ELSE_LIST.q70(), $this$IF_ELSE_LIST.y70($$this$FragmentShaderDefault.x70(), $this$IF_ELSE_LIST.i72($this$IF_ELSE_LIST.k72([ratio_0, $this$IF_ELSE_LIST.t70(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.cdh();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.ddh();
  }, null);
}
function u_ColorMul$factory_1() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.ndb();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.edh();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.bdh();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.fdh();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.gdh();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.hdh();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.cdh();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.ddh();
  }, null);
}
function u_ColorMul$factory_2() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.ndb();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.edh();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.bdh();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.fdh();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.gdh();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.hdh();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(RootAnimationNode, 'RootAnimationNode');
initMetadataForClass(TweenNode, 'TweenNode');
initMetadataForClass(BlockNode, 'BlockNode');
initMetadataForClass(Animator, 'Animator', VOID, VOID, [CloseableCancellable], [1]);
initMetadataForClass(ViewStageComponent, 'ViewStageComponent');
initMetadataForLambda(KeysEvents$down$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$down$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$up$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$typed$slambda, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForClass(TouchEvents, 'TouchEvents');
initMetadataForClass(SingleTouchHandler, 'SingleTouchHandler', SingleTouchHandler);
initMetadataForClass(singleTouch$SingleTouchInfo, 'SingleTouchInfo');
initMetadataForObject(MaterialBlockUB, 'MaterialBlockUB');
initMetadataForObject(MaterialRender, 'MaterialRender');
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_3);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.ycn);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.ba7);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.zcn);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.tch);
initMetadataForClass(UIView, 'UIView', UIView.kag);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.lag);
protoOf(Transition$1).gan = start;
protoOf(Transition$1).han = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForClass(ViewStyles, 'ViewStyles');
initMetadataForClass(ViewStyle, 'ViewStyle');
initMetadataForInterface(StyleableView, 'StyleableView');
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TextSnapshot, 'TextSnapshot');
initMetadataForLambda(TextEditController$slambda, VOID, VOID, [1]);
initMetadataForLambda(TextEditController$slambda_0, VOID, VOID, [1]);
initMetadataForInterface(UIFocusable, 'UIFocusable');
initMetadataForClass(TextEditController, 'TextEditController', VOID, VOID, [AutoCloseable, UIFocusable, ISoftKeyboardConfig]);
initMetadataForClass(TimerComponents, 'TimerComponents', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(TimerRef, 'TimerRef');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_4);
initMetadataForLambda(UIButton$slambda, VOID, VOID, [1]);
initMetadataForLambda(UIButton$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(UIButton$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(UIButton$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(UIButton$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(UIButton$slambda_2, VOID, VOID, [1]);
initMetadataForClass(UIFocusableView, 'UIFocusableView', UIFocusableView.sbb, VOID, [UIView, UIFocusable]);
initMetadataForClass(UIButton, 'UIButton', UIButton.rbb);
initMetadataForClass(UIBaseContainer, 'UIBaseContainer');
initMetadataForClass(UIContainer, 'UIContainer');
initMetadataForClass(UIVerticalHorizontalStack, 'UIVerticalHorizontalStack');
initMetadataForClass(UIVerticalStack, 'UIVerticalStack', UIVerticalStack.ubq);
initMetadataForClass(UIHorizontalVerticalFill, 'UIHorizontalVerticalFill');
initMetadataForClass(UIVerticalFill, 'UIVerticalFill', UIVerticalFill.rbw);
initMetadataForObject(Scope, 'Scope');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(UIFocusManager, 'UIFocusManager');
initMetadataForClass(Highlight, 'Highlight');
initMetadataForClass(Highlights, 'Highlights');
initMetadataForClass(UIMaterialLayer, 'UIMaterialLayer', UIMaterialLayer.tbb);
initMetadataForClass(UIScrollable, 'UIScrollable');
initMetadataForInterface(ViewRenderer, 'ViewRenderer');
initMetadataForClass(sam$korlibs_korge_view_ViewRenderer$0, 'sam$korlibs_korge_view_ViewRenderer$0', VOID, VOID, [ViewRenderer, FunctionAdapter]);
initMetadataForClass(UITextInput, 'UITextInput', UITextInput.qc7, VOID, [UIView, ISoftKeyboardConfig]);
initMetadataForClass(sam$korlibs_korge_view_ViewRenderer$0_0, 'sam$korlibs_korge_view_ViewRenderer$0', VOID, VOID, [ViewRenderer, FunctionAdapter]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.ncu);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.rcq);
initMetadataForClass(ClipContainer, 'ClipContainer', ClipContainer.dca);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [Collection, MutableIterable, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.kcu);
initMetadataForClass(CustomContextRenderizableView, 'CustomContextRenderizableView');
initMetadataForClass(DummyView, 'DummyView', DummyView.pcw);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SContainer, 'SContainer', SContainer.pa9);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.rd2);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).dd3 = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForClass(RenderableView, 'RenderableView');
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Sprite, 'Sprite', Sprite.ud8);
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(SpriteAnimation, 'SpriteAnimation', VOID, VOID, [Collection]);
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_11);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForInterface(IText, 'IText');
initMetadataForClass(Text, 'Text', VOID, VOID, [Container, IText], [2]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(TextBlock, 'TextBlock', TextBlock.fbf);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_13);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).dd3 = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_15);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForObject(UB, 'UB');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Batch, 'Batch');
initMetadataForClass(DebugVertexView, 'DebugVertexView');
initMetadataForObject(ColorTransformUB, 'ColorTransformUB');
initMetadataForClass(BaseProgramProvider, 'BaseProgramProvider', BaseProgramProvider);
initMetadataForCompanion(Companion_17);
initMetadataForInterface(Filter, 'Filter');
protoOf(ShaderFilter).ydc = get_recommendedFilterScale;
initMetadataForClass(ShaderFilter, 'ShaderFilter', VOID, VOID, [Filter]);
initMetadataForClass(ColorTransformFilter, 'ColorTransformFilter');
initMetadataForCompanion(Companion_18);
initMetadataForClass(ComposedFilter, 'ComposedFilter', ComposedFilter.edd, VOID, [Filter]);
initMetadataForCompanion(Companion_19);
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).ydc = get_recommendedFilterScale;
protoOf(IdentityFilter).wdc = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_20);
initMetadataForCompanion(Companion_21);
initMetadataForObject(TexInfoUB, 'TexInfoUB');
initMetadataForCompanion(Companion_22);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForCompanion(Companion_23);
protoOf(ViewRenderPhaseFilter).pd9 = beforeRender;
protoOf(ViewRenderPhaseFilter).qd9 = afterRender;
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', ViewRenderPhaseFilter, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.od2);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_17 = new Companion_2();
Scope_instance = new Scope();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
Companion_instance_26 = new Companion_11();
Companion_instance_28 = new Companion_13();
Companion_instance_29 = new Companion_14();
Companion_instance_30 = new Companion_15();
Companion_instance_33 = new Companion_18();
Companion_instance_38 = new Companion_23();
//endregion
//region block: exports
export {
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_45 as Companion_getInstancequ1o8fwft10r,
  Companion_instance_26 as Companion_instance1qzytx5vkv693,
  MouseEvents as MouseEvents19mapgq8ez76g,
  get_mouse as get_mouse1jstwhfaumelj,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  UIButton as UIButton259u54yn72ttw,
  UITextInput as UITextInput3hf6kt3o0p9up,
  UIVerticalFill as UIVerticalFillcra9r5nmzb6d,
  UIVerticalStack as UIVerticalStack2gichhwk4pg3x,
  alignLeftToRightOf as alignLeftToRightOf25wtg1v682ku8,
  alignTopToTopOf as alignTopToTopOf1pzlngle4qef6,
  centerOnStage as centerOnStage1tf2oda60yrak,
  centerXOn as centerXOn3acn3bw226nj3,
  ColorTransformFilter as ColorTransformFilter1faqlnyd4nsx3,
  addFilter as addFilter3artfhx3aolvq,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  SolidRect as SolidRect131p7hyzlx7j8,
  SpriteAnimation as SpriteAnimationagta0d6ji85w,
  Sprite as Sprite19oods84ct31j,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  get_centered as get_centeredilxldnbf7ma6,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  position as positionu6441b7hkb4l,
  rotation as rotation29g98bv3f78wn,
  setText as setText209z1w9h7o9hy,
  size_0 as size3ul8wgwwt88hf,
  xy_0 as xy1gb51vhy014mx,
};
//endregion
